<template>
  <div class="content public-content-Dialog">
    <div class="left-content" :style="{width: showRight ? '54%':'100%'}">
      <div v-if="routeEntry != 5 && routeEntry != 7">
        <el-tabs v-model="activeName">
          <el-tab-pane label="录入列表" name="first"> </el-tab-pane>
          <el-tab-pane label="添加术语" name="second"> </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="activeName == 'first' && !choseFillInfo" style="height:calc(100% - 90px);margin-top:20px;">
        <el-scrollbar class="scrollbar-form" style="height: 100%;font-size: 12px" v-if="fillInfo">
          <div class="header">
            <p></p>
            <h1>基础信息</h1>
          </div>
          <!-- :rules="previewPicturesUrl ? rules : noPicRules" -->
          <el-form ref="formRef" :model="form" :rules="formRules" label-width="130px" style="padding-right:10px">
            <el-form-item label="患者：">
              <div style="display:flex;width:100%;">
                <div style="width:30%">{{ form.patientName }}</div>
                <div style="width:30%">年龄：{{ form.age }}岁</div>
                <div>性别：{{ form.sex === null ? "" : sexObj[form.sex] }}</div>
              </div>
            </el-form-item>

            <el-form-item label="归属：">
              <span v-if="editBack">
                <el-radio-group
                  v-model="form.itemBelong"
                  @change="val => {changeItemBelong(val, 1)}">
                  <el-radio :label="1">本人</el-radio>
                  <el-radio v-if="kinsFolkForm && kinsFolkForm.name" :label="2">亲属({{ kinsFolkForm.name }})</el-radio>
                </el-radio-group>
                <el-button v-if="!kinsFolkForm" type="primary" size="mini" slot="reference" style="margin-left:20px" @click="addKinsFolk">+ 新增亲属</el-button>
              </span>
              <span v-else>{{ form.itemBelong == 1 ? "本人" : kinsFolkForm.name + "(亲属)" }}</span>
              <div class="kins-folk-info">
                <KinsfolkInfo v-if="showKinsPop" :showKinsPop.sync="showKinsPop" @recieveRelative="recieveRelative"></KinsfolkInfo>
              </div>
            </el-form-item>
            <!-- </el-form> -->

            <!-- 病程记录 -->
            <div class="header" v-if="editBack">
              <p></p>
              <div class="disease-record-row">
                <span class="disease-record">病程记录</span>
                <el-form-item
                  label="关联病程"
                  prop="archivesEventName">
                  <el-select
                    v-if="editBack"
                    v-model="form.archivesEventId"
                    value-key="id"
                    size="small"
                    placeholder="请选择关联病程"
                    @change="clickArchivesEventChange"
                  >
                    <el-option
                      v-for="(item, index) in archivesIdarr"
                      :key="index"
                      :label="`${item.eventDate} ${item.eventName}`"
                      :value="item.id">
                      <span>{{ item.eventDate }}</span>
                      <span style="display:inline-block;margin-left:25px">{{
                        item.eventName
                      }}</span>
                    </el-option>
                  </el-select>
                  <span v-else>{{ form.archivesEventName }}</span>
                </el-form-item>
                <el-button type="primary" size="mini" slot="reference" style="margin-left:20px;height:34px" @click="addNewCourse">新建病程</el-button>
              </div>
            </div>
            <div>
              <div v-if="selectArchivesEvent.id" class="disease-record-card">
                <span class="record-time">{{selectArchivesEvent.eventDate}} {{selectArchivesEvent.eventName}}</span>
                <div class="depart-hos">
                  <p>
                    <span>{{selectArchivesEvent.hospital}}</span>
                    <span style="display:inline-block;margin-left:10px">{{selectArchivesEvent.departmentName}}</span>
                  </p>
                  <span v-if="selectArchivesEvent.diseaseName" style="display:inline-block;margin-top:10px">{{selectArchivesEvent.diseaseName}}</span>
                </div>
                <el-button v-if="editBack" class="record-btn" type="text" size="small" @click="editDiseaseRecord">编辑</el-button>
              </div>
              <!-- 新建病程 -->
              <NewCourse v-if="showNewCourse" :key="newCourseTime" :showNewCourse="showNewCourse" :selectArchivesEvent="selectArchivesEvent" :basicOcrObj="basicOcrObj" :ocrTime="ocrTime" :kinsFolkForm="kinsFolkForm" :itemBelong="form.itemBelong" @closeNewCourse="closeNewCourse" @searchArchivesEvent="searchArchivesEvent"/>
            </div>
            <!-- <div class="course-disease-time">
              <span>病程时间：</span>
              <el-date-picker size="mini" style="width:290px" v-model="courseTime" type="daterange" :clearable="false" @change="searchArchivesEvent" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
            </div>
            <div v-if="archivesEventData && archivesEventData.length" style="width:100%;">
              <el-scrollbar class="event-list-scrollbar" style="width:100%;font-size: 12px;">
                <div class="event-list-wrapper" style="width:500px;">
                  <div v-for="(item, index) in archivesEventData" :key="index" class="event-list">
                    <div :class="[index % 2 === 0 ? 'event-detail-top' : 'event-detail-bottom',selectArchivesEvent.id == item.id ? 'select-event' : '']" 
                      :style="{cursor: !selectFileObj.disabled && $route.path != '/customerRoom' ? 'pointer' : 'unset'}"
                      @click="!selectFileObj.disabled && $route.path != '/customerRoom' && clickArchivesEvent(item)">
                      <p :title="item.diseaseName" class="overdot-disease">{{ item.diseaseName ? item.diseaseName : "-" }}</p>
                      <div>
                        <span class="overdot-hospital" :title="item.hospital">{{ item.hospital }}</span>
                        <span class="overdot-depart" :title="item.departmentName">{{ item.departmentName }}</span>
                      </div>
                      <div>
                        <span>{{ item.eventDate }}</span>
                        <span>{{ item.eventName }}</span>
                      </div>
                    </div>
                    <div class="single-line-wrapper">
                      <span class="single-dot"></span>
                      <span class="single-line"></span>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div> -->

            <div v-show="selectArchivesEvent.id">
              <!-- <div class="header" style="margin-top:30px">
                <p></p>
                <h1>录入信息</h1>
              </div> -->
              <div class="record-type-radio">
              <el-row :gutter="20" v-show="selectArchivesEvent.eventName == '门诊'">
                
                <el-col :span="24">
                  <el-form-item label="记录类型：" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="1">门诊病历</el-radio>
                      <el-radio :label="2">处方</el-radio>
                      <el-radio :label="3">手术</el-radio>
                      <el-radio :label="4">检验</el-radio>
                      <el-radio :label="5">检查</el-radio>
                      <el-radio :label="6">门诊化疗记录单</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 急诊 -->
              <el-row :gutter="20" v-show="selectArchivesEvent.eventName == '急诊'">
                <el-col :span="24">
                  <el-form-item label="记录类型：" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="1">急诊病历</el-radio>
                      <el-radio :label="2">处方</el-radio>
                      <el-radio :label="3">手术</el-radio>
                      <el-radio :label="4">检验</el-radio>
                      <el-radio :label="5">检查</el-radio>
                      <el-radio :label="7">急诊留观记录</el-radio>
                      <el-radio :label="8">急诊抢救记录</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 住院 -->
              <el-row :gutter="20" v-show="selectArchivesEvent.eventName == '住院'">
                <el-col :span="24" class="inp-record-type">
                  <el-form-item label="记录类型：" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="3">手术</el-radio>
                      <el-radio :label="4">检验</el-radio>
                      <el-radio :label="5">检查</el-radio>
                      <el-radio :label="6">住院化疗记录单</el-radio>
                      <el-radio :label="9">24h出入院记录</el-radio>
                      <el-radio :label="10">入院记录</el-radio>
                      <el-radio :label="11">住院病程记录</el-radio>
                      <el-radio :label="12">出院小结</el-radio>
                      <el-radio :label="13">筛查评估单</el-radio>
                      <el-radio :label="16">会诊</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 院外 -->
              <el-row :gutter="20" v-show="selectArchivesEvent.eventName == '院外'">
                <el-col :span="24">
                  <el-form-item label="记录类型：" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="14">线下随访（除门诊外）</el-radio>
                      <el-radio :label="15">其他</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- 图文问诊 -->
              <el-row :gutter="20" v-show="selectArchivesEvent.eventName == '图文问诊'">
                <el-col :span="24">
                  <el-form-item label="记录类型：" prop="type">
                    <el-radio-group v-model="form.type">
                      <el-radio :label="1">病历</el-radio>
                      <el-radio :label="2">处方</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              </div>
            </div>
            <el-row :gutter="20" v-if="selectArchivesEvent.id && routeEntry != 5 && routeEntry != 7">
              <el-col :span="24">
                <el-form-item label="报告名称：" prop="reportName">
                  <el-input v-if="editBack" type="text" size="small" clearable maxlength="50" v-model.trim="form.reportName" placeholder="请输入报告名称" style="width:220px"></el-input>
                  <span v-else>{{form.reportName}}</span>
                </el-form-item>
              </el-col>
            </el-row>

            <div v-if="selectArchivesEvent.id && form.type != 4">
              <div class="drug-title-wrapper">
                 <div class="header">
                  <p></p>
                  <h1>录入字段</h1>
                </div>
                <div v-show="form.standardTable && form.standardTable.length > 2" class="fold-btn" style="margin-top:0px">
                  <div v-if="foldStandard" @click="foldStandard = !foldStandard">收起<i class="el-icon-arrow-up"></i></div>
                  <div v-else @click="foldStandard = !foldStandard">展开<i class="el-icon-arrow-down"></i></div>
                </div>
                
              </div>
              <div class="standard-table">
                <el-table :data="!foldStandard ? form.standardTable.slice(0,2) : form.standardTable" style="width: 100%;margin-bottom:16px" :default-expand-all="true">
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit && scope.row.standardFieldId"
                        :prop="'standardTable.' + scope.$index +'.inputValue'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <el-select
                          v-if="scope.row.dataType == '单选下拉' && scope.row.standardFieldName !== '省市区'"
                          v-model="scope.row.inputValue"
                          filterable
                          size="small"
                          style="width:100%"
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.dataType == '多选下拉'"
                          v-model="scope.row.inputValue"
                          filterable
                          style="width:100%"
                          size="small"
                          multiple
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-switch v-if="scope.row.dataType == '开关'" v-model.trim="scope.row.inputValue" active-color="#1a7bfc" inactive-color="#dcdfe6" active-value="是" inactive-value="否"></el-switch>
                        <el-input size="small" v-if="scope.row.dataType == '字符串' || !scope.row.dataType" type="textarea" clearable v-model="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <!-- oninput="value=value.replace(/[^0-9.]/g,'')"  oninput="value=value.replace(/[^!@#$%^&*()-=+_{}\|;:',./<>?`~^]/g,'')" .replace(/[\u4e00-\u9fa5]/g, '') -->
                        <el-input size="small" v-if="scope.row.dataType == '数值'" maxlength="500" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input size="small" v-if="scope.row.dataType == '富文本'" type="textarea" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-checkbox-group v-if="scope.row.dataType == '多选'" v-model.trim="scope.row.inputValue">
                          <el-checkbox v-for="(item,index) in scope.row.selectDataList" :label="item.name" :key="index"></el-checkbox>
                        </el-checkbox-group>
                        <el-cascader
                          v-if="scope.row.standardFieldName == '省市区'"
                          :key="resetCascader"
                          v-model="scope.row.inputValue"
                          size="small"
                          style="width:100%"
                          placeholder="请输入"
                          :options="scope.row.selectDataList" :props="selectAddressProp"
                          filterable></el-cascader>
                        <BaseUploadFile
                          v-if="scope.row.dataType == '图片'"
                          :fileSize="6" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="60"
                          :height="50" :beforeRemove="handleTableImgRemove" :responseFn="tableImgChange"
                          :action="VUE_APP_WECHATBASE_URL" :data="{ path:'dsicm-entry', type: 'image', mediaId: '' }"
                          v-model="scope.row.inputValue"></BaseUploadFile>
                        <el-date-picker
                          v-if="scope.row.dataType == '日期'"
                          v-model="scope.row.inputValue"
                          style="width:100%"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <span v-else>
                        <!-- <el-tooltip v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)" effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue.join(',')" placement="right">
                          <span>
                            {{scope.row.inputValue.join(',').length>10 ? scope.row.inputValue.join(',').substring(0,10)+'...' : scope.row.inputValue.join(',')}}
                          </span>
                        </el-tooltip> -->
                        <span v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)">
                          {{scope.row.inputValue.join(',')}}
                        </span>
                        <span v-else-if="scope.row.dataType == '图片'">
                          <img :src="scope.row.inputValue" alt="" style="width:60px;">
                        </span>
                        <!-- <el-tooltip v-else effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue" placement="right">
                          <span>
                            {{scope.row.inputValue.length>10 ? scope.row.inputValue.substring(0,10)+'...' : scope.row.inputValue}}
                          </span>
                        </el-tooltip> -->
                        <span v-html="scope.row.inputValue" v-else></span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="录入字段" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit"
                        :prop="'standardTable.' + scope.$index +'.standardFieldName'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <!-- <el-select
                          v-model="scope.row.standardFieldIdObj"
                          placeholder="请选择标准字段"
                          @change="val => {listFieldChange(val, scope.row)}"
                          filterable
                          remote
                          reserve-keyword
                          value-key="focusFieldId"
                          v-elSelectloadMore="loadmoreFieldList"
                          style="width:100%"
                          :remote-method="val => {remoteFieldMethod(val)}"
                          clearable>
                          <el-option v-for="(item, index) in standardFieldList" :key="index" :label="item.standardFieldName" :value="item" :disabled="item.disabledStandard"> </el-option>
                        </el-select> -->
                        <el-select
                          v-model="scope.row.standardFieldIdObj"
                          placeholder="请选择录入字段"
                          remote
                          size="small"
                          :remote-method="val => {standardFieldFilter(val, scope.row)}"
                          @focus="focusStandardField"
                          @change="val => {listFieldChange(val, scope.row)}"
                          filterable
                          value-key="focusFieldId"
                          style="width:100%">
                          <el-option v-for="(item, index) in standardFieldList" :key="index" :label="item.focusFieldName" :value="item" :disabled="item.disabledStandard"> </el-option>
                        </el-select>
                      </el-form-item>
                      <span v-else>{{ scope.row.focusFieldName }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="是否重点" align="center" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isFocus" class="important-tag">是</span>
                      <span v-else class="no-important-tag">否</span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="字段值" align="center" width="200">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit && scope.row.standardFieldId"
                        :prop="'standardTable.' + scope.$index +'.inputValue'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <el-select
                          v-if="scope.row.dataType == '单选下拉' && scope.row.standardFieldName !== '省市区'"
                          v-model="scope.row.inputValue"
                          filterable
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.dataType == '多选下拉'"
                          v-model="scope.row.inputValue"
                          filterable
                          multiple
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-switch v-if="scope.row.dataType == '开关'" v-model.trim="scope.row.inputValue" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        <el-input v-if="scope.row.dataType == '字符串' || !scope.row.dataType" type="textarea" maxlength="5000" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.dataType == '数值'" maxlength="500" oninput="value=value.replace(/[^0-9.]/g,'')" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.dataType == '富文本'" type="textarea" maxlength="5000" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-checkbox-group v-if="scope.row.dataType == '多选'" v-model.trim="scope.row.inputValue">
                          <el-checkbox v-for="(item,index) in scope.row.selectDataList" :label="item.name" :key="index"></el-checkbox>
                        </el-checkbox-group>
                        <el-cascader
                          v-if="scope.row.standardFieldName == '省市区'"
                          v-model.trim="scope.row.inputValue"
                          placeholder="请输入"
                          :options="scope.row.selectDataList" :props="selectAddressProp"
                          filterable></el-cascader>
                        <BaseUploadFile
                          v-if="scope.row.dataType == '图片'"
                          :fileSize="6" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="60"
                          :height="50" :beforeRemove="handleTableImgRemove" :responseFn="tableImgChange"
                          :action="VUE_APP_WECHATBASE_URL" :data="{ path:'dsicm-entry', type: 'image', mediaId: '' }"
                          v-model="scope.row.inputValue"></BaseUploadFile>
                        <el-date-picker
                          v-if="scope.row.dataType == '日期'"
                          v-model="scope.row.inputValue"
                          style="width:100%"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <span v-else>
                        <el-tooltip v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)" effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue.join(',')" placement="right">
                          <span>
                            {{scope.row.inputValue.join(',').length>10 ? scope.row.inputValue.join(',').substring(0,10)+'...' : scope.row.inputValue.join(',')}}
                          </span>
                        </el-tooltip>
                        <span v-else-if="scope.row.dataType == '图片'">
                          <img :src="scope.row.inputValue" alt="" style="width:60px;">
                        </span>
                        <el-tooltip v-else effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue" placement="right">
                          <span>
                            {{scope.row.inputValue.length>10 ? scope.row.inputValue.substring(0,10)+'...' : scope.row.inputValue}}
                          </span>
                        </el-tooltip>
                      </span>
                    </template>
                  </el-table-column> -->

                  <el-table-column label="单位" align="center" width="120">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.doseUnit" size="small" maxlength="10" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.doseUnit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="180">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.fieldDescription" size="small" maxlength="10" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.fieldDescription }}</span>
                    </template>
                  </el-table-column>
                  <!-- fillInfo && isAnswerPlan ||  -->
                  <el-table-column v-if="editBack" label="操作" align="center" width="250">
                    <template slot-scope="scope">
                      <!-- <el-button v-if="!scope.row.isEdit" type="text" :disabled="scope.row.dataType != '日期'" size="small">关联至编链</el-button> -->
                      <span style="display:inline-block;margin-right:10px">
                        <RelateChain
                          v-if="scope.row.dataType == '日期'"
                          :patientFilesId="patientFilesId"
                          :eventName="form.eventName"
                          :docType="form.type"
                          :chainTimeText="scope.row.standardFieldName"
                          :chainDate="scope.row.inputValue"
                        />
                      </span>
                      <!-- <el-button v-if="scope.row.isEdit" type="text" size="small" @click="saveStandardRow(scope.row,scope.$index)">保存</el-button>
                      <el-button v-if="!scope.row.isEdit" type="text" size="small" @click="editStandardRow(scope.row)">编辑</el-button> -->
                      <el-button type="text" size="small" @click="delStandardRow(scope.$index)">删除</el-button>
                      <el-button type="text" :disabled="!scope.row.standardFieldId" size="small" @click="fillHistoryData(scope.row)">填入历史</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button v-if="editBack" size="small" class="add-item" type="primary" style="margin-bottom:20px;margin-top:0" @click="addStandardRow"> + 新增一条记录</el-button>
              </div>
            </div>

            <div v-if="selectArchivesEvent.id">
              <div class="drug-title-wrapper">
                 <div class="header">
                  <p></p>
                  <h1>检验</h1>
                </div>
                <div v-show="form.inspectionTable && form.inspectionTable.length > 2" class="fold-btn">
                  <div v-if="foldInspect" @click="foldInspect = !foldInspect">收起<i class="el-icon-arrow-up"></i></div>
                  <div v-else @click="foldInspect = !foldInspect">展开<i class="el-icon-arrow-down"></i></div>
                </div>
              </div>
              <div>
                <el-form-item label="标本类型：">
                  <el-select
                    v-if="editBack"
                    v-model="form.specimenType"
                    filterable
                    default-first-option
                    placeholder="请选择"
                    size="small"
                    style="width:220px"
                    @change="changeSpecimenType"
                  >
                    <el-option v-for="(item,index1) in specimenTypeData" :key="index1" :label="item" :value="item"> </el-option>
                  </el-select>
                  <span v-else>{{form.specimenType}}</span>
                </el-form-item>
              </div>
              <div class="inspection-table">
                <el-table :data="!foldInspect ? form.inspectionTable.slice(0,2) : form.inspectionTable" style="width: 100%;margin-bottom:16px">
                  <el-table-column label="检验项目">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit"
                        :prop="'inspectionTable.' + scope.$index + '.definitionItemId'"
                        :rules="[{
                          required: true,
                          message: '此项为必填项',
                          trigger: 'blur'
                        }]">
                        <!-- 数据库不存在的 -->
                        <!-- <el-select
                          v-if="!scope.row.standardFieldId && scope.row.id"
                          v-model.trim="scope.row.name"
                          :title="scope.row.name"
                          placeholder="请选择检验项目"
                          @change="val => {listNameChange(val, scope.row)}"
                          :allow-create="previewPicturesUrl ? true : false"
                          filterable
                          remote
                          reserve-keyword
                          v-elSelectloadMore="loadmore"
                          :remote-method="
                            val => {
                              remoteInspectItemMethod(val);
                            }
                          "
                          clearable
                        >
                          <el-option v-for="(item, index) in inspectionList" :key="index" :label="(item.firstCategoryName ? item.firstCategoryName + '-' : '') + item.name" :value="item.id"> </el-option>
                        </el-select> -->
                        <!-- 数据库存在的:allow-create="previewPicturesUrl ? true : false" -->
                        <!-- :title="`${scope.row.firstCategoryName ? scope.row.firstCategoryName + '-' : ''}${scope.row.name}`" -->
                        <!-- :title="`${resultPropertyObj[scope.row.resultProperty]}-${scope.row.standardFieldName}`" -->
                        <!-- <el-select
                          v-model="scope.row.definitionItemId"
                          placeholder="请选择检验项目"
                          :title="scope.row.standardFieldName"
                          @change="val => {listNameChange(val, scope.row)}"
                          filterable
                          remote
                          popper-class="select-inspect-item"
                          reserve-keyword
                          v-elSelectloadMore="loadmore"
                          :remote-method="val => {remoteInspectItemMethod(val)}"
                          clearable>
                          <el-option v-for="(item, index) in inspectionList" :key="index" :label="`${resultPropertyObj[item.resultProperty]}-${item.standardFieldName}`" :value="item.focusFieldId" :disabled="item.disabledItem">
                            <span class="inspect-item-type">{{resultPropertyObj[item.resultProperty]}}</span>
                            <span class="inspect-item-name">{{item.standardFieldName}}</span>
                          </el-option>
                        </el-select> -->
                        <!-- @focus="focusInspectName" :filter-method="val => {itemDataFilter(val, scope.row)}"-->
                        <el-select
                          v-model="scope.row.definitionItemId"
                          placeholder="请选择检验项目"
                          :title="scope.row.focusFieldName ? scope.row.focusFieldName : scope.row.name"
                          remote
                          :remote-method="val => {itemDataFilter(val, scope.row)}"
                          value-key="focusFieldId"
                          @focus="focusInspectName"
                          @change="val => {listNameChange(val, scope.row)}"
                          filterable
                          size="small"
                          style="width:100%"
                          popper-class="select-inspect-item">
                          <el-option v-for="(item, index) in inspectionList" :key="index" :label="`${resultPropertyObj[item.resultProperty]}-${item.focusFieldName}`" :value="item" :disabled="item.disabledItem">
                            <span class="inspect-item-type" :style="{background: item.disabledItem ? '#c0c4cc' : '#1a7bfc'}">{{resultPropertyObj[item.resultProperty]}}</span>
                            <span class="inspect-item-name" :style="{color: item.disabledItem ? '#c0c4cc' : '#000000'}">{{item.focusFieldName}}</span>
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <!-- <span v-else>{{ scope.row.firstCategoryName ? scope.row.firstCategoryName + "-" : "" }}{{ scope.row.name }}</span> -->
                      <span v-else class="select-inspect-item">
                        <!-- <span class="inspect-item-type">定性</span> -->
                        <span class="inspect-item-type" v-if="scope.row.resultProperty !== null">{{resultPropertyObj[scope.row.resultProperty]}}</span>
                        {{ scope.row.focusFieldName ? scope.row.focusFieldName : scope.row.name }}
                      </span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="是否重点" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isFocus" class="important-tag">是</span>
                      <span v-else class="no-important-tag">否</span>
                    </template>
                  </el-table-column> -->
                  <el-table-column label="检验结果" align="center" width="130">
                    <!-- ,{pattern: /^(\+|-)?\d+(\.\d+)?$/,message: '请输入数字', trigger: ['change', 'blur']} -->
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit"
                        :prop="'inspectionTable.' + scope.$index + '.inputValue'"
                        :rules="[{
                          required: true,
                          message: '此项为必填项',
                          trigger: 'blur'
                        }]">
                        <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.inputValue" maxlength="10" @input="change($event)" clearable></el-input> -->

                        <!-- 0 定性 1 定量 2 描述 -->
                        <!-- 定量 数值输入框 -->
                        <el-input size="small" v-if="scope.row.resultProperty == 1" v-model.trim="scope.row.inputValue" maxlength="30" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" clearable></el-input>
                        <!-- 描述 文本输入框 -->
                        <el-input size="small" v-if="scope.row.resultProperty == 2 || scope.row.resultProperty == null" v-model.trim="scope.row.inputValue" maxlength="30" clearable></el-input>
                        <!-- 定性 下拉选择可输入 -->
                        <el-select size="small" v-if="scope.row.resultProperty == 0" v-model="scope.row.inputValue" filterable
                          allow-create
                          placeholder="请选择">
                          <el-option
                            v-for="item in scope.row.referencesList"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <span v-else>{{ scope.row.inputValue }}</span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column label="参考值" align="center">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input v-model.trim="scope.row.references" :title="scope.row.references" maxlength="30" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.references }}</span>
                    </template>
                  </el-table-column> -->

                  <el-table-column label="单位" align="center" width="120">
                    <!-- ,{pattern: /^(\+|-)?\d+(\.\d+)?$/,message: '请输入数字', trigger: ['change', 'blur']} -->
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <!-- {{scope.row.unitList}} -->
                        <el-select
                          v-model.trim="scope.row.doseUnit"
                          filterable
                          clearable
                          allow-create
                          size="small"
                          @change="val => {listUnitChange(val, scope.row)}"
                          default-first-option
                          placeholder="请选择单位"
                        >
                          <el-option v-for="item in scope.row.unitList" :key="item" :label="item" :value="item"> </el-option>
                        </el-select>
                      </el-form-item>
                      <span v-else>{{ scope.row.doseUnit }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="异常" align="center" width="120">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.exceptionRecord" size="small" placeholder="请选择异常值" style="width:80%">
                          <el-option label="偏高" :value="1"></el-option>
                          <el-option label="偏低" :value="2"></el-option>
                          <el-option label="正常" :value="3"></el-option>
                          <el-option label="异常" :value="0"></el-option>
                        </el-select>
                      </el-form-item>
                      <span v-else>{{ scope.row.exceptionRecord == null ? "" : exceptionRecordObj[scope.row.exceptionRecord] }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="130">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input size="small" v-if="scope.row.isEdit" v-model.trim="scope.row.fieldDescription" maxlength="10" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.fieldDescription }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="editBack" label="操作" align="center" width="60">
                    <template slot-scope="scope">
                      <!-- <el-button size="mini" type="text" @click="categoryEdit(scope.$index, scope.row)">{{ scope.row.isEdit ? "保存" : "编辑" }}</el-button> -->
                      <el-button size="mini" type="text" @click="categoryDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="addDrug" v-if="editBack" @click="addExamineData">+添加一条检验结果记录</div>
              </div>
            </div>  

            <div v-if="selectArchivesEvent.id && form.type == 4">
              <div class="drug-title-wrapper">
                 <div class="header">
                  <p></p>
                  <h1>录入字段</h1>
                </div>
                <div v-show="form.standardTable && form.standardTable.length > 2" class="fold-btn" style="margin-top:0px">
                  <div v-if="foldStandard" @click="foldStandard = !foldStandard">收起<i class="el-icon-arrow-up"></i></div>
                  <div v-else @click="foldStandard = !foldStandard">展开<i class="el-icon-arrow-down"></i></div>
                </div>
                
              </div>
              <div class="standard-table">
                <el-table :data="!foldStandard ? form.standardTable.slice(0,2) : form.standardTable" style="width: 100%;margin-bottom:16px" :default-expand-all="true">
                  <el-table-column type="expand">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit && scope.row.standardFieldId"
                        :prop="'standardTable.' + scope.$index +'.inputValue'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <el-select
                          v-if="scope.row.dataType == '单选下拉' && scope.row.standardFieldName !== '省市区'"
                          v-model="scope.row.inputValue"
                          filterable
                          size="small"
                          style="width:100%"
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.dataType == '多选下拉'"
                          v-model="scope.row.inputValue"
                          filterable
                          size="small"
                          style="width:100%"
                          multiple
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-switch size="small" v-if="scope.row.dataType == '开关'" v-model.trim="scope.row.inputValue" active-color="#1a7bfc" inactive-color="#dcdfe6" active-value="是" inactive-value="否"></el-switch>
                        <el-input size="small" v-if="scope.row.dataType == '字符串' || !scope.row.dataType" type="textarea"  clearable v-model="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <!-- oninput="value=value.replace(/[^0-9.]/g,'')"  oninput="value=value.replace(/[^!@#$%^&*()-=+_{}\\\[\]|;:',./<>?`~^]/g,'')"-->
                        <el-input size="small" v-if="scope.row.dataType == '数值'" maxlength="500" oninput="value=value.replace(/[\u4E00-\u9FA5]/g,'')" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input size="small" v-if="scope.row.dataType == '富文本'" type="textarea" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-checkbox-group v-if="scope.row.dataType == '多选'" v-model.trim="scope.row.inputValue">
                          <el-checkbox v-for="(item,index) in scope.row.selectDataList" :label="item.name" :key="index"></el-checkbox>
                        </el-checkbox-group>
                        <el-cascader
                          v-if="scope.row.standardFieldName == '省市区'"
                          :key="resetCascader"
                          v-model="scope.row.inputValue"
                          size="small"
                          style="width:100%"
                          placeholder="请输入"
                          :options="scope.row.selectDataList" :props="selectAddressProp"
                          filterable></el-cascader>
                        <BaseUploadFile
                          v-if="scope.row.dataType == '图片'"
                          :fileSize="6" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="60"
                          :height="50" :beforeRemove="handleTableImgRemove" :responseFn="tableImgChange"
                          :action="VUE_APP_WECHATBASE_URL" :data="{ path:'dsicm-entry', type: 'image', mediaId: '' }"
                          v-model="scope.row.inputValue"></BaseUploadFile>
                        <el-date-picker
                          v-if="scope.row.dataType == '日期'"
                          v-model="scope.row.inputValue"
                          style="width:100%"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <span v-else>
                        <!-- <el-tooltip v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)" effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue.join(',')" placement="right">
                          <span>
                            {{scope.row.inputValue.join(',').length>10 ? scope.row.inputValue.join(',').substring(0,10)+'...' : scope.row.inputValue.join(',')}}
                          </span>
                        </el-tooltip> -->
                        <span v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)">
                          {{scope.row.inputValue.join(',')}}
                        </span>
                        <span v-else-if="scope.row.dataType == '图片'">
                          <img :src="scope.row.inputValue" alt="" style="width:60px;">
                        </span>
                        <!-- <el-tooltip v-else effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue" placement="right">
                          <span>
                            {{scope.row.inputValue.length>10 ? scope.row.inputValue.substring(0,10)+'...' : scope.row.inputValue}}
                          </span>
                        </el-tooltip> -->
                        <span v-else>{{scope.row.inputValue}}</span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column label="录入字段" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit"
                        :prop="'standardTable.' + scope.$index +'.standardFieldName'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <!-- <el-select
                          v-model="scope.row.standardFieldIdObj"
                          placeholder="请选择标准字段"
                          @change="val => {listFieldChange(val, scope.row)}"
                          filterable
                          remote
                          reserve-keyword
                          value-key="focusFieldId"
                          style="width:100%"
                          v-elSelectloadMore="loadmoreFieldList"
                          :remote-method="val => {remoteFieldMethod(val)}"
                          clearable>
                          <el-option v-for="(item, index) in standardFieldList" :key="index" :label="item.standardFieldName" :value="item" :disabled="item.disabledStandard"> </el-option>
                        </el-select> -->
                        <el-select
                          v-model="scope.row.standardFieldIdObj"
                          placeholder="请选择录入字段"
                          remote
                          size="small"
                          :remote-method="val => {standardFieldFilter(val, scope.row)}"
                          @focus="focusStandardField"
                          @change="val => {listFieldChange(val, scope.row)}"
                          filterable
                          value-key="focusFieldId"
                          style="width:100%">
                          <el-option v-for="(item, index) in standardFieldList" :key="index" :label="item.focusFieldName" :value="item" :disabled="item.disabledStandard"> </el-option>
                        </el-select>
                      </el-form-item>
                      <span v-else>{{ scope.row.focusFieldName }}</span>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column label="是否重点" align="center" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isFocus" class="important-tag">是</span>
                      <span v-else class="no-important-tag">否</span>
                    </template>
                  </el-table-column> -->

                  <!-- <el-table-column label="字段值" align="center" width="200">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit && scope.row.standardFieldId"
                        :prop="'standardTable.' + scope.$index +'.inputValue'"
                        :rules="[{required: true,message: '此项为必填项',trigger: 'blur'}]">
                        <el-select
                          v-if="scope.row.dataType == '单选下拉' && scope.row.standardFieldName !== '省市区'"
                          v-model="scope.row.inputValue"
                          filterable
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-select
                          v-if="scope.row.dataType == '多选下拉'"
                          v-model="scope.row.inputValue"
                          filterable
                          multiple
                          default-first-option
                          placeholder="请选择"
                        >
                          <el-option v-for="(item,index1) in scope.row.selectDataList" :key="index1" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                        <el-switch v-if="scope.row.dataType == '开关'" v-model.trim="scope.row.inputValue" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        <el-input v-if="scope.row.dataType == '字符串' || !scope.row.dataType" type="textarea" maxlength="5000" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.dataType == '数值'" maxlength="500" oninput="value=value.replace(/[^0-9.]/g,'')" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-input v-if="scope.row.dataType == '富文本'" type="textarea" maxlength="5000" clearable v-model.trim="scope.row.inputValue" placeholder="请输入内容"></el-input>
                        <el-checkbox-group v-if="scope.row.dataType == '多选'" v-model.trim="scope.row.inputValue">
                          <el-checkbox v-for="(item,index) in scope.row.selectDataList" :label="item.name" :key="index"></el-checkbox>
                        </el-checkbox-group>
                        <el-cascader
                          v-if="scope.row.standardFieldName == '省市区'"
                          v-model.trim="scope.row.inputValue"
                          placeholder="请输入"
                          :options="scope.row.selectDataList" :props="selectAddressProp"
                          filterable></el-cascader>
                        <BaseUploadFile
                          v-if="scope.row.dataType == '图片'"
                          :fileSize="6" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="60"
                          :height="50" :beforeRemove="handleTableImgRemove" :responseFn="tableImgChange"
                          :action="VUE_APP_WECHATBASE_URL" :data="{ path:'dsicm-entry', type: 'image', mediaId: '' }"
                          v-model="scope.row.inputValue"></BaseUploadFile>
                        <el-date-picker
                          v-if="scope.row.dataType == '日期'"
                          v-model="scope.row.inputValue"
                          style="width:100%"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
                        </el-date-picker>
                      </el-form-item>
                      <span v-else>
                        <el-tooltip v-if="scope.row.inputValue && Array.isArray(scope.row.inputValue)" effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue.join(',')" placement="right">
                          <span>
                            {{scope.row.inputValue.join(',').length>10 ? scope.row.inputValue.join(',').substring(0,10)+'...' : scope.row.inputValue.join(',')}}
                          </span>
                        </el-tooltip>
                        <span v-else-if="scope.row.dataType == '图片'">
                          <img :src="scope.row.inputValue" alt="" style="width:60px;">
                        </span>
                        <el-tooltip v-else effect="dark" popper-class="inputValue-tool-tip" :content="scope.row.inputValue" placement="right">
                          <span>
                            {{scope.row.inputValue.length>10 ? scope.row.inputValue.substring(0,10)+'...' : scope.row.inputValue}}
                          </span>
                        </el-tooltip>
                      </span>
                    </template>
                  </el-table-column> -->

                  <el-table-column label="单位" align="center" width="120">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input size="small" v-if="scope.row.isEdit" v-model.trim="scope.row.doseUnit" maxlength="10" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.doseUnit }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="180">
                    <template slot-scope="scope">
                      <el-form-item label-width="0px" v-if="scope.row.isEdit">
                        <el-input size="small" v-if="scope.row.isEdit" v-model.trim="scope.row.fieldDescription" maxlength="10" clearable></el-input>
                      </el-form-item>
                      <span v-else>{{ scope.row.fieldDescription }}</span>
                    </template>
                  </el-table-column>
                  <!-- fillInfo && isAnswerPlan ||  -->
                  <el-table-column v-if="editBack" label="操作" align="center" width="250">
                    <template slot-scope="scope">
                      <!-- <el-button v-if="!scope.row.isEdit" type="text" :disabled="scope.row.dataType != '日期'" size="small">关联至编链</el-button> -->
                      <span style="display:inline-block;margin-right:10px">
                        <RelateChain
                          v-if="scope.row.dataType == '日期'"
                          :patientFilesId="patientFilesId"
                          :eventName="form.eventName"
                          :docType="form.type"
                          :chainTimeText="scope.row.standardFieldName"
                          :chainDate="scope.row.inputValue"
                        />
                      </span>
                      <!-- <el-button v-if="scope.row.isEdit" type="text" size="small" @click="saveStandardRow(scope.row,scope.$index)">保存</el-button>
                      <el-button v-if="!scope.row.isEdit" type="text" size="small" @click="editStandardRow(scope.row)">编辑</el-button> -->
                      <el-button type="text" size="small" @click="delStandardRow(scope.$index)">删除</el-button>
                      <el-button type="text" :disabled="!scope.row.standardFieldId" size="small" @click="fillHistoryData(scope.row)">填入历史</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button v-if="editBack" size="small" class="add-item" type="primary" style="margin-bottom:20px;margin-top:0" @click="addStandardRow"> + 新增一条记录</el-button>
              </div>
            </div>
            
            <div v-if="selectArchivesEvent.id" class="drug-entry-wrapper">
              <div class="drug-title-wrapper">
                 <div class="header">
                  <p></p>
                  <h1>药品</h1>
                </div>
                <div v-if="foldDrug" class="fold-btn" @click="foldDrug = !foldDrug">收起<i class="el-icon-arrow-up"></i></div>
                <div v-else class="fold-btn" @click="foldDrug = !foldDrug">展开<i class="el-icon-arrow-down"></i></div>
              </div>
              <div v-show="foldDrug" class="drug-table">
                <!-- prop="prescription.type" -->
                <!-- prescription.genre -->
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="处方类别：">
                      <el-select v-if="editBack" size="small" v-model.trim="form.prescription.type" @change="selectChange" placeholder="请选择处方类别" clearable>
                        <el-option label="西药处方" :value="1"></el-option>
                        <el-option label="中药处方" :value="2"></el-option>
                        <el-option label="营养处方" :value="3"></el-option>
                        <el-option label="运动处方" :value="4"></el-option>
                        <el-option label="治疗类处方" :value="5"></el-option>
                        <el-option label="其他" :value="6"></el-option>
                      </el-select>
                      <span v-else>{{prescriptionTypeObj[form.prescription.type]}}</span>
                    </el-form-item> 
                  </el-col>
                  <el-col v-if="form.prescription.type" :span="12" style="display:flex;align-items:center">
                    <!-- prop="prescription.genre" -->
                    <el-form-item label="处方类型：">
                      <el-select
                        v-if="editBack"
                        style="width:100%" size="small" clearable
                        v-model.trim="form.prescription.genre"
                        placeholder="请选择处方类型">
                        <el-option label="长期" value="长期"></el-option>
                        <el-option label="短期" value="短期"></el-option>
                      </el-select>
                      <span v-else>{{ form.prescription.genre }}</span>
                    </el-form-item> 
                    <el-form-item label="" prop="prescription.day" label-width="0px">
                      <el-input
                        v-if="editBack"
                        placeholder="" size="small"
                        :disabled="!form.prescription.genre || form.prescription.genre == '长期'"
                        v-model.trim="form.prescription.day"
                        style="margin-top:5px;margin-left:10px"
                        class="input-with-select">
                        <template slot="append">天</template>
                      </el-input>
                      <span v-if="form.prescription.genre == '短期' && editBack == false">{{ form.prescription.day }}天</span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- 西药 -->
                <div v-if="form.prescription.type === 1">
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="处方诊断：" prop="prescription.initDiagnosis">
                        <el-input v-if="editBack" v-model.trim="form.prescription.initDiagnosis" size="small" maxlength="100" placeholder="请输入处方诊断"></el-input>
                        <span v-else>{{form.prescription.initDiagnosis}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="药品类型：" prop="prescription.drugType">
                        <el-select v-if="editBack" v-model.trim="form.prescription.drugType" size="small" clearable placeholder="请选择药品类型">
                          <el-option v-for="(item, index) in medicineTypeList" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.drugType}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="安全类别：" prop="prescription.securityCategory">
                        <!-- saveCategoryList -->
                        <!-- <el-input v-model.trim="form.prescription.securityCategory" size="small" placeholder="请选择安全类别"></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.securityCategory" size="small" clearable placeholder="请选择药品类型">
                          <el-option v-for="(item, index) in saveCategoryList" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.securityCategory}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-table
                    :data="form.prescription.itemList"
                    :header-cell-style="{
                      textAlign: 'center',
                      color: '#333333',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      backgroundColor: '#FAFAFA'
                    }"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    fit
                    highlight-current-row
                  >
                    <el-table-column align="center" prop="title" label="药品名称" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugName'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <!-- <el-input v-model.trim="scope.row.drugName" size="small" placeholder=""></el-input>  :title="scope.row.drugName" -->
                          <el-select
                            v-model.trim="scope.row.drugName"
                            :title="scope.row.drugName"
                            filterable
                            remote
                            reserve-keyword
                            @change="val => {changeDrug(val, scope.row)}"
                            placeholder="请输入关键词"
                            :remote-method="remoteMethod"
                          >
                            <el-option v-for="item in drugList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                          </el-select>
                        </el-form-item>
                        <span v-else>{{ scope.row.drugName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="examTypeName" label="规格" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span>{{ scope.row.drugSpecification }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="medicationFrequencyName" label="频率">
                      <template slot-scope="scope">
                        <!-- <el-input v-model.trim="form.medicationFrequencyName" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.medicationFrequencyName'"
                          :rules="[{required: true,message: '此项为必填项',trigger: 'change'}]">
                          <el-select v-model.trim="scope.row.medicationFrequencyName" size="small" clearable placeholder="请选择">
                            <el-option v-for="(item, index) in frequencyList" :key="index" :label="item.name" :value="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-else>{{ scope.row.medicationFrequencyName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="medicationModeName" label="用法" width="100">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.medicationModeName'"
                          :rules="[{required: true,message: '此项为必填项',trigger: 'change'}]"
                        >
                          <el-select v-model.trim="scope.row.medicationModeName" size="small" clearable placeholder="请选择">
                            <el-option v-for="(item, index) in routeList" :key="index" :label="item.name" :value="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-else>{{ scope.row.medicationModeName }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column align="center" prop="title" label="单次量">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.medicationNumber'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1,2})?$/,
                                message: '保留两位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-model.trim="scope.row.medicationNumber" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.medicationNumber }}</span>
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.drugUnitName'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-model.trim="scope.row.drugUnitName" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in unitList" :key="index" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.drugUnitName }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="examTypeName" label="总量">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.drugNumber'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1,2})?$/,
                                message: '保留两位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-model.trim="scope.row.drugNumber" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.drugNumber }}</span>
                          <!-- 单位 -->
                          <!-- <el-input v-model.trim="form.medicationUnitName" size="small" placeholder=""></el-input> -->
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.medicationUnitName'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-model.trim="scope.row.medicationUnitName" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in unitList" :key="index" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.medicationUnitName }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="diseaseName" label="备注" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" v-if="scope.row.isEdit">
                          <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.remarks" maxlength="50" size="small" placeholder=""></el-input>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.remarks }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="editBack" align="center" prop="enabled" label="操作" width="100">
                      <template slot-scope="scope">
                        <!-- <el-button type="text" size="small" v-if="!scope.row.isEdit" @click="handleEditRow(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="scope.row.isEdit" @click="handleSaveRow(scope.row, scope.$index)">保存</el-button> -->
                        <el-button type="text" size="small" @click="handleDelRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="editBack" size="small" class="add-item" type="primary" @click="handleAdd" style="margin-bottom:20px"> + 添加一条西药处方信息</el-button>
                </div>
                <!-- 中药 -->
                <div v-if="form.prescription.type === 2">
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="处方诊断：" prop="prescription.initDiagnosis">
                        <el-input v-if="editBack" v-model.trim="form.prescription.initDiagnosis" maxlength="100" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.initDiagnosis}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="处方证型：" prop="prescription.certificate">
                        <el-input v-if="editBack" v-model.trim="form.prescription.certificate" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.certificate}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="药品类型：" prop="prescription.drugType">
                        <!-- <el-input v-model.trim="form.prescription.drugType" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.drugType" size="small" clearable placeholder="请选择药品类型">
                          <el-option v-for="(item, index) in medicineTypeList" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.drugType}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="安全类别：" prop="prescription.securityCategory">
                        <!-- <el-input v-model.trim="form.prescription.securityCategory" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.securityCategory" size="small" clearable placeholder="请选择药品类型">
                          <el-option v-for="(item, index) in saveCategoryList" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.securityCategory}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="中药用法：" prop="prescription.chineseDrugUsage">
                        <!-- <el-input v-model.trim="form.prescription.chineseDrugUsage" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.chineseDrugUsage" size="small" clearable placeholder="请选择">
                          <el-option v-for="(item, index) in routeList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.chineseDrugUsage}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="中药频率：" prop="prescription.chineseDrugFrequency">
                        <!-- <el-input v-model.trim="form.prescription.chineseDrugFrequency" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.chineseDrugFrequency" size="small" clearable placeholder="请选择">
                          <el-option v-for="(item, index) in frequencyList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                        <span v-else>{{form.prescription.chineseDrugFrequency}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="单次用量：" prop="prescription.asingleDose">
                        <el-input v-if="editBack" v-model.trim="form.prescription.asingleDose" style="width:22%;margin-right:10px" size="small" placeholder=""></el-input>
                        <span v-if="!editBack">{{form.prescription.asingleDose}}</span>
                        <!-- 单位 -->
                        <!-- <el-input v-model.trim="form.prescription.asingleDoseUnit" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.asingleDoseUnit" style="width:22%;margin-right:10px" size="small" clearable placeholder="请选择">
                          <el-option v-for="(item, index) in unitList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                        <span v-if="!editBack">{{form.prescription.asingleDoseUnit}}</span>
                        <!-- 剂量 -->
                        <!-- <el-input v-model.trim="form.prescription.dosage" size="small" placeholder=""></el-input> -->
                        <el-select v-if="editBack" v-model.trim="form.prescription.dosage" style="width:23%;margin-right:10px" size="small" clearable placeholder="请选择">
                          <el-option v-for="(item, index) in dosageList" :key="index" :label="item" :value="item"></el-option>
                        </el-select>
                        <span v-if="!editBack">{{form.prescription.dosage}}</span>
                        <!-- 总量 -->
                        <!-- <el-input v-model.trim="form.prescription.totalDose" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" style="width:23%;margin-right:10px;margin-top:2.5px" size="small" v-model.trim="form.prescription.totalDose">
                          <template slot="prepend">总</template>
                        </el-input>
                        <span v-if="!editBack">总{{form.prescription.totalDose}}</span>
                        <!-- 单位 -->
                        <!-- <el-input v-model.trim="form.prescription.totalDoseUnit" size="small" placeholder=""></el-input> -->
                        <span>剂</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-table
                    :data="form.prescription.itemList"
                    :header-cell-style="{
                      textAlign: 'center',
                      color: '#333333',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      backgroundColor: '#FAFAFA'
                    }"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    fit
                    highlight-current-row
                  >
                    <el-table-column align="center" prop="drugName" label="中药名称">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugName'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            },
                            {
                              pattern: /[\u4e00-\u9fa5]/,
                              message: '请输入中文',
                              trigger: ['blur', 'change']
                            }
                          ]"
                        >
                          <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugName" maxlength="15" size="small" placeholder=""></el-input>
                        </el-form-item>
                        <span v-else>{{ scope.row.drugName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="drugNumber" label="数量">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugNumber'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            },
                            {
                              pattern: /^\d{1,4}(\.\d{1,2})?$/,
                              message: '保留两位小数，小数点前至多4位',
                              trigger: ['change', 'blur']
                            }
                          ]"
                        >
                          <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugNumber" size="small" placeholder=""></el-input> -->
                          <el-input v-model.trim="scope.row.drugNumber" size="small" placeholder="" style="margin-top:2.5px">
                            <template slot="append">{{ scope.row.medicationUnitName }}</template>
                          </el-input>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.drugNumber }}</span>

                        <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.medicationUnitName" disabled size="small" placeholder=""></el-input> -->
                        <span v-if="!scope.row.isEdit">{{ scope.row.medicationUnitName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="editBack" align="center" prop="enabled" label="操作" width="100">
                      <template slot-scope="scope">
                        <!-- <el-button type="text" size="small" v-if="!scope.row.isEdit" @click="handleEditRow(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="scope.row.isEdit" @click="handleSaveRow(scope.row, scope.$index)">保存</el-button> -->
                        <el-button type="text" size="small" @click="handleDelRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="editBack" size="small" class="add-item" type="primary" @click="handleAdd" style="margin-bottom:20px"> + 添加一条中药处方信息</el-button>
                </div>
                <!-- 营养处方 -->
                <div v-if="form.prescription.type === 3">
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item
                        label="营养诊断："
                        prop="prescription.initDiagnosis"
                        :rules="[
                          {
                            pattern: /[\u4e00-\u9fa5]/,
                            message: '请输入中文',
                            trigger: ['blur', 'change']
                          }
                        ]"
                      >
                        <el-input v-if="editBack" v-model.trim="form.prescription.initDiagnosis" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.initDiagnosis}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div class="nutrition-line-txt">目标营养素摄入</div>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="能量：" prop="prescription.energyKcal">
                        <!-- <el-input v-model.trim="form.prescription.energyKcal" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.energyKcal">
                          <template slot="append">kcal</template>
                        </el-input>
                        <span v-else>{{form.prescription.energyKcal}}kcal</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="碳水化合物：" prop="prescription.carbohydrate">
                        <!-- <el-input v-model.trim="form.prescription.carbohydrate" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.carbohydrate">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.carbohydrate}}g</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="脂肪：" prop="prescription.fat">
                        <!-- <el-input v-model.trim="form.prescription.fat" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.fat">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.fat}}g</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="蛋白质：" prop="prescription.protein">
                        <!-- <el-input v-model.trim="form.prescription.protein" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.protein">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.protein}}g</span>
                      </el-form-item>
                    </el-col>
                  </el-row> 
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="嘌呤：" prop="prescription.purine">
                        <!-- <el-input v-model.trim="form.prescription.purine" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.purine">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.purine}}g</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="膳食纤维：" prop="prescription.df">
                        <!-- <el-input v-model.trim="form.prescription.df" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.df">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.df}}g</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="铁：" prop="prescription.iron">
                        <!-- <el-input v-model.trim="form.prescription.iron" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.iron">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.iron}}g</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="钙：" prop="prescription.calcium">
                        <!-- <el-input v-model.trim="form.prescription.calcium" size="small" placeholder=""></el-input> -->
                        <el-input v-if="editBack" placeholder="请输入内容" v-model.trim="form.prescription.calcium">
                          <template slot="append">g</template>
                        </el-input>
                        <span v-else>{{form.prescription.calcium}}g</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="建议食物：" prop="prescription.suggestFood">
                        <el-input v-if="editBack" v-model.trim="form.prescription.suggestFood" maxlength="200" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.suggestFood}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="限制食物：" prop="prescription.restrictFood">
                        <el-input v-if="editBack" v-model.trim="form.prescription.restrictFood" maxlength="200" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.restrictFood}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col>
                      <el-form-item label="医生建议：" prop="prescription.doctorSuggest">
                        <el-input v-if="editBack" v-model.trim="form.prescription.doctorSuggest" maxlength="200" size="small" placeholder=""></el-input>
                        <span v-else>{{form.prescription.doctorSuggest}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <!-- 运动处方 -->
                <div v-if="form.prescription.type === 4">
                  <el-table
                    :data="form.prescription.itemList"
                    :header-cell-style="{
                      textAlign: 'center',
                      color: '#333333',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      backgroundColor: '#FAFAFA'
                    }"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    fit
                    highlight-current-row
                  >
                    <el-table-column align="center" prop="category" label="运动类型" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.category" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.sportId'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select
                            v-if="scope.row.isEdit"
                            v-model.trim="scope.row.sportId"
                            @change="
                              val => {
                                changeSport(val, scope.row);
                              }
                            "
                            size="small"
                            clearable
                            placeholder="请选择"
                          >
                            <el-option v-for="(item, index) in moveTypeList" :key="index" :label="item.categoryName" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.category }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" label="运动项目" prop="drugName">
                      <template slot-scope="scope">
                        <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugName" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.sportCategoryId'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select
                            v-if="scope.row.isEdit"
                            v-model.trim="scope.row.sportCategoryId"
                            @change="val => {changeSportItem(val, scope.row)}"
                            size="small"
                            clearable
                            placeholder="请选择"
                          >
                            <el-option v-for="(item, index) in scope.row.moveItemList" :key="index" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.drugName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="medicationFrequencyName" label="运动频率">
                      <template slot-scope="scope">
                        <!-- <el-input v-model.trim="form.medicationFrequencyName" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.medicationFrequencyName'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.medicationFrequencyName" size="small" clearable placeholder="请选择">
                            <el-option v-for="(item, index) in frequencyList" :key="index" :label="item.name" :value="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.medicationFrequencyName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="drugNumber" label="总次数">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugNumber'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            },
                            {
                              pattern: /^[1-9][0-9]{0,3}$/,
                              message: '至多4位正整数',
                              trigger: ['change', 'blur']
                            }
                          ]"
                        >
                          <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugNumber" size="small" placeholder=""></el-input>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.drugNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="singleTime" label="单次时长">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.singleTime'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1})?$/,
                                message: '保留一位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.singleTime" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.singleTime }}</span>
                          <!-- 单位 -->
                          <!-- <el-input v-model.trim="form.singleUnit" size="small" placeholder=""></el-input> -->
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.singleUnit'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.singleUnit" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in timeUnitList" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.singleUnit }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="totalTime" label="总时长">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.totalTime'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1})?$/,
                                message: '保留一位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.totalTime" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.totalTime }}</span>
                          <!-- 单位 -->
                          <!-- <el-input v-model.trim="form.totalUnit" size="small" placeholder=""></el-input> -->
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.totalUnit'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.totalUnit" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in timeUnitList" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.totalUnit }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="editBack" align="center" prop="enabled" label="操作" width="100">
                      <template slot-scope="scope">
                        <!-- <el-button type="text" size="small" v-if="!scope.row.isEdit" @click="handleEditRow(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="scope.row.isEdit" @click="handleSaveRow(scope.row, scope.$index)">保存</el-button> -->
                        <el-button type="text" size="small" @click="handleDelRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="editBack" size="small" class="add-item" type="primary" @click="handleAdd" style="margin-bottom:20px"> + 添加一条运动处方信息</el-button>
                </div>
                <!-- 治疗处方 -->
                <div v-if="form.prescription.type === 5">
                  <el-table
                    :data="form.prescription.itemList"
                    :header-cell-style="{
                      textAlign: 'center',
                      color: '#333333',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      backgroundColor: '#FAFAFA'
                    }"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    fit
                    highlight-current-row>
                    <el-table-column align="center" prop="drugName" label="治疗项目" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <!-- <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugName" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugName'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select
                            v-if="scope.row.isEdit"
                            v-model.trim="scope.row.drugName"
                            :title="scope.row.drugName"
                            filterable
                            remote
                            :remote-method="remotetreatMethod"
                            size="small"
                            @change="
                              val => {
                                changeDrugItem(val, scope.row);
                              }
                            "
                            clearable
                            placeholder="请选择"
                          >
                            <el-option v-for="(item, index) in treatmentList" :key="index" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.drugName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="medicationFrequencyName" label="治疗频率">
                      <template slot-scope="scope">
                        <!-- <el-input v-model.trim="form.medicationFrequencyName" size="small" placeholder=""></el-input> -->
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.medicationFrequencyName'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.medicationFrequencyName" size="small" clearable placeholder="请选择">
                            <el-option v-for="(item, index) in frequencyList" :key="index" :label="item.name" :value="item.name"></el-option>
                          </el-select>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.medicationFrequencyName }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="drugNumber" label="总次数">
                      <template slot-scope="scope">
                        <el-form-item
                          label-width="0px"
                          v-if="scope.row.isEdit"
                          :prop="'prescription.itemList.' + scope.$index + '.drugNumber'"
                          :rules="[
                            {
                              required: true,
                              message: '此项为必填项',
                              trigger: 'blur'
                            },
                            {
                              pattern: /^[1-9][0-9]{0,3}$/,
                              message: '至多4位正整数',
                              trigger: ['change', 'blur']
                            }
                          ]"
                        >
                          <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.drugNumber" size="small" placeholder=""></el-input>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.drugNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="singleTime" label="单次时长">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.singleTime'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1})?$/,
                                message: '保留一位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.singleTime" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.singleTime }}</span>
                          <!-- 单位 -->
                          <!-- <el-input v-model.trim="form.singleUnit" size="small" placeholder=""></el-input> -->
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.singleUnit'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.singleUnit" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in timeUnitList" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.singleUnit }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="totalTime" label="总时长">
                      <template slot-scope="scope">
                        <div class="table-cell-style">
                          <el-form-item
                            label-width="0px"
                            v-if="scope.row.isEdit"
                            :prop="'prescription.itemList.' + scope.$index + '.totalTime'"
                            :rules="[
                              {
                                required: true,
                                message: '必填',
                                trigger: 'blur'
                              },
                              {
                                pattern: /^\d{1,4}(\.\d{1})?$/,
                                message: '保留一位小数，小数点前至多4位',
                                trigger: ['change', 'blur']
                              }
                            ]"
                          >
                            <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.totalTime" size="small" placeholder=""></el-input>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.totalTime }}</span>
                          <!-- 单位 -->
                          <!-- <el-input v-model.trim="form.totalUnit" size="small" placeholder=""></el-input> -->
                          <el-form-item label-width="0px" v-if="scope.row.isEdit" :prop="'prescription.itemList.' + scope.$index + '.totalUnit'" :rules="[{ required: true, message: '必填', trigger: 'blur' }]">
                            <el-select v-if="scope.row.isEdit" v-model.trim="scope.row.totalUnit" size="small" clearable placeholder="请选择">
                              <el-option v-for="(item, index) in timeUnitList" :key="index" :label="item" :value="item"></el-option>
                            </el-select>
                          </el-form-item>
                          <span v-if="!scope.row.isEdit">{{ scope.row.totalUnit }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remarks" label="处方备注" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-form-item label-width="0px" v-if="scope.row.isEdit">
                          <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.remarks" maxlength="200" size="small" placeholder=""></el-input>
                        </el-form-item>
                        <span v-if="!scope.row.isEdit">{{ scope.row.remarks }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="editBack" align="center" prop="enabled" label="操作" width="100">
                      <template slot-scope="scope">
                        <!-- <el-button type="text" size="small" v-if="!scope.row.isEdit" @click="handleEditRow(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" v-if="scope.row.isEdit" @click="handleSaveRow(scope.row, scope.$index)">保存</el-button> -->
                        <el-button type="text" size="small" @click="handleDelRow(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-button v-if="editBack" size="small" class="add-item" type="primary" @click="handleAdd" style="margin-bottom:20px"> + 添加一条治疗处方信息</el-button>
                </div>
                <!-- 其他类别 -->
                <div v-if="form.prescription.type === 6">
                  <el-row :gutter="20">
                    <el-col>
                      <!-- prop="prescription.initDiagnosis" -->
                      <el-form-item label="处方内容：">
                        <el-input v-if="editBack" type="textarea" v-model.trim="form.prescription.initDiagnosis" size="small" maxlength="500" placeholder=""></el-input>
                        <span v-else>{{form.prescription.initDiagnosis}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>  
          </el-form>
        </el-scrollbar>
        <div class="updataBtn" v-if="fillInfo">
          <el-button v-if="editBack == true && ($route.query.inputGroupId || selectFileObj.inputGroupId)" size="mini" style="width:110px;height:32px" @click="cancelEntery(1)">取消录入</el-button>
          <!-- <el-button type="primary" v-if="editBack == true" v-preventReClick size="mini" style="width:110px;height:32px" @click="preservationForm">保存</el-button> -->
          <!-- 诊疗事件下不显示暂存草稿按钮 -->
          <el-button type="primary" v-if="editBack == true && this.routeEntry != 5 && this.routeEntry != 6 && this.routeEntry != 7" v-preventReClick size="mini" style="width:110px;height:32px" @click="saveDraft">
            暂存草稿
            <el-tooltip class="item" effect="dark" content="仅针对当前对照录入进行暂存" placement="top-start">
              <img src="@/assets/images/circle-tips.png" style="width:14px;height:14px;vertical-align:text-bottom"/>
            </el-tooltip>
          </el-button>
          <el-button type="primary" v-if="editBack == true" v-preventReClick size="mini" style="width:110px;height:32px" @click="preservationForm">
            完成录入
            <el-tooltip class="item" effect="dark" content="保存当前对照录入结果" placement="top-start">
              <img src="@/assets/images/circle-tips.png" style="width:14px;height:14px;vertical-align:text-bottom"/>
            </el-tooltip>
          </el-button>
          <el-button type="primary" v-else size="mini" style="width:110px;height:32px" @click="handleEditForm">编辑</el-button>
        </div>
      </div>
      <div v-if="activeName == 'second'" style="height:calc(100% - 50px);">
        <AddTerms :patientFilesItemId="patientFilesItemId" />
      </div>
      <!-- 选择文件 -->
      <div v-if="activeName == 'first' && choseFillInfo" class="questionImg" style="height:calc(100% - 50px);margin-top:40px">
        <div class="fileTitleBack" style="display: flex;justify-content: space-between;">
          <div class="title" style="font-size: 14px;color: #000;border-left: 4px solid #1A7BFC;padding-left: 10px;font-weight: bold;">
            文件列表
          </div>
          <div class="fileBack" style="font-weight: bold;font-size: 14px;color: black;cursor: pointer;margin-right:10%" @click="choseFileBackOn"><span class="el-icon-caret-left"></span>返回上一级</div>
        </div>
        <!-- height:100vh; -->
        <div style="height:70vh;width:100%;">
          <!-- <el-scrollbar style="height: 100%;font-size: 12px;width:100%"> -->
          <div class="changeFile" style="display: flex;padding: 20px;">
            <el-input placeholder="请输入内容" size="mini" prefix-icon="el-icon-search" v-model.trim="searchKey" style="width:25%"></el-input>
            <el-date-picker style="margin:0px 10px;width:40%" v-model.trim="searchTime" type="daterange" align="right" unlink-panels range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="mini"></el-date-picker>
            <el-button size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" size="mini" style="margin-left:10px" @click="searchFrom">搜索</el-button>
            <el-button type="primary" size="mini" style="margin-left:10px" @click="addFilestoArr" v-loading="btnLoading">添加</el-button>
          </div>
          <div class="infoTitle" style="font-size: 12px;color: black;padding: 20px;">
            *可多选
          </div>
          <el-scrollbar style="height: calc(100% - 180px);font-size: 12px;width:100%">
            <div class="infoList" style="display: flex;align-items: center;justify-content: space-between;padding: 20px;" v-for="(item, index) in choseFileList" :key="index">
              <el-checkbox v-model.trim="item.checkTrue"></el-checkbox>
              <div class="fileImg" style="height: 25px;width: 25px;margin:0px 20px;">
                <img style="height: 100%;width: 100%;" :src="item.icon" alt="" />
              </div>
              <div class="fileName" style="flex: 1;font-size: 12px;font-weight: bold;color: black;cursor:pointer" @click="previewAddImg(item.filePath)">
                {{ item.fileName }}
              </div>
              <div class="filePeople" style="color: #666;font-size: 12px;">
                {{ item.uploadUserName }}
              </div>
              <div class="fileTime" style="color: #666;font-size: 12px;margin: 0px 50px;">
                {{ item.createTime }}
              </div>
              <div class="fileRight" style="display: flex;align-items: center;">
                <span style="color: red" class="iconfont icon-point"></span>
                <div>未录入</div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
    <div v-if="showRight && filePicList && filePicList.length" class="right-content" style="position:relative">
      <div class="pdfFiled">
        <div style="margin-bottom:20px">
          <div style="display:flex;flex:1;justify-content:center;margin:0 auto;text-align:center">
            <el-select v-if="fileNameSelect" v-model.trim="selectFileObj" value-key="id" placeholder="请选择" size="mini" style="width:200px" @change="fileChange">
              <el-option v-for="(item, index) in filePicList" :key="index" :label="item.fileName" :value="item"> </el-option>
            </el-select>
            <!-- <el-input v-else placeholder="请输入文件名" maxlength="20" style="width:200px" size="mini" v-model.trim="picName" clearable></el-input> -->
            <div v-if="(editBack || selectFileObj.disabled) && $route.query.isLock != '1' && $route.path != '/customerRoom'">
              <div v-show="selectFileObj && !selectFileObj.disabled" class="invalid-btn" @click="handleSetInvalid(true)">
                <img src="@/assets/images/forbid.png" alt="" />
                标注无效
              </div>
              <div v-show="selectFileObj && selectFileObj.disabled" class="recover-btn" @click="handleSetInvalid(false)">
                <img src="@/assets/images/recover.png" alt="" />
                恢复图片
              </div>
            </div>

            <div v-if="selectFileObj.status == 1 && editBack && $route.query.isLock != '1' && $route.path != '/customerRoom'" class="invalid-btn" @click="handleNoNeedEntry">
              <img src="@/assets/images/no-need-entry.png" alt="" />
              无需录入
            </div>
            <div v-if="editBack && $route.query.isLock != '1' && ocrImportantWordArr.length && $route.path != '/customerRoom'" class="invalid-btn" @click="handleShowInstance">
              <img src="@/assets/images/instance.png" alt="" />
              单据样例
            </div>
          </div>
          <div class="pic-option-row">
            <!-- disabled -->
            <el-button v-if="!$route.query.enterType" round size="mini" :disabled="currentFilesIndex == 0 || !allPatientFilesItem.length" @click="getPreviousFile">上一张</el-button>
            <div v-if="editBack" style="margin:0 auto">
              <!-- <span class="el-icon-edit edit-pic-btn" v-if="fileNameSelect" @click="editFileName"></span>
              <span class="el-icon-check edit-pic-btn" v-else @click="updateFimeName"></span> -->
              <span class="el-icon-delete del-file-btn" @click="deleteFileItem"></span>
              <el-button v-if="selectFileObj && !selectFileObj.disabled" round size="mini" @click="addFilesList">新增图片</el-button>
              <!-- :disabled="!editBack || !form.eventName || !form.type || ocrFlag" -->
              <!-- :disabled="!editBack || !form.eventName || !form.type || ocrFlag" -->
              <el-button v-show="!ocrRecognizeUrl" round size="mini" @click="clickOCRDiscern">开始OCR识别智能填入</el-button>
              <el-button v-show="ocrRecognizeUrl" round size="mini" @click="clickOCRDiscern">重新进行OCR识别智能填入</el-button>
            </div>
            <el-button v-if="!$route.query.enterType" round size="mini" :disabled="currentFilesIndex == allPatientFilesItem.length - 1 || !allPatientFilesItem.length" @click="getNextFile">下一张</el-button>
          </div>
        </div>
        <div class="imgFiled">
          <el-carousel trigger="click" arrow="never" indicator-position="none">
            <el-carousel-item style="display:flex;flex:1">
              <!-- width:500px;height:500px -->
              <div
                @mousedown="move"
                style="flex:1;"
                class="move-position"
                @mousewheel="handleZoomImg"
                :style="{
                  backgroundImage: 'url(' + imgOss + previewPicturesUrl + ')',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  transform: isPreview ? `rotate(${rightcountDeg}deg) scale(${(zoomIndex / 10) * 1})` : `rotate(${rightcountDeg}deg)`
                }"
              ></div>
              <div v-if="ocrRecognizeUrl && !showOcrText" style="flex:1;">
                <!-- <img :src="ocrRecognizeUrl"/> -->
                <el-image :src="ocrRecognizeUrl" fit="contain"></el-image>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="swap-ocr" @click="changeOcrTag">
            <img src="@/assets/images/swap.png" alt="" />
            <span v-if="showOcrText">切换图片</span>
            <span v-else>切换文本</span>
          </div>
        </div>
        <div>
          <span style="text-align:center;margin-top:10px;display:block">
            <el-button v-if="editBack" @click="leftRotate">左旋转</el-button>
            <el-button v-if="editBack" @click="rightRotate">右旋转</el-button>
            <el-button v-if="(routeEntry == 1 || routeEntry == 2 || routeEntry == 3) && $route.path != '/customerRoom'" @click="sendToCurrentPatient">发送给当前患者</el-button>
          </span>
        </div>
      </div>
    </div>
    <div v-if="routeEntry != 5 && routeEntry != 7 && showOcrText" class="ocr-text-wrapper" style="flex:1;">
      <div class="folder-wrapper">
        <div @mousedown="moveSelect" style="flex:1;padding:5px 0">
          <i class="el-icon-rank" style="font-size:24px"></i>
          <!-- <i class="el-icon-zoom-out" @click="handleFolderOcrText"></i> -->
        </div>

        <div v-show="openOcrTextStatus" @click="handleFolderOcrText">折叠<i class="el-icon-arrow-up"></i></div>
        <div v-show="!openOcrTextStatus" @click="handleFolderOcrText">展开<i class="el-icon-arrow-down"></i></div>
      </div>
      <div v-if="openOcrTextStatus" class="ocr-text">
        <el-scrollbar style="height: 100%;width:100%">
          <div class="exact-recognize">
            <span class="title">
              精准识别
            </span>
            <!-- <div v-for="(item, index) in ocrRecognizeResult" :key="index" style="line-height:20px">
              <span>{{ index + 1 }}、</span><span>{{ item.name }}</span
              >：<span>{{item.inputValue}}</span>
            </div> -->
            <div
            v-for="(item, index) in ocrRecognizeResult"
            :key="index"
            style="line-height:20px;display:flex"
          >
            <div style="width:30px">{{ index + 1 }}、</div>
            <div style="flex:1">
              <span>{{ item.name }}</span>
              <span v-if="item.html || item.inputValue">：</span>
              <span v-if="item.html" v-html="item.html"></span>
              <span v-else>{{item.inputValue}}</span>
              <!-- <span style="display:inline-block;margin-left:15px">{{item.ocrRange}}</span> -->
            </div>
          </div>
          </div>
          <div class="exact-recognize">
            <span class="title">模糊识别</span>
            <div v-for="(item, index) in textList" :key="index" style="line-height:20px">
              <span>{{ index + 1 }}、</span><span>{{ item }}</span>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>

    <!-- 查看图片大图 -->
    <!--  @change="changeImgUrl" -->
    <el-dialog :visible.sync="showLargePic" :close-on-click-modal="false" append-to-body title="查看图片">
      <div class="dialog-carousel-content">
        <div class="update-add-imgName">
          <span>图片名称：</span>
          <el-input type="text" size="small" placeholder="请输入图片名称" v-model.trim="addPicName"></el-input>
          <el-button type="primary" size="small" @click="updateAddPicName">确定</el-button>
        </div>
        <!-- <img width="100%" :src="picUrl" alt=""> indicator-position="outside" style="display: flex !important;align-items: center;justify-content: center;" -->
        <el-carousel ref="carouselRef" trigger="click" :autoplay="false" indicator-position="outside" @change="changeAddPic">
          <el-carousel-item v-for="(item, index) in choseFileList" :key="index" :name="index + ''" style="display: flex !important;align-items: center;justify-content: center;">
            <img style="height:100%" :src="imgOss + item.filePath" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <!-- && editBack -->
    <!-- 录入提示（弹框显示时已经解锁） enteryTipStatus  @close.native="cancelEntery(1)"-->
    <el-dialog :visible.sync="enteryTipStatus" :close-on-click-modal="false" append-to-body width="600px" :show-close="false" title="录入提示">
      <!-- x小时 -->
      <div class="entry-time-tips">
        当前你在2小时内未完成对此图片的录入，是否继续录入？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelEntery(1)">取消录入</el-button>
        <el-button type="primary" size="small" @click="continueEntery">继续录入</el-button>
      </span>
    </el-dialog>

    <!-- 新建病程 -->
    <!-- <NewCourse v-if="showNewCourse" :showNewCourse="showNewCourse" :basicOcrObj="basicOcrObj" :kinsFolkForm="kinsFolkForm" :itemBelong="form.itemBelong" @closeNewCourse="closeNewCourse" @searchArchivesEvent="searchArchivesEvent"/> -->
    <!-- 填入历史记录 -->
    <HistoryRecord v-if="showHistoryRecord" :showHistoryRecord="showHistoryRecord" :selectStandardRow="selectStandardRow" @receiveStandardValue="receiveStandardValue" @closeHistoryRecord="closeHistoryRecord" />
    <!-- 样例查看 -->
    <FileInstanceModal v-if="showInstance" :showInstance="showInstance" @handleCloseInstance="handleCloseInstance" :previewPicturesUrl="previewPicturesUrl" :ocrImportantWordArr="ocrImportantWordArr"></FileInstanceModal>
  </div>
</template>
<script>
import FileInstanceModal from "@/components/CrossReferenceEntry/FileInstanceModal.vue";
import NewCourse from "@/components/CrossReferenceEntry/NewCourse.vue";
import HistoryRecord from "@/components/CrossReferenceEntry/HistoryRecord.vue";
import { unlockInGroupFile, lockInGroupFile } from "@/api/enteryDetailPage";
import local from "@/utils/local.js";
import { getRelativeByPatientId } from "@/api/Patientmanagement.js";
import moment from "moment";
// import axios from "axios";
import { ocrRecord, ocrRecordDetail, getOcrLog, disableInvalid, saveInspectRow, getOcrLogNew, getOcrLogText, getPatientFocusFieldSearchPage,
  archivesEventPage,pageStandardField,getNewByRefId,saveCrossEntry,getSelectStandardValue,inspectionInfoFocus,standardFiledFocus,getNewByEventMedicalId,
  archivesDetail,markFocus,getAllSpecimenTypeList,push,pushPic,noPushOcrAnomaly } from "@/api/crossreentry";
import RelateChain from "@/views/treatment/components/CrossReferenceEntry/RelateChain.vue";
import AddTerms from "@/views/treatment/components/CrossReferenceEntry/AddTerms.vue";
import { DEEP_CLONE } from "@/utils/constants";
import { getArchivesEventLog, getPlaceList, medication_frequency, standard_list, movement_list, treatment_list, apiGetPatientFiles, 
  api_getOtherFiles, api_patient_files, apiGetPatientById, api_getdrug, api_inspection, api_operate_position,
  getDepartmentList, api_part_orientation, getInspectionInfoPageByName, api_shoot_orientation } from "@/views/treatment/components/CrossReferenceEntry/api.js";

import {
  // getArchivesEventLog,
  apiAddArchives,
  apiUpdateArchives,
  getDrugList,
  getArchivesList,
  getHospitalList,
  saveContent,
  // getDepartmentList,
  getFrequency,
  getSpecs,
  getRoute,
  getMoveType,
  getMoveItem,
  getTreatmentList,
  // getPlaceList,
  // getInspectionInfoPageByName
} from "@/views/newPatientmanage/api/treatmentPlan.js";

export default {
  components: {
    AddTerms,
    RelateChain,
    KinsfolkInfo: () => import("@/components/KinsfolkInfo.vue"),
    NewCourse,
    HistoryRecord,
    FileInstanceModal
  },
  props: {
    routeEntry: {
      type: Number
    },
    // 是否显示右侧部分
    showRight: {
      type: Boolean,
      default: true
    },
    freshReferenListStatus: {
      type: Boolean,
      default: false
    },
    // 病历夹列表
    medicalFolderList: {
      type: Object,
      default: () => {}
    },
    // 外层对照录入列表选中tab
    activeTabName: {
      type: String
    },
    // 外层对照录入列表点击选中的文件
    crossReferenItem: {
      type: Object,
      default: () => {}
    },
    // 无效列表
    invalidFileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let checkRecipeDay = (rule, value, callback) => {
      if (this.form.prescription.genre === "短期" && !value) {
        callback(new Error("此项为必填项"));
      } else {
        callback();
      }
    };
    return {
      ocrTime: '',
      allInspectTableData: [],
      referencesOptions: [],
      ocrImportantWordArr: [],
      showInstance: false,
      resetCascader: 0,
      newCourseTime: Date.now(),
      formRules: {
        reportName: [{ required: true, message: "此项为必填项", trigger: ["change"] }],
        "prescription.type": [
          { required: true, message: "此项为必填项", trigger: ["change"] }
        ],
        "prescription.genre": [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],

        // 'drugName':[{ pattern: /[\u4e00-\u9fa5]/, message: '请输入中文', trigger: ['change', 'blur'] }],
        "prescription.day": [
          {
            pattern: /^[1-9]\d{0,2}$/,
            message: "最多三位的正整数",
            trigger: ["change", "blur"]
          },
          { validator: checkRecipeDay, trigger: ["change", "blur"] }
        ],

        "prescription.initDiagnosis": [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ],
        // "prescription.drugType": [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],
        // 'prescription.securityCategory':[{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        // "prescription.certificate": [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],
        // "prescription.chineseDrugUsage": [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],
        // "prescription.chineseDrugFrequency": [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],
        // "prescription.asingleDose": [
        //   {
        //     required: true,
        //     message: "此项为必填项",
        //     trigger: ["change", "blur"]
        //   }
        // ],

        "prescription.energyKcal": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.carbohydrate": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.fat": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.protein": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.purine": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.df": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.iron": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.calcium": [
          {
            pattern: /^\d{1,4}(\.\d{1,2})?$/,
            message: "保留两位小数，小数点前至多4位",
            trigger: ["change", "blur"]
          }
        ],
        "prescription.remarks": [
          {
            required: true,
            message: "此项为必填项",
            trigger: ["change", "blur"]
          }
        ]
      },
      foldStandard: true,
      foldInspect: true,
      foldDrug: true,
      originalEntryInfo: {},
      basicOcrObj: [],
      VUE_APP_WECHATBASE_URL: '/api/dsicm-contact-platform/feign/file/upload',
      dosageList: [
        "每次一剂",
        "每次两剂",
        "每次三剂",
        "每次四剂",
        "每次五剂",
        "两次一剂",
        "三次一剂",
        "四次一剂",
        "五次一剂",
        "三次两剂",
        "三次四剂",
        "其他用量"
      ],
      lookAddPicObj: {},
      addPicName: '',
      selectAddressProp: {
        value: "name",
        label: "name",
        children: "children"
      },
      frequencyList: [],
      unitList: [],
      routeList: [],
      moveTypeList: [],
      // moveItemList: [],
      treatmentList: [],

      ocrTableTimer: '',
      ocrTableCount: 0,
      ocrTextTimer: '',
      ocrTextCount: 0,

      saveCategoryList: ["甲类", "乙类", "暂未知"],
      medicineTypeList: ["处方药", "非处方药"],
      timeUnitList: ["时", "分", "秒"],
      standardFieldList: [],
      fieldCurrent: 1,
      fieldPages: 20,   
      fieldItemQuery: '',
      // standardTable: [],
      // inspectionTable: [],
      archivesEventData: [],
      courseTime: [
        moment().subtract(3, "months").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      ],
      showNewCourse: false,
      // tableData: [],
      // unitList: ['g','kg'],
      enteryTipStatus: false,
      picUrl: "",
      showLargePic: false,
      selectFileObj: {},
      kinsFolkForm: null,
      dsicmType: null,
      // precount: 0,
      // preOcrtimer: "",
      // 是否开启尺寸修改
      resizeable: false,
      // 鼠标按下时的坐标，并在修改尺寸时保存上一个鼠标的位置
      clientX: 0,
      clientY: 0,
      // div可修改的最小宽高
      // minW: 8,
      // minH: 8,
      // 鼠标按下时的位置，使用n、s、w、e表示
      // direc: "",

      openOcrTextStatus: false,
      
      resultPropertyObj: {
        0: "定性",
        1: "定量",
        2: "描述"
      },
      prescriptionTypeObj: {
        1: "西药处方",
        2: "中药处方",
        3: "营养处方",
        4: "运动处方",
        5: "治疗类处方",
        6: "其他",
      },
      exceptionRecordObj: {
        0: "异常",
        1: "偏高",
        2: "偏低",
        3: "正常"
      },
      recognizeStatus: 0,
      textList: [],
      patientFilesId: "",
      ocrRecognizeUrl: "",
      ocrtimer: "",
      activeName: "first",
      sexObj: {
        0: "未知",
        1: "男",
        2: "女"
      },
      partOrientationList: [],
      shootOrientationList: [],
      isAnswerPlan: true,
      typeFlag: true,
      positionX: 0,
      positionY: 0,
      zoomIndex: 10,
      isPreview: false,
      previewPicturesUrl: "",
      picName: "",
      // departmentList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //选当前时间之前的时间
        }
      },
      fileNameSelect: true,
      loading: false,
      fillInfo: true,
      // crossReferenceEntry: false,
      choseFillInfo: false,
      form: {
        medicalCase: {}, //病历
        prescription: { itemList: [], dosage: "每次一剂", totalDoseUnit: "剂"}, //处方层
        patientMedicalDocs: {
          patientCheckoutDTOS: [],
          checkScansArr: []
        }, //其他层
        patientFilesItem: {},
        prentype: 0,
        itemBelong: 1,
        type: null,
        patientName: '',
        age: null,
        sex: null,
        standardTable: [],
        inspectionTable: [],
        specimenType: '',
        draftId: '',
      },
      inspectionList1: [],
      editBack: true, //反显
      // itemList: [],
      // pushMedicalDocs: {}, //添加检验类别对象
      // pushMedicalDocsList: [], //检验类别数组
      inspectionList: [], //检验项目数组
      pushCategory: "",
      // categoryChose: false, //添加检验
      // prescriptionChose: false, //添加西药
      // chineseMedicine: false, //添加中药
      // sportData: false, //添加运动处方
      // treamentShow: false, //添加治疗处方
      // inputValue: "", //检查结果
      // hospitalList: [], //医院数组
      // departList: [], //科室数组
      // categoryIndex: "", //检验列表点击得索引
      // addPrescription: {}, //新增西药对象
      // medicationList: [], //西药频率
      // drugUnitList: [], //西药单位
      // administrationList: [], //西药用法
      // chineseMedicineObj: {}, //新增中药对象
      standardList: [], //运动类型数组
      movementList: [], //运动项目数组
      // addCategoryObj: {}, //新增运动处方对象
      // treatmentObj: {}, //新增治疗处方对象
      treatmentList: [], //治疗项目数组
      archivesIdarr: [], //关联病程数组
      patientFilesItemId: "",
      fileListArr: [],
      filePicList: [],
      // selectFileObj: {},
      imgOss: process.env.VUE_APP_OSS_URL, //图片公用拼接地址
      searchTime: "",
      searchKey: "",
      btnLoading: false,
      choseFileList: [],
      fileObjId: [],
      selectFileObj: {},
      // value: "",
      druglist: [],
      // pushTab: 1,
      drugIndex: 0, //drug索引
      // deleteDom: false,
      checkPrArr: [], //检查部位数组
      hospitalDays: "", //住院天数
      archivesEventLog: [],
      directRotate: "",
      rightcountDeg: 0,
      count: 0,
      showOcrText: true,
      ocrRecognizeResult: [],
      ocrFlag: false,
      codePage: {
        current: 1,
        size: 20
      },
      itemQuery: "",
      pages: 0,
      allPatientFilesItem: [],
      currentFilesIndex: 0,
      // mapElem: "",
      ocrRecflag: false,
      moveDistance: {},
      showKinsPop: false,
      defaultAddImgIndex: 0,
      showHistoryRecord: false,
      selectStandardRow: {},
      selectArchivesEvent: {},
      drugList: [],
      specimenTypeData: [],
      cloneStandardFieldList: [],
      cloneInspectionList: []
    };
  },
  filters: {
    // processOne(data) {
    //   if (data) {
    //     return data.split("      ")[0];
    //   }
      
    // },
    // processTwo(data) {
    //   if (data) {
    //     return data.split("      ")[1];
    //   }
      
    // }
  },
  sockets: {
    // 接收socket推送的事件
    patientInputGroupAutoUnLock(data) {
      if (typeof data === "string") {
        let recieveInputGroupId = JSON.parse(data).result.data;
        // console.log(recieveInputGroupId)
        if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
          if (recieveInputGroupId == (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId)) {
            this.enteryTipStatus = true;
          }
        }
      }
    }
  },
  watch: {
    "form.specimenType": {
      handler(newVal, oldVal) {
        this.getInspectionItemList()
      },
      deep: true
    }
  },

  async created() {
    // console.log(this.showRight)
    this.getInitData()
    this.getAllSpecimenTypeData()
    this.getFieldList()
    // this.getInspectionItemList()
    this.selectFileObj = this.crossReferenItem
    if (this.selectFileObj.disabled) {
      this.editBack = false;
      this.isAnswerPlan = false; // 不显示编辑保存
    }

    await this.getKinsFolk()
    // // 清除定时器
    // this.ocrTextCount = 0
    // clearInterval(this.ocrTextTimer)
    // this.ocrTextTimer = ""
    // this.ocrTableCount = 0
    // clearInterval(this.ocrTableTimer)
    // this.ocrTableTimer = ""

    await this.searchArchivesEvent()
    console.log(this.crossReferenItem.status,"this.crossReferenItem.status");
    // ---------------疗程管理——对照录入------------------
    if (this.routeEntry == 1) {
      this.editBack = false;
      this.isAnswerPlan = false; // 不显示编辑保存
      if (this.crossReferenItem.status == 1) {
        await this.noEntryData(this.crossReferenItem)
      }
      if (this.crossReferenItem.status == 2 || this.crossReferenItem.status == 5) {
        await this.yetEntryData(this.crossReferenItem)
      }
    }
    // 
    if (this.routeEntry == 2) {
      this.editBack = false;
      this.isAnswerPlan = false; // 不显示编辑保存
      if (this.crossReferenItem.status == 1) {
        await this.noEntryData(this.crossReferenItem)
      }
    }
    if (this.routeEntry == 3) {
      if (this.crossReferenItem.status == 1) {
        await this.noEntryData(this.crossReferenItem)
      }
      if (this.crossReferenItem.status == 2 || this.crossReferenItem.status == 5) {
        await this.yetEntryData(this.crossReferenItem)
      }
    }
    // ---------------病人管理——诊疗事件------------------
    if (this.routeEntry == 5) {
      this.form.patientName = JSON.parse(sessionStorage.getItem('patientInfo')).name
      this.form.age = JSON.parse(sessionStorage.getItem('patientInfo')).age
      this.form.sex = JSON.parse(sessionStorage.getItem('patientInfo')).sex
      this.clickArchivesEvent(this.selectArchivesEvent)
    }
    // 查看诊疗事件--带图片 已录入
    if (this.routeEntry == 6) {
      await this.refeDialog(this.crossReferenItem)
    }
    if (this.routeEntry == 7) {
      await this.refeDialog(this.crossReferenItem)
    } 
    // --------------录入管理（入录列表、我的录入）-------------------
      // 已完成的，本人录入的可以修改，非本人只能查看
      // 录入列表（被锁看不了，只有没被锁可以录入）
      // 我的录入（被锁住的只能查看，没被锁可以录入）
      // 我的录入-无效文件 （查看无效图片）
      // // 查看/编辑状态 (已完成录入的入录列表的本人录入的可以编辑保存)
      if (this.$route.query.enterType && this.crossReferenItem.status == 2 && !this.crossReferenItem.nowUserStatus || this.$route.query.isLock == 1) {
        // console.log('查看非自己录入的')
        // debugger
        this.editBack = false;
        this.isAnswerPlan = false; // 不显示编辑保存
      }

      if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
        if (this.crossReferenItem.status == 1) {
          await this.noEntryData(this.crossReferenItem)
        }
        if (this.crossReferenItem.status == 2 || this.crossReferenItem.status == 5) {
          await this.yetEntryData(this.crossReferenItem)
        }
        if (this.selectFileObj.disabled) {
          this.editBack = false;
          this.isAnswerPlan = false; // 不显示编辑保存
        }
      }
      

      if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
        this.$socket.emit("setPatientInputGroupId", this.$route.query.inputGroupId || this.selectFileObj.inputGroupId);
      }

      // 处理上一张下一张所需列表数据
      this.getPatientFilesItemData(JSON.parse(sessionStorage.getItem("patientInfo")).patientId)
      // this.getConditionList();
      this.getFrequencyList()
    
    // console.log(this.form,'录入数据')
  },
  mounted() {},
  methods: {
    // 发送给当前患者
    async sendToCurrentPatient() {
      let res = await pushPic({
        patientFilesItemId: this.selectFileObj.id,
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId
      })
      if (res.code == 0) {
        this.$message.success('成功发送当前患者')
      } else {
        this.$message.error(res.msg)
      }
    },
    // 暂存草稿
    async saveDraft() {
      if (!this.selectArchivesEvent.id) {
        this.$message.error("请选择病程");
        return;
      }
      if (!this.form.type) {
        this.$message.error("请选择记录类型");
        return;
      }
      if (this.showNewCourse) {
        this.$message.error("请先保存病程");
        return;
      }
      if (this.form.inspectionTable.length && !this.form.specimenType) {
        this.$message.error("请选择标本类型")
        return
      }
      this.form.standardTable = this.form.standardTable.map(item => {
        if ((item.dataType == '字符串' || item.dataType == '富文本') && typeof item.inputValue == 'string' && item.inputValue.match(/^[ ]*$/)) {
          item.inputValue = item.inputValue.replace(/\s+/g, '')
        }
        return {
          ...item
        }
      })
      
      // // 校验标准字段表格
      // try {     
      //   this.form.standardTable.forEach(v => {
      //     if (!v.standardFieldName || !v.inputValue)  throw new Error("请补全标准字段或字段值")
      //   })
      // } catch (e) {
      //   if (e.message == '请补全标准字段或字段值') {
      //     return this.$message.error('请补全标准字段或字段值');
      //   }
      // }
      // // 校验检验表格
      // try {     
      //   this.form.inspectionTable.forEach(v => {
      //     if (!v.name || !v.inputValue)  throw new Error("请补全检验项目或检验结果")
      //   })
      // } catch (e) {
      //   if (e.message == '请补全检验项目或检验结果') {
      //     return this.$message.error('请补全检验项目或检验结果');
      //   }
      // }

      // let isPassStandard = this.form.standardTable.filter(v => v.isEdit)
      // if (isPassStandard.length) {
      //   this.$message.error("请保存标准字段表格数据");
      //   return;
      // }

      // let isPassInspect = this.form.inspectionTable.filter(v => v.isEdit)
      // if (isPassInspect.length) {
      //   this.$message.error("请保存检验表格数据");
      //   return;
      // }

      // this.$refs.formRef.validate(async (valid) => {
        // if (valid) {
          // let names = this.form.inspectionTable.map(item => item["name"]);
          // let nameSet = new Set(names);
          
          // if (nameSet.size == names.length) {
          //   // console.log("没有重复值");
          // } else {
          //   // console.log("有重复值");
          //   this.$message.error("检验项目不可重复");
          //   return;
          // }

          // 保存新增的检验项目或者检验单位
          for (const row of this.form.inspectionTable) {
            row.specimenType = this.form.specimenType
            // 数据库里没有检验项目，手动新增的数据，需要保存(addItem为true)，保存检验项目和单位
            // if (row.addItem) {
            //   // let res = await saveInspectRow({
            //   //   type: 1,
            //   //   name: row.name,
            //   //   doseUnit: row.doseUnit,
            //   //   imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
            //   //   exceptionRecord: row.exceptionRecord,
            //   //   inputValue: row.inputValue,
            //   //   sourceType: 1
            //   // });
            //   // if (res.code == 0) {
            //   //   row.id = res.data.id;
            //   //   row.addItem = false;
            //   // }
            // } else {
            //   // 数据库里没有单位，需要保存
            //   if (row.addUnit && row.doseUnit) {
            //     let res = await saveInspectRow({
            //       type: 2,
            //       name: row.name,
            //       doseUnit: row.doseUnit,
            //       imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
            //       exceptionRecord: row.exceptionRecord,
            //       inputValue: row.inputValue,
            //       sourceType: 1
            //     });
            //     if (res.code == 0) {
            //       // row.id = res.data.id
            //       row.addUnit = false;
            //     }
            //   }
            // }
          }

          if (!this.typeFlag) return;
          this.typeFlag = false;

          // this.form.fileItemList = this.form.fileList.filter(v => v.disabled == false);

          // if (this.form.fileItemList.length == 0) {
          //   this.form.fileItemList = [this.form.fileList[0]];
          // }
          // this.form.clinicalEvents = 1;
          let patientInputGroupIdVal = null;
          let clinicalEvents = 0
          // 诊疗事件不加锁
          if (this.routeEntry == 5 || this.routeEntry == 7) {
            clinicalEvents = 1
          } else {
            if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
              patientInputGroupIdVal = this.$route.query.inputGroupId ? this.$route.query.inputGroupId : this.selectFileObj.inputGroupId;
            }
          }
          // console.log('this.originalEntryInfo:',this.originalEntryInfo);
          let standardTableClone = DEEP_CLONE(this.form.standardTable)
          standardTableClone.forEach(v => {
            if (v.inputValue instanceof Array) {
              v.inputValue = v.inputValue.join(',')
            }
            if (v.inputValue === true) {
              v.inputValue = '是'
            }
            if (v.inputValue === false) {
              v.inputValue = '否'
            }
            delete v.selectDataList
            delete v.standardFieldIdObj
          })
          // console.log(this.originalEntryInfo,'this.originalEntryInfo')
          saveCrossEntry({
            clinicalEvents: clinicalEvents,
            type: this.form.type,
            patientInputGroupId: patientInputGroupIdVal,
            ocrJsonDTO: {
              prescription: this.form.prescription,
              ocrBasicInfoDTOS: standardTableClone,
              ocrInspectDTOS: this.form.inspectionTable
            },
            archivesEventId: this.selectArchivesEvent.id,
            fileItemList: this.form.fileList,
            eventName: this.selectArchivesEvent.eventName,
            patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id,
            // // 修改的情况
            // 查询返回的id
            id: this.form.id,
            // 老的archivesEventId
            oldArchivesEventId: this.originalEntryInfo.draftArchivesEventId,
            // 新的（记录类型相同，取返回的refId；类型不同，为空）
            // 有图片的时候切换type也要传入this.form.refId
            eventMedicalId: this.originalEntryInfo.type == this.form.type ? this.form.refId : (this.previewPicturesUrl ? this.form.refId : null),
            patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
            reportName: this.form.reportName,
            specimenType: this.form.specimenType,
            draft:true,
            draftId:this.form.draftId
          })
            .then(res => {
              this.typeFlag = true;
              if (res.code == 0) {
                // console.log(res.data,'打印');
                if (clinicalEvents == 0) {
                  // 保存后记录保存id、archivesEventId、originalEntryInfo
                  this.form.id = res.data.id
                  this.form.draftId = res.data.draftId
                  // this.form.archivesEventId = res.data.archivesEventId
                  this.originalEntryInfo.archivesEventId = res.data.archivesEventId
                  this.originalEntryInfo.draftArchivesEventId = res.data.draftArchivesEventId
                  this.form.type = res.data.type
                  this.originalEntryInfo.type = res.data.type
                  this.form.refId = res.data.refId
                  this.filePicList = res.data.fileList
                }

                // 保存后刷新文件下拉列表名称
                // this.filePicList.forEach(v => {
                //   v.fileName = this.form.reportName
                // })


                if (this.routeEntry == 5 || this.routeEntry == 7 || this.routeEntry == 6) {
                  // 关闭弹框
                  this.$emit("clickClose")
                  // 刷新病人管理诊疗事件
                  this.$emit("getArchivesEvent")
                }
                // this.crossReferenceEntry = false
                this.editBack = false;
                // 表格置为查看状态
                
                // this.form.standardTable = this.form.standardTable.map(item => {
                //   return {
                //     ...item,
                //     inputValue: JSON.stringify(item.inputValue).indexOf('\n') ? item.inputValue.replace(/\n/g, '<br/>') : item.inputValue
                //   }
                // })
                this.form.standardTable.forEach(v => {
                  if ((v.dataType == '字符串' || v.dataType == '富文本')) {
                    v.inputValue = JSON.stringify(v.inputValue).indexOf('\n') ? v.inputValue.replace(/\n/g, '<br/>') : v.inputValue
                  }
                  this.$set(v,'isEdit',false)
                })
                this.allInspectTableData = this.form.inspectionTable
                this.form.inspectionTable.forEach(v => {
                  this.$set(v,'isEdit',false)
                })
                if (this.form.prescription.itemList) {
                  this.form.prescription.itemList.forEach(v => {
                    this.$set(v,'isEdit',false)
                  })
                }
                this.patientFilesId = res.data.id;
                // clearInterval(this.ocrtimer);
                // clearInterval(this.preOcrtimer);
                // 清除定时器
                this.ocrTextCount = 0
                clearInterval(this.ocrTextTimer)
                this.ocrTextTimer = ""
                this.ocrTableCount = 0
                clearInterval(this.ocrTableTimer)
                this.ocrTableTimer = ""

                clearInterval(this.ocrtimer);
                this.ocrtimer = "";
                this.count = 0;
                this.ocrFlag = false;

                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                // 入录详情列表刷新
                if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
                  this.$parent.handleTabClick();
                }
                // 疗程管理--对照录入列表刷新
                if (this.routeEntry == 3) {
                  // 刷新病历夹列表
                  this.$emit("searchFolder")
                }


                // 异常指标提示(保存后触发)
              } else {
                this.$message.error(res.message);
                this.loading = false;
              }
            })
            .catch(e => {
              this.typeFlag = true;
              this.loading = false;
            });
        // } else {
        //   this.$message.error("请填写必填项");
        //   return false
        // }
      // });
    },
    
    async standardFieldFilter(val, row) {
      // standardFieldList
      // console.log(val)
      // // this.getFieldList(val)
      // this.value = val;
      // row.standardFieldIdObj = val
      if (val) { //val存在
        // this.getFieldList(val)
        // this.standardFieldList = this.cloneStandardFieldList.filter((item) => {
        //   if (item.alias.indexOf(val) != -1) {
        //     return true
        //   }
        // })

        let res = await getPatientFocusFieldSearchPage({
          patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
          // current: current,
          // size: 20,
          nameLike: val,
          regionId: 1 // 1 非检验 4检验
        });
        if (res.code == 0) {
          this.standardFieldList = res.data;
          // this.cloneStandardFieldList = res.data
          let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
          this.standardFieldList.forEach(v => {
            if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
              // v.disabled = true
              this.$set(v,'disabledStandard',true)
            } else {
              this.$set(v,'disabledStandard',false)
            }
          })

          // this.fieldPages = res.data.pages;
        }
      }
      else { //val为空时，还原数组
        // console.log('val为空时，还原数组11')
        this.standardFieldList = this.cloneStandardFieldList

        let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
        this.standardFieldList.forEach(v => {
          if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
            // v.disabled = true
            this.$set(v,'disabledStandard',true)
          } else {
            this.$set(v,'disabledStandard',false)
          }
        })
      }
    },
    async itemDataFilter(val,row) {
      // row.definitionItemId = val
      if (val) { //val存在
        if (this.form.specimenType) {
          let res = await getPatientFocusFieldSearchPage({
            // current: 1,
            // size: 20,
            nameLike: val,
            patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
            regionId: 4,
            specimenType: this.form.specimenType
          });
          if (res.code == 0) {
            this.inspectionList = res.data
            let inspectFocusFieldIds = this.form.inspectionTable.map(v => v.focusFieldId)
            // console.log(inspectFocusFieldIds)
            this.inspectionList.forEach(v => {
              if (inspectFocusFieldIds.indexOf(v.focusFieldId) != -1) {
                // v.disabled = true
                this.$set(v,'disabledItem',true)
              } else {
                this.$set(v,'disabledItem',false)
              }
            })
          }
        }
      } 
      else { //val为空时，还原数组
        // console.log('val为空时，还原数组22')
        this.inspectionList = this.cloneInspectionList
        let inspectFocusFieldIds = this.form.inspectionTable.map(v => v.focusFieldId)
        // console.log(inspectFocusFieldIds)
        this.inspectionList.forEach(v => {
          if (inspectFocusFieldIds.indexOf(v.focusFieldId) != -1) {
            // v.disabled = true
            this.$set(v,'disabledItem',true)
          } else {
            this.$set(v,'disabledItem',false)
          }
        })
      }
    },
    changeSpecimenType(val) {
      // this.getInspectionItemList()
      this.form.inspectionTable = this.allInspectTableData.filter(v => v.specimenType == val || !v.specimenType)
      // console.log(this.form.inspectionTable)
      // 检验有数据，specimenType值为null（历史数据）的情况
      // if (this.form.inspectionTable.length == 0) {
      //   this.form.inspectionTable = this.allInspectTableData
      //   this.form.inspectionTable.forEach(v => {
      //     v.specimenType = val
      //   })
      // } else {
      //   this.form.inspectionTable.forEach(v => {
      //     this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
      //     this.$set(v,'isEdit',true)
      //   })
      // }
      this.form.inspectionTable.forEach(v => {
        this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
        this.$set(v,'isEdit',true)
      })
    },
    // 获取标本类型列表
    async getAllSpecimenTypeData() {
      let res = await getAllSpecimenTypeList()
      if (res.code == 0) {
        this.specimenTypeData = res.data
      }
    },
    // 一张单据时，清空删除数据
    // 多张单据时，清空当前停留单据的编辑的内容（修改的）
    // 无需录入
    async handleNoNeedEntry() {
      // console.log(this.currentFilesIndex)
      // return
      if (this.routeEntry == 3) {
        let res = await markFocus({
        id: this.selectFileObj.id,
        focus: false
      })
        if (res.code == 0) {
          // console.log(this.allPatientFilesItem,'allPatientFilesItem这是录入任务所有的图片')
          if (this.allPatientFilesItem.length == 1) {
            this.$emit("clickClose");
          } else {
            if (this.filePicList.length == 1) {
              if (this.currentFilesIndex ==  this.allPatientFilesItem.length -1) {
                // this.allPatientFilesItem.splice(this.currentFilesIndex, 1);
                this.currentFilesIndex = -1
                // 跳到第一张
                this.getNextFile()
              } else {
                this.allPatientFilesItem.splice(this.currentFilesIndex, 1);
                this.currentFilesIndex = this.currentFilesIndex - 1
                // 跳到下一张
                this.getNextFile()
              }
            } else {
              // console.log(this.currentFilesIndex)
              // 添加多张图片
              let noNeedEntryIndex = this.allPatientFilesItem.findIndex(item => {
                return item.id === this.selectFileObj.id
              })
              this.allPatientFilesItem.splice(noNeedEntryIndex, 1)
              // this.filePicList.
              this.filePicList.map((item, index) => {
                if (item.id == this.selectFileObj.id) {
                  this.filePicList.splice(index, 1)
                }
              })
              this.selectFileObj = this.filePicList[0]
              this.fileChange(this.filePicList[0],'noneed')
            }
          }
          // 刷新录入任务列表
          this.$emit("searchFolder")
        }
        // console.log(this.$store.state.allEntryFormData)
        this.form = this.$store.state.allEntryFormData
        if (this.form.archivesEventId) {
          await this.getArchivesDetail(this.form.archivesEventId)
        } else {
          this.selectArchivesEvent = {}
        }
        
        // this.clickArchivesEvent()
      }

      if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
        let res = await markFocus({
          id: this.selectFileObj.id,
          focus: false
        })
        if (res.code == 0) {
          if (this.filePicList.length == 1) {
            // 刷新未完成列表定位到未完成的下一个文件
            this.$parent.getNextUnfinished();
          } else {
            this.filePicList.map((item, index) => {
              if (item.id == this.selectFileObj.id) {
                this.filePicList.splice(index, 1)
              }
            })
            this.selectFileObj = this.filePicList[0]
            this.$parent.handleTabClick();
          }
          
        }
        // console.log(this.$store.state.allEntryFormData)
        this.form = this.$store.state.allEntryFormData
        if (this.form.archivesEventId) {
          await this.getArchivesDetail(this.form.archivesEventId)
        } else {
          this.selectArchivesEvent = {}
        }
        
        // this.clickArchivesEvent()
      }
      this.getInspectionItemList()

    },
    handleShowInstance() {
      this.showInstance = true
    },
    handleCloseInstance() {
      this.showInstance = false
    },
    handleTableImgRemove() {
      // row.inputValue = null
    },
    tableImgChange(response) {
      let url;
      if (response.code == 0) {
        url = this.imgOss + response.data;
      }
      // console.log(url)
      return url
    },
    receiveStandardValue(data) {
      console.log(data)
      this.selectStandardRow.inputValue = data
    },
    changeAddPic(index,oldIndex) {
      // console.log(index,oldIndex)
      this.addPicName = this.choseFileList[index].fileName
      this.lookAddPicObj = this.choseFileList[index]
    },
    async getInitData() {
      // getFrequency,getSpecs,getRoute
      let res1 = await getFrequency();
      if (res1.code === 0) {
        this.frequencyList = res1.data;
      }
      let res2 = await getSpecs();
      if (res2.code === 0) {
        this.unitList = res2.data;
      }
      let res3 = await getRoute();
      if (res3.code === 0) {
        this.routeList = res3.data;
      }
      let res4 = await getMoveType({
        status: false,
        type: 6
      });
      if (res4.code === 0) {
        this.moveTypeList = res4.data;
      }
    },
    // 选择药品
    changeDrug(val, row) {
      row.drugName = this.drugList.filter(v => v.id === val)[0].name;
      row.drugId = val
      row.drugSpecification = this.drugList.filter(
        v => v.id === val
      )[0].specifications;
    },
    async remoteMethod(query) {
      if (query !== "") {
        let res = await getDrugList({
          name: query
        });
        if (res.code === 0) {
          this.drugList = res.data;
        }
      } else {
        this.drugList = [];
      }
    },
    changeDrugItem(val, row) {
      row.drugId = val
      row.drugName = this.treatmentList.filter(v => v.id === val)[0].name;
    },
    // 改变处方类别
    changeRecipeCategory() {
      // if (this.form.prescription.type === 1 && this.form.type === '2') {
      //   this.form.prescription.itemList.push({
      //     drugName: '',
      //     drugSpecification: '',
      //     medicationFrequencyName: '',
      //     medicationModeName: '',
      //     medicationNumber: '',
      //     drugUnitName: '',
      //     drugNumber: '',
      //     medicationUnitName: '',
      //     remarks: '',
      //     isEdit: true
      //   })
      // } else {
      //   this.form.prescription.itemList = []
      // }
      this.$refs.formRef.clearValidate();
      this.form.prescription.itemList = [];
      this.handleAdd(1);
    },
    // 删除
    handleDelRow(index) {
      this.$confirm("确定要删除当前数据吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm"
      }).then(async () => {
        this.form.prescription.itemList.splice(index, 1);
      });
    },
    handleclose() {
      // this.$refs.formRef.clearValidate()
      this.$refs.formRef.resetFields();
      // this.$refs.formRef.clearValidate()
    },
    // remotetreatMethod() {},
    async changeSport(val, row) {
      row.category = this.moveTypeList.filter(
        item => item.id === val
      )[0].categoryName;
      row.sportCategoryId = "";
      let res5 = await getMoveItem({
        categoryId: val,
        status: false
      });
      if (res5.code === 0) {
        this.$set(row,'moveItemList',res5.data)
        // this.moveItemList = res5.data;
      }
    },
    changeSportItem(val, row) {
      row.drugName = row.moveItemList.filter(item => item.id === val)[0].name;
    },
    handleEditRow(row) {
      let editArr = [];
      editArr = this.form.prescription.itemList.filter(
        item => item.isEdit === true
      );
      if (editArr.length === 1) {
        this.$message.error("请完成当前编辑");
        return;
      }
      this.$set(row,'isEdit',true)
      // row.isEdit = true;
    },
    handleSaveRow(row, index) {
      let arr = [];
      Object.keys(row).forEach(ele => {
        arr.push("prescription.itemList." + index + "." + ele);
      });
      // let arr = []
      let valiResArr = [];
      this.$refs.formRef.validateField(arr, error => {
        valiResArr.push(error);
        // if(!error){
        //     //当校验通过时，这里面写逻辑代码
        //   row.isEdit = false
        // }
      });
      let ispass = valiResArr.every(item => {
        return item == false;
      });
      if (ispass) {
        //当校验通过时，这里面写逻辑代码
        // row.isEdit = false;
        this.$set(row,'isEdit',false)
      }
      // 校验
      // this.$refs.formRef.validateField('prescription')
      // return
    },




    clickArchivesEvent(item) {
      this.form.type = null
      // this.selectArchivesEvent = item
      let menzhenArr = [1, 2, 3, 4, 5, 6];
      let jizhenArr = [1, 2, 3, 4, 5, 7, 8];
      let zhuyuanArr = [3, 4, 5, 6, 9, 10, 11, 12, 13, 16];
      let yuanwaiArr = [14, 15];
      // 图片的未录入的
      if (this.selectFileObj.filePath && this.selectFileObj.status == 1 && this.dsicmType 
        && (this.selectArchivesEvent.eventName == '门诊' && menzhenArr.indexOf(this.dsicmType) != -1 || 
          this.selectArchivesEvent.eventName == '急诊' && jizhenArr.indexOf(this.dsicmType) != -1 ||
          this.selectArchivesEvent.eventName == '住院' && zhuyuanArr.indexOf(this.dsicmType) != -1 ||
          this.selectArchivesEvent.eventName == '院外' && yuanwaiArr.indexOf(this.dsicmType) != -1 )) {
        this.form.type = this.dsicmType
      } else {
        if (this.selectArchivesEvent.eventName == '门诊') {
          this.form.type = 1
        }
        if (this.selectArchivesEvent.eventName == '急诊') {
          this.form.type = 1
        }
        if (this.selectArchivesEvent.eventName == '住院') {
          this.form.type = 3
        }
        if (this.selectArchivesEvent.eventName == '院外') {
          this.form.type = 14
        }
      }
    },
    // saveStandardRow(row,index) {
    //   let editArr = [];
    //   editArr = this.form.standardTable.filter(item => item.standardFieldName === row.standardFieldName);
    //   if (editArr.length > 1) {
    //     this.$message.error("标准字段不可重复");
    //     return;
    //   }
    //   // this.$set(row,'isEdit',false)
    //   // 只校验标准字段表格部分
    //   let arr = [];
    //   Object.keys(row).forEach(ele => {
    //     arr.push("standardTable." + index + "." + ele);
    //   });
    //   let valiResArr = []
    //   this.$refs.formRef.validateField(arr, error => {
    //     valiResArr.push(error);
    //   });
    //   let ispass = valiResArr.every(item => {
    //     return item == false
    //   });
    //   if (ispass) {
    //     //当校验通过时，这里面写逻辑代码
    //     this.$set(row,'isEdit',false)
    //   }
    // },
    // async editStandardRow(row) {
    //   let editArr = [];
    //   editArr = this.form.standardTable.filter(item => item.isEdit === true);
    //   if (editArr.length === 1) {
    //     this.$message.error("请完成当前编辑");
    //     return;
    //   }
    //   console.log(row)
    //   // row.isEdit = true
    //   this.$set(row,'isEdit',true)
    //   this.$set(row,'standardFieldIdObj',{
    //     id: row.standardFieldId,
    //     name: row.standardFieldName,
    //     dataType: row.dataType
    //   })
    //   this.standardFieldList = []
    //   this.getFieldList(1,row.standardFieldName)
    //   if (row.dataType == '多选' || row.dataType == '多选下拉') {
    //     if (row.inputValue) {
    //       row.inputValue = typeof row.inputValue == 'string' ? row.inputValue.split(',') : row.inputValue
    //     } else {
    //       row.inputValue = []
    //     }
    //   }
      
    //   // 点击编辑时获取标准字段是否重点
    //   let res = await standardFiledFocus({
    //     standardFieldId: row.standardFieldId,
    //     wholeCourseId: this.selectFileObj.wholeCourseId,
    //     patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
    //     type: this.form.type
    //   })
    //   if (res.code == 0) {
    //     row.isFocus = res.data.isFocus
    //     row.focusFieldId = res.data.focusFieldId
    //     row.focusFieldName = res.data.focusFieldName
    //   }

    //   //获取下拉数据
    //   if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
    //     let res1 = await getSelectStandardValue({
    //       standardFieldId: row.standardFieldId
    //     })
    //     if (res1.code == 0) {
    //       if (res1.data && res1.data.length) {
    //         this.$set(row,'selectDataList',res1.data)
    //       } else {
    //         this.$set(row,'selectDataList',[])
    //       }
    //       // row.selectDataList = res.data
          
    //     }
    //   }
    //   //获取下拉数据
    //   // if (row.dataType.indexOf('下拉') != -1) {
    //   //   let res1 = await getSelectStandardValue({
    //   //     standardFieldId: row.standardFieldId
    //   //   })
    //   //   if (res1.code == 0) {
    //   //     this.$set(row,'selectDataList',res1.data)
    //   //     // row.selectDataList = res1.data
    //   //     // row.selectDataList.push(res1.data)
    //   //     // this.$forceUpdate()
    //   //   }
    //   // }
    // },
    delStandardRow(index) {
      this.form.standardTable.splice(index,1)
    },
    focusStandardField() {
      this.standardFieldList = this.cloneStandardFieldList
      let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
      this.standardFieldList.forEach(v => {
        if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
          // v.disabled = true
          this.$set(v,'disabledStandard',true)
        } else {
          this.$set(v,'disabledStandard',false)
        }
      })
    },
    addStandardRow() {
      // let editArr = [];
      // editArr = this.form.standardTable.filter(item => item.isEdit === true);
      // if (editArr.length === 1) {
      //   this.$message.error("请完成当前编辑");
      //   return;
      // }
      // this.standardFieldList = []
      this.form.standardTable.push({
        standardFieldId: null,
        standardFieldName: "",
        isFocus: true,
        dataType: "",
        html: "",
        id: null,
        name: null,
        exceptionRecord: null,
        // firstCategoryId: null,
        // firstCategoryName: null,
        // secondCategoryId: null,
        // secondCategoryName: null,
        doseUnit: "",
        unitList: null,
        ocrRange: null,
        inputValue: "",
        resultProperty: null,
        isEdit: true,
        standardFieldIdObj: {},
        fieldDescription: ''
      });
      // let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
      // this.standardFieldList.forEach(v => {
      //   if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
      //     // v.disabled = true
      //     this.$set(v,'disabledStandard',true)
      //   } else {
      //     this.$set(v,'disabledStandard',false)
      //   }
      // })
    },
    // 添加一条表格数据
    handleAdd(flag) {
      // 改变处方类别
      // if (flag !== 1) {
      //   let editArr = [];
      //   editArr = this.form.prescription.itemList.filter(item => item.isEdit === true);
      //   if (editArr.length === 1) {
      //     this.$message.error("请完成当前编辑");
      //     return;
      //   }
      // }
      if (this.form.prescription.type === 1) {
        this.form.prescription.itemList.push({
          drugId: "",
          drugName: "",
          drugSpecification: "",
          medicationFrequencyName: "",
          medicationModeName: "",
          medicationNumber: "",
          drugUnitName: "",
          drugNumber: "",
          medicationUnitName: "",
          remarks: "",
          isEdit: true
        });
      }
      if (this.form.prescription.type === 2) {
        this.form.prescription.itemList.push({
          drugName: "",
          drugNumber: "",
          medicationUnitName: "g",
          isEdit: true
        });
      }
      if (this.form.prescription.type === 4) {
        this.form.prescription.itemList.push({
          category: "",
          drugName: "",
          medicationFrequencyName: "",
          drugNumber: "",
          singleTime: "",
          singleUnit: "分",
          totalTime: "",
          totalUnit: "分",
          isEdit: true,
          sportId: "",
          sportCategoryId: "",
          moveItemList: []
        });
      }
      if (this.form.prescription.type === 5) {
        this.form.prescription.itemList.push({
          drugName: "",
          medicationFrequencyName: "",
          drugNumber: "",
          singleTime: "",
          singleUnit: "分",
          totalTime: "",
          totalUnit: "分",
          remarks: "",
          isEdit: true
        });
      }
    },
    async remoteMethod(query) {
      if (query !== "") {
        let res = await getDrugList({
          name: query
        });
        if (res.code === 0) {
          this.drugList = res.data;
        }
      } else {
        this.drugList = [];
      }
    },
    // changeDrug(val, row) {
    //   row.drugName = this.drugList.filter(v => v.id === val)[0].name;
    //   row.drugSpecification = this.drugList.filter(
    //     v => v.id === val
    //   )[0].specifications;
    // },
    closeHistoryRecord() {
      this.showHistoryRecord = false;
    },
    fillHistoryData(row) {
      this.selectStandardRow = row
      this.showHistoryRecord = true;
    },
    addNewCourse() {
      this.showNewCourse = true;
      this.form.archivesEventId = ''
      this.form.archivesEventName = null
      this.selectArchivesEvent = {}
      this.newCourseTime = Date.now()
    },
    editDiseaseRecord() {
      this.showNewCourse = true;
    },
    async closeNewCourse(id) {
      this.showNewCourse = false;
      // 新增
      if (id) {
        await this.getArchivesDetail(id)
        this.clickArchivesEvent()
      }
    },
    async getArchivesDetail(id) {
      let res = await archivesDetail(id)
      if (res.code === 0) {
        // console.log(res)
        this.selectArchivesEvent = res.data
        // this.clickArchivesEvent(this.selectArchivesEvent)
      }
    },
    previewAddImg(filePath) {
      this.showLargePic = true;
      // this.picUrl = this.imgOss + filePath
      this.defaultAddImgIndex = this.choseFileList.findIndex(item => {
        return item.filePath === filePath;
      });
      // console.log(this.defaultImgIndex)
      setTimeout(() => {
        this.$refs.carouselRef.setActiveItem(this.defaultAddImgIndex)
      }, 0)
      this.lookAddPicObj = this.choseFileList[this.defaultAddImgIndex]
      this.addPicName = this.choseFileList[this.defaultAddImgIndex].fileName
    },
    async handleSetInvalid(data) {
      let res = await disableInvalid(data, this.patientFilesItemId)
      if (res.code == 0) {
        this.$message.success("成功")
        if (data) {
          this.editBack = false
        } else {
          this.editBack = true
        }
        this.$set(this.selectFileObj, "disabled", data)
        // 入录详情列表刷新
        if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
          this.$parent.handleTabClick();
        }
        // 刷新录入任务列表
        if (this.routeEntry == 3) {
          this.$emit("searchFolder")
        }
        // 对于已录入的，标记无效后，刷新当前文件的数据（清空数据记录）
        if (data) {
          await this.refeDialog(this.selectFileObj);
          this.editBack = false;
          this.isAnswerPlan = false; // 不显示编辑保存
        } else {
          this.editBack = true;
          this.isAnswerPlan = true; // 显示编辑保存
        }
      }
      this.allPatientFilesItem.splice(this.currentFilesIndex, 1);
      // console.log(this.allPatientFilesItem)
    },
    // handleRecoverInvalid() {

    // },
    recieveRelative(data) {
      this.kinsFolkForm = data;
    },
    async getKinsFolk() {
      let res = await getRelativeByPatientId({
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId
      });
      if (res.code == 0) {
        this.kinsFolkForm = res.data;
      }
    },
    addKinsFolk() {
      this.showKinsPop = true;
    },
    // handleCancelKins() {
    //   this.showKinsPop = false
    // },
    handleSaveKins() {},
    moveSelect(e) {
      if (this.$route.query.inputGroupId) {
        this.moveBlockFull(e);
      } else {
        this.moveBlock(e);
      }
    },
    moveBlock(e) {
      // console.log(e)
      // let parentNode = document.getElementsByClassName("el-dialog");
      let childrenNode = document.getElementsByClassName("ocr-text-wrapper")[0];
      // console.log(childrenNode)
      let computeHeight = Number(getComputedStyle(childrenNode, null)["height"].slice(0, -2));
      // console.log(computeHeight)

      // console.log(e)
      let odiv = e.target; //获取目标元素
      let disX = e.offsetX;
      let disY = e.offsetY;
      document.onmousemove = e => {
        //鼠标事件对象
        var oEvent = e || event;
        var l = oEvent.clientX - disX - 20;
        var t = oEvent.clientY - disY - 20;

        if (l < 10) {
          l = 0;
        }
        if (t < -20) {
          t = -20;
        }

        childrenNode.style.left = l + "px";
        childrenNode.style.top = t + "px";

        if (document.documentElement.clientWidth - (l + document.documentElement.clientWidth * 0.23) < 10) {
          l = "calc(76% + 40px)";
          childrenNode.style.left = l;
        }

        if (document.documentElement.clientHeight - (t + computeHeight) < 20) {
          t = document.documentElement.clientHeight - computeHeight - 20;
          childrenNode.style.top = t + "px";
        }

        /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
        childrenNode.style.marginLeft = 0;
        childrenNode.style.marginTop = 0;
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    moveBlockFull(e) {
      // console.log(e)
      // let parentNode = document.getElementsByClassName("el-dialog");
      let childrenNode = document.getElementsByClassName("ocr-text-wrapper")[0];
      // console.log(childrenNode)
      let computeHeight = Number(getComputedStyle(childrenNode, null)["height"].slice(0, -2));
      // console.log(computeHeight)

      // console.log(e)
      let odiv = e.target; //获取目标元素
      let disX = e.offsetX;
      let disY = e.offsetY;
      document.onmousemove = e => {
        //鼠标事件对象
        var oEvent = e || event;
        var l = oEvent.clientX - disX;
        var t = oEvent.clientY - disY;

        if (l < 10) {
          l = 0;
        }
        if (t < 10) {
          t = 0;
        }

        childrenNode.style.left = l + "px";
        childrenNode.style.top = t + "px";

        if (document.documentElement.clientWidth - (l + document.documentElement.clientWidth * 0.23) < 10) {
          // l = 'calc(76% + 20px)'
          l = "76%";
          childrenNode.style.left = l;
        }

        if (document.documentElement.clientHeight - (t + computeHeight) < 20) {
          t = document.documentElement.clientHeight - computeHeight - 5;
          childrenNode.style.top = t + "px";
        }

        /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
        childrenNode.style.marginLeft = 0;
        childrenNode.style.marginTop = 0;
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };

      // // let parentNode = document.getElementsByClassName("el-dialog");
      // let childrenNode = document.getElementsByClassName("ocr-text-wrapper")[0]
      // // console.log(childrenNode)
      // let computeHeight = Number(getComputedStyle(childrenNode,null)["height"].slice(0, -2))
      // // console.log(computeHeight)

      // // console.log(e)
      // let odiv = e.target; //获取目标元素
      // let disX = e.offsetX;
      // let disY = e.offsetY;
      // // console.log(disX,'disX')
      // // console.log(disY,'disY')
      // document.onmousemove = e => {

      //   //鼠标事件对象
      //   var oEvent = e || event;
      //   // if (this.$store.state.isCollapse) {
      //   //   var l = oEvent.clientX - disX - 63;
      //   // } else {
      //   //   var l = oEvent.clientX - disX - 260;
      //   // }
      //   var l = oEvent.clientX - disX;
      //   var t = oEvent.clientY - disY;

      //   // console.log(t)
      //   if (l < 10) {
      //     l = 0;
      //   }
      //   if (t < 10) {
      //     // console.log(t)
      //     t = 0;
      //     // t = document.documentElement.clientHeight - 50
      //   }

      //   childrenNode.style.left = l + "px";
      //   childrenNode.style.top = t + "px";

      //   if (this.$store.state.isCollapse) {
      //     if (document.documentElement.clientWidth - (l + 63 + 333) < 150) {
      //       childrenNode.style.left = '76%'
      //     }

      //   } else {
      //     if (document.documentElement.clientWidth - (l + 260 + 333) < 50) {
      //       childrenNode.style.left = '76%'
      //     }
      //   }

      //   if (document.documentElement.clientHeight - (t + computeHeight) < 10) {
      //     t = document.documentElement.clientHeight - computeHeight - 5
      //     childrenNode.style.top = t + "px";
      //   }

      //   // console.log(document.documentElement.clientWidth,'clientWidth')
      //   // console.log(l,'l')

      //   /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
      //   childrenNode.style.marginLeft = 0;
      //   childrenNode.style.marginTop = 0;

      // };
      // document.onmouseup = e => {
      //   document.onmousemove = null;
      //   document.onmouseup = null;
      // };
    },

    // 设置样式
    setStyle(elem, obj) {
      // console.log(document.getElementsByClassName('ocr-text-wrapper')[0])
      for (var key in obj) {
        var value = obj[key];
        document.getElementsByClassName("ocr-text-wrapper")[0].style.setProperty(key, value);
      }
    },

    setMapStyle(obj) {
      var x = obj.x;
      var y = obj.y;
      var scale = obj.scale;
      // var duration = obj.duration
      this.setStyle(document.getElementsByClassName("ocr-text-wrapper")[0], {
        "transform-origin": "0px 0px",
        // transition: `all ${duration / 1000}s ease-out 0s`,
        transform: `translate3d(${x}px, ${y}px, 0px) scale3d(${scale}, ${scale}, 1)`
      });
    },

    // 测试使用
    // setMapStyle(this.animation)

    // // 鼠标按钮被按下
    // ocrTextDown(event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   // console.log(event.button);
    //   // 0 为鼠标左键
    //   if (event.button === 0) {
    //     this.ocrRecflag = true;

    //     // clientX 鼠标指针相对于浏览器页面左边的水平坐标
    //     this.moveDistance = {
    //       x: event.clientX - this.animation.x,
    //       y: event.clientY - this.animation.y
    //     };
    //   }
    // },

    // // 鼠标按键被松开
    // ocrTextUp(event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   // console.log(event.button);
    //   // 0 为鼠标左键
    //   if (event.button === 0) {
    //     this.ocrRecflag = false;
    //   }
    // },

    // // 鼠标被移动
    // ocrTextMove(event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   if (this.ocrRecflag) {
    //     var left = event.clientX - this.moveDistance.x;
    //     var top = event.clientY - this.moveDistance.y;

    //     this.animation = {
    //       x: left,
    //       y: top,
    //       scale: this.animation.scale,
    //       duration: 0
    //     };

    //     this.setMapStyle(this.animation);
    //   }
    // },

    // // 鼠标移出
    // ocrTextOut(event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   // console.log(event);
    //   var mapIndex = event.path.findIndex(f => f === document.getElementsByClassName("ocr-text-wrapper")[0]);
    //   var targetIndex = event.path.findIndex(f => f === event.relatedTarget);
    //   if (targetIndex > mapIndex) {
    //     this.ocrRecflag = false;
    //   }
    //   // this.ocrRecflag = false
    // },

    handleFolderOcrText() {
      this.openOcrTextStatus = !this.openOcrTextStatus;
    },
    handleZoomImg(e) {
      this.isPreview = true;
      // console.log("鼠标滚动了", e);
      e = e || window.event;

      // 火狐下没有wheelDelta，用detail代替，由于detail值的正负和wheelDelta相反，所以取反
      e.delta = e.wheelDelta || -e.detail;

      e.preventDefault();
      if (e.delta > 0) {
        //当滑轮向上滚动时
        this.scaleFunc(2);
      }
      if (e.delta < 0) {
        //当滑轮向下滚动时
        this.scaleFunc(-2);
      }
    },
    // 图片缩放
    scaleFunc(num) {
      // 这里设置了一个缩小倍数限制，最小缩小到0.2呗
      if (this.zoomIndex <= 2 && num < 0) return;
      // this.zoomIndex += num
      this.zoomIndex = this.zoomIndex + num;
      // console.log(this.zoomIndex);
    },
    // 上一张
    async getPreviousFile() {
      // console.log(this.allPatientFilesItem)
      // if (this.currentFilesIndex == 0) {
      //   this.$message.error('已是第一张')
      //   return
      // }
      // clearInterval(this.preOcrtimer);
      // this.preOcrtimer = "";
      // 清除定时器
      this.ocrTextCount = 0
      clearInterval(this.ocrTextTimer)
      this.ocrTextTimer = ""
      this.ocrTableCount = 0
      clearInterval(this.ocrTableTimer)
      this.ocrTableTimer = ""

      clearInterval(this.ocrtimer);
      this.ocrtimer = "";
      this.count = 0;
      this.ocrFlag = false;

      this.currentFilesIndex = this.currentFilesIndex - 1;
      // console.log(this.allPatientFilesItem)
      // console.log(this.currentFilesIndex,'currentFilesIndex')
      this.$nextTick(() => {
        document.getElementsByClassName("move-position")[0].style.left = 0;
        document.getElementsByClassName("move-position")[0].style.top = 0;

        document.getElementsByClassName("ocr-text-wrapper")[0].style.left = "76%";
        document.getElementsByClassName("ocr-text-wrapper")[0].style.top = "220px";
      });
      // console.log(this.allPatientFilesItem[this.currentFilesIndex]);
      // this.refeDialog(this.allPatientFilesItem[this.currentFilesIndex]);

      this.selectFileObj = this.allPatientFilesItem[this.currentFilesIndex]
      this.selectFileObj.status = this.selectFileObj.statusName == '未录入' ? 1 : this.selectFileObj.statusName == '已录入' ? 2 : this.selectFileObj.statusName == '草稿' ? 5 : null

      if (this.routeEntry == 1) {
        this.editBack = false;
        this.isAnswerPlan = false; // 不显示编辑保存
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
        if (this.selectFileObj.status == 2 || this.selectFileObj.status == 5) {
          await this.yetEntryData(this.selectFileObj)
        }
      }
      // 
      if (this.routeEntry == 2) {
        this.editBack = false;
        this.isAnswerPlan = false; // 不显示编辑保存
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
      }
      if (this.routeEntry == 3) {
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
        if (this.selectFileObj.status == 2 || this.selectFileObj.status == 5) {
          await this.yetEntryData(this.selectFileObj)
        }
      }

      if (this.routeEntry == 3) {
        // （判断当前这张和上一张是不是同一组，同一组不需要加锁解锁操作）
        // 不同组的需要加锁当前这张图片组，解锁上一张图片组
        if (this.allPatientFilesItem[this.currentFilesIndex].inputGroupId == this.allPatientFilesItem[this.currentFilesIndex + 1].inputGroupId) {
        } else {
          // 解锁上一张
          let res = await unlockInGroupFile(this.allPatientFilesItem[this.currentFilesIndex + 1].inputGroupId);
          if (res.code == 0) {
          }
          // 加锁当前图片
          lockInGroupFile(this.allPatientFilesItem[this.currentFilesIndex].inputGroupId)
            .then(res => {
              if (res.code == 0) {
                this.editBack = true;
                this.isAnswerPlan = true; // 显示编辑保存
              }
            })
            .catch(e => {
              // 被锁了只能查看
              this.editBack = false;
              this.isAnswerPlan = false; // 不显示编辑保存
            });
        }
      }
    },
    //下一张
    async getNextFile() {
      // if (this.currentFilesIndex == this.allPatientFilesItem.length - 1) {
      //   this.$message.error('已是最后一张')
      //   return
      // }

      // clearInterval(this.preOcrtimer);
      // this.preOcrtimer = "";
      // 清除定时器
      this.ocrTextCount = 0
      clearInterval(this.ocrTextTimer)
      this.ocrTextTimer = ""
      this.ocrTableCount = 0
      clearInterval(this.ocrTableTimer)
      this.ocrTableTimer = ""

      clearInterval(this.ocrtimer);
      this.ocrtimer = "";
      this.count = 0;
      this.ocrFlag = false;

      this.currentFilesIndex = this.currentFilesIndex + 1;
      // console.log(this.allPatientFilesItem)
      // console.log(this.currentFilesIndex,'currentFilesIndex')
      this.$nextTick(() => {
        document.getElementsByClassName("move-position")[0].style.left = 0;
        document.getElementsByClassName("move-position")[0].style.top = 0;

        document.getElementsByClassName("ocr-text-wrapper")[0].style.left = "76%";
        document.getElementsByClassName("ocr-text-wrapper")[0].style.top = "220px";
      });
      // this.refeDialog(this.allPatientFilesItem[this.currentFilesIndex]);

      this.selectFileObj = this.allPatientFilesItem[this.currentFilesIndex]
      // console.log(this.selectFileObj)
      this.selectFileObj.status = this.selectFileObj.statusName == '未录入' ? 1 : this.selectFileObj.statusName == '已录入' ? 2 : this.selectFileObj.statusName == '草稿' ? 5 : null

      if (this.routeEntry == 1) {
        this.editBack = false;
        this.isAnswerPlan = false; // 不显示编辑保存
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
        if (this.selectFileObj.status == 2 || this.selectFileObj.status == 5) {
          await this.yetEntryData(this.selectFileObj)
        }
      }
      // 
      if (this.routeEntry == 2) {
        this.editBack = false;
        this.isAnswerPlan = false; // 不显示编辑保存
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
      }
      if (this.routeEntry == 3) {
        if (this.selectFileObj.status == 1) {
          await this.noEntryData(this.selectFileObj)
        }
        if (this.selectFileObj.status == 2 || this.selectFileObj.status == 5) {
          await this.yetEntryData(this.selectFileObj)
        }
      }

      
      if (this.routeEntry == 3) {
        let filesObj
        if (this.allPatientFilesItem[this.currentFilesIndex - 1]) {
          filesObj = this.allPatientFilesItem[this.currentFilesIndex - 1]
        } else {
          filesObj = this.allPatientFilesItem[this.allPatientFilesItem.length - 1]
        }
        // （判断当前这张和上一张是不是同一组，同一组不需要加锁解锁操作）
        // 不同组的需要加锁当前这张图片组，解锁上一张图片组
        if (this.allPatientFilesItem[this.currentFilesIndex].inputGroupId == filesObj.inputGroupId) {
        } else {
          // 解锁上一张
          let res = await unlockInGroupFile(filesObj.inputGroupId);
          if (res.code == 0) {
          }
          // 加锁当前图片
          lockInGroupFile(this.allPatientFilesItem[this.currentFilesIndex].inputGroupId)
            .then(res => {
              if (res.code == 0) {
                this.editBack = true;
                this.isAnswerPlan = true; // 显示编辑保存
              }
            })
            .catch(e => {
              // 被锁了只能查看
              this.editBack = false;
              this.isAnswerPlan = false; // 不显示编辑保存
            });
        }
        // if (this.allPatientFilesItem[this.currentFilesIndex - 1]) {}
        // else {
        //   this.allPatientFilesItem.splice(this.allPatientFilesItem.length-1, 1);
        // }
      }
    },
    // 处理上一张下一张所需列表数据
    async getPatientFilesItemData(patientId) {
      if (this.activeTabName == "second") {
        let medicalFolderArr = Object.values(this.medicalFolderList);
        this.allPatientFilesItem = [].concat.apply([], medicalFolderArr);
        this.currentFilesIndex = this.allPatientFilesItem.findIndex(v => v.id == this.patientFilesItemId);
        // console.log(this.currentFilesIndex);
      }

      if (this.activeTabName == "third") {
        this.allPatientFilesItem = this.invalidFileList;
        this.currentFilesIndex = this.allPatientFilesItem.findIndex(v => v.id == this.patientFilesItemId);
      }
    },
    // // 修改就诊日期
    // changeDiagnoseDate(val) {
    //   // console.log(this.form.archivesEventName)
    //   if (this.form.prentype == 2) {
    //     if (this.form.archivesEventName.indexOf(".") != -1) {
    //       if (val != this.form.archivesEventName.split("      ")[1].replace(/\./g, "-")) {
    //         this.$set(this.form, "prentype", 1);
    //         this.form.eventName = this.form.archivesEventName.split("      ")[0];
    //         this.form.archivesEventId = "";
    //         this.$forceUpdate();
    //       }
    //     } else {
    //       // console.log(this.form.archivesEventName.split(" ")[1])
    //       // return
    //       if (val != this.form.archivesEventName.split(" ")[1]) {
    //         this.$set(this.form, "prentype", 1);
    //         this.form.eventName = this.form.archivesEventName.split(" ")[0];
    //         this.form.archivesEventId = "";
    //         this.$forceUpdate();
    //       }
    //     }
    //   }
    // },
    async remotetreatMethod(queryString) {
      let res = await getTreatmentList({
        keyword: queryString
      });
      if (res.code === 0) {
        this.treatmentList = res.data
      }
    },
    // remoteFieldMethod(query) {
    //   this.standardFieldList = [];
    //   this.fieldCurrent = 1;
    //   if (query !== "") {
    //     this.fieldItemQuery = query
    //     this.getFieldList(1, query)
    //   } else {
    //     this.standardFieldList = [];
    //   }
    // },
    //列表选择标准字段
    async listFieldChange(val, row) {
      // console.log(val)
      // if (!val) return
      this.$set(row,'standardFieldIdObj',val.focusFieldName)
      row.standardFieldId = val.standardFieldId
      row.standardFieldName = val.standardFieldName
      row.dataType = val.dataType
      // this.$set(row,'dataType',val.dataType)
      if (row.dataType == '开关') {
        row.inputValue = '是'
      } else {
        row.inputValue = ''
      }

      row.focusFieldId = val.focusFieldId
      row.focusFieldName = val.focusFieldName
      console.log(row)
      // let res = await standardFiledFocus({
      //   standardFieldId: val.id,
      //   wholeCourseId: this.selectFileObj.wholeCourseId,
      //   patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
      //   type: this.form.type
      // })
      // if (res.code == 0) {
      //   row.isFocus = res.data.isFocus
      //   row.focusFieldId = res.data.focusFieldId
      //   row.focusFieldName = res.data.focusFieldName
      // }
      
      if (val.dataType == '多选' || val.dataType == '多选下拉') {
        row.inputValue = []
      }
      //获取下拉数据
      if (val.dataType == '单选下拉' || val.dataType == '多选下拉' || val.dataType == '多选') {
        let res1 = await getSelectStandardValue({
          standardFieldId: val.standardFieldId
        })
        if (res1.code == 0) {
          if (res1.data && res1.data.length) {
            this.$set(row,'selectDataList',res1.data)
          } else {
            this.$set(row,'selectDataList',[])
          }
          // row.selectDataList = res.data
          
        }
      }
      
      let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
      this.standardFieldList.forEach(v => {
        if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
          // v.disabled = true
          this.$set(v,'disabledStandard',true)
        } else {
          this.$set(v,'disabledStandard',false)
        }
      })
    },
    // //加载标准字段
    // loadmoreFieldList() {
    //   this.fieldCurrent++
    //   if (this.fieldCurrent > this.fieldPages) return
    //   this.getFieldList(this.fieldCurrent, this.fieldItemQuery)
    // },
    // async getFieldList(current, searchCondition) {
    //   let res = await getPatientFocusFieldSearchPage({
    //     patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
    //     current: current,
    //     size: 20,
    //     nameLike: searchCondition,
    //     regionId: 1 // 1 非检验 4检验
    //   });
    //   if (res.code == 0) {
    //     this.standardFieldList = this.standardFieldList.concat(res.data.records);
        
    //     let standardFocusFieldIds = this.form.standardTable.map(v => v.focusFieldId)
    //     this.standardFieldList.forEach(v => {
    //       if (standardFocusFieldIds.indexOf(v.focusFieldId) != -1) {
    //         // v.disabled = true
    //         this.$set(v,'disabledStandard',true)
    //       } else {
    //         this.$set(v,'disabledStandard',false)
    //       }
    //     })

    //     this.fieldPages = res.data.pages;
    //   }
    // },
    async getFieldList(searchCondition) {
      let res = await getPatientFocusFieldSearchPage({
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
        // current: current,
        // size: 20,
        nameLike: searchCondition ? searchCondition : '',
        regionId: 1 // 1 非检验 4检验
      });
      if (res.code == 0) {
        this.standardFieldList = res.data;
        this.cloneStandardFieldList = res.data
        console.log(this.standardFieldList)

        // this.fieldPages = res.data.pages;
      }
    },
    // remoteInspectItemMethod(query) {
    //   this.inspectionList = [];
    //   this.codePage.current = 1;
    //   if (query !== "") {
    //     this.itemQuery = query;
    //     this.getInspectionItemList(1, query);
    //   } else {
    //     this.inspectionList = [];
    //   }
    // },
    // //获取检验项目
    // loadmore() {
    //   this.codePage.current++;
    //   // console.log(this.codePage.current,'this.codePage.current')
    //   // console.log(this.pages,'this.pages')
    //   if (this.codePage.current > this.pages) {
    //     return;
    //   }
    //   this.getInspectionItemList(this.codePage.current, this.itemQuery);
    //   // this.getMergeLeveList();
    // },
    async getInspectionItemList(searchCondition) {
      if (this.form.specimenType && this.form.specimenType.length > 0) {
        let res = await getPatientFocusFieldSearchPage({
          // current: 1,
          // size: 20,
          nameLike: searchCondition ? searchCondition : '',
          patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
          regionId: 4,
          specimenType: this.form.specimenType
        });
        if (res.code == 0) {

          // // let names = this.form.inspectionTable.map(item => item["name"]);
          // // let nameSet = new Set(names);
          
          // // if (nameSet.size == names.length) {
          // //   // console.log("没有重复值");
          // // } else {
          // //   // console.log("有重复值");
          // //   this.$message.error("检验项目不可重复");
          // //   return;
          // // }
          
          // // res.data.records.disabled
          // this.inspectionList = this.inspectionList.concat(res.data.records);
          // // this.form.inspectionTable.forEach(item => {
          // //   // console.log(item,'inspectionTableitem')
          // //   this.inspectionList.forEach(v => {
          // //     console.log(v.focusFieldId,'v.focusFieldId')
          // //     console.log(item.focusFieldId,'item.focusFieldId')
          // //     if (v.focusFieldId == item.focusFieldId) {
          // //       // v.disabled = true
          // //       this.$set(v,'disabledItem',true)
          // //     } else {
          // //       this.$set(v,'disabledItem',false)
          // //     }
          // //   })
          // // })

          this.inspectionList = res.data
          this.cloneInspectionList = res.data

          console.log(this.inspectionList,'this.inspectionList')
          this.pages = res.data.pages;
        }
      }
    },
    changeOcrTag() {
      this.showOcrText = !this.showOcrText;
    },
    async handleCloseCross(tag) {
      // 清除定时器
      this.ocrTextCount = 0
      clearInterval(this.ocrTextTimer)
      this.ocrTextTimer = ""
      this.ocrTableCount = 0
      clearInterval(this.ocrTableTimer)
      this.ocrTableTimer = ""

      clearInterval(this.ocrtimer);
      this.ocrtimer = "";
      this.count = 0;
      this.ocrFlag = false;

      // this.crossReferenceEntry = false
      // && this.activeTabName == 'second'

      // // // 刷新疗程管理病历夹列表
      // if (this.routeEntry == 3) {
      //   this.$emit("searchFolder")
      // }

      // 有组id、编辑状态、无效图片、（保存后变为不可编辑，但是需要解锁）this.selectFileObj.isView == 0 || 
      if ((this.editBack || this.selectFileObj.disabled || this.routeEntry == 3) && this.$route.query.isLock != "1" && (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId)) {
        // 解锁
        let res = await unlockInGroupFile(this.$route.query.inputGroupId ? this.$route.query.inputGroupId : this.selectFileObj.inputGroupId);
        if (res.code == 0) {
          // this.$router.back()
          // this.$parent.clickClose()
        }
      }
      if (this.$route.query.inputGroupId) {
        this.$router.back();
      } else {
        this.$emit("clickClose");
      }

      // await this.$emit("searchClick",4);
    },
    async clickOCRDiscern() {
      if (this.ocrFlag) return;
      this.ocrFlag = true;
      this.count = 0;
      let res = await ocrRecord({
        // type: type,
        refId: this.patientFilesItemId,
        // picSource: this.imgOss + this.previewPicturesUrl
        picSource: this.imgOss + this.previewPicturesUrl + "?x-oss-process=image/auto-orient,0/resize,m_lfit,h_2000,w_2000,limit_1/rotate," + this.rightcountDeg
      });
      if (res.code === 0) {
        // clearInterval(ocrtimer)
        this.handleOCRDetail(res.data);
      }

      // axios({
      //   method: 'post',
      //   url: '/admin/ocr-record/ocr/add',
      //   data: {
      //     refId: this.patientFilesItemId,
      //     // picSource: this.imgOss + this.previewPicturesUrl
      //     picSource: this.imgOss + this.previewPicturesUrl + "?x-oss-process=image/auto-orient,0/resize,m_lfit,h_2000,w_2000,limit_1/rotate," + this.rightcountDeg
      //   }
      // })
      // .then((res) => {
      //   this.handleOCRDetail(res.data)
      // })
    },
    async handleOCRDetail(id) {
      // for (let i = 0; i < 120; i++) {
      //   try {
      //     let res = await ocrRecordDetail(id);
      //     // if (this.count == 120) {
      //     //   clearInterval(this.ocrtimer);
      //     //   this.ocrFlag = false;
      //     // }
      //     if (res.code === 0) {
      //       if (res.data.status == 1) {
      //         clearInterval(this.ocrtimer);
      //         this.ocrFlag = false;
      //         // 刷新ocr数据接口
      //         this.getOcrText('loop')
      //         this.getOcrData('loop')
      //         break;
      //       }
      //     }
      //   } catch(err){
      //     console.log(err)
      //     break;
      //   } 
      // }

      this.ocrtimer = setInterval(async () => {
        this.count++;
        let res = await ocrRecordDetail(id);
        if (this.count == 120) {
          clearInterval(this.ocrtimer);
          this.ocrFlag = false;
        }
        if (res.code === 0) {
          if (res.data.status == 1) {
            clearInterval(this.ocrtimer);
            this.ocrFlag = false;
            // 刷新ocr数据接口
            this.getOcrText('loop')
            this.getOcrData('loop')
          }
        }

        // axios({
        //   method: 'get',
        //   url: 'https://dev-admin.dsicm.com/api/admin/ocr-record/1529740428152860673'
        // })
        //   .then((res) => {
        //     // if (this.count == 5) {
        //     //   clearInterval(this.ocrtimer)
        //     // }
        // });
      }, 1000);
    },
    // // 处理OCR识别数据
    // handleOCRTypeData(recognizeResult, type) {
    //   if (type == 1) {
    //     recognizeResult.forEach(v => {
    //       if (v.fieldName !== "patientName" && v.fieldName !== "age" && v.fieldName !== "sex") {
    //         // 日期处理
    //         if (v.fieldName == "checkDate") {
    //           let splitTime = v.value.split(" ")[0];
    //           splitTime = splitTime.substring(0, 10);
    //           // 包含年
    //           if (splitTime.indexOf("年") != -1) {
    //             splitTime = splitTime.replace(/年/g, "-");
    //           }
    //           // 包含月
    //           if (splitTime.indexOf("月") != -1) {
    //             splitTime = splitTime.replace(/月/g, "-");
    //           }
    //           if (splitTime.indexOf("/") != -1) {
    //             splitTime = splitTime.replace(/\//g, "-");
    //           }
    //           if (splitTime.indexOf(".") != -1) {
    //             splitTime = splitTime.replace(/\./g, "-");
    //           }
    //           let isStandardTime = moment(splitTime, "YYYY-MM-DD", true).isValid();
    //           if (isStandardTime) {
    //             v.value = splitTime;
    //           } else {
    //             v.value = "";
    //           }
    //         }
    //         this.$set(this.form.medicalCase, v.fieldName, v.value);
    //       }
    //       if (v.fieldName == "diagnosis" && v.value) {
    //         // 处理诊断字段显示
    //         // 填充诊断字段
    //         this.$set(this.form.patientMedicalDocs, "antidiastole", v.value);
    //         this.$set(this.form.patientMedicalDocs, "clinicalDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "diagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "inDiagnosis", v.value);
    //         this.$set(this.form.prescription, "initDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "initialDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "leaveDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "postoperativeDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "preoperativeDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "regularDiagnose", v.value);
    //         this.$set(this.form.patientMedicalDocs, "diagnosisResult", v.value);
    //         this.$set(this.form.patientMedicalDocs, "tentativeDiagnosis", v.value);
    //         this.$set(this.form.medicalCase, "diagnosis", v.value);
    //         // console.log(this.form.patientMedicalDocs,'this.form.patientMedicalDocs')
    //       }
    //     });
    //   }
    //   // // 处方识别数据映射处理
    //   // if (type == 2) {
    //   //   recognizeResult.forEach(v => {
    //   //     if (v.fieldName !== "patientName" && v.fieldName !== "age" && v.fieldName !== "sex") {
    //   //       // 日期处理
    //   //       if (v.fieldName == "checkDate") {
    //   //         let splitTime = v.value.split(" ")[0];
    //   //         splitTime = splitTime.substring(0,10)
    //   //         // 包含年
    //   //         if (splitTime.indexOf('年') != -1) {
    //   //           splitTime = splitTime.replace(/年/g, '-')
    //   //         }
    //   //         // 包含月
    //   //         if (splitTime.indexOf('月') != -1) {
    //   //           splitTime = splitTime.replace(/月/g, '-')
    //   //         }
    //   //         if (splitTime.indexOf("/") != -1) {
    //   //           splitTime = splitTime.replace(/\//g, "-");
    //   //         }
    //   //         if (splitTime.indexOf(".") != -1) {
    //   //           splitTime = splitTime.replace(/\./g, "-");
    //   //         }
    //   //         let isStandardTime = moment(splitTime,"YYYY-MM-DD",true).isValid();
    //   //         if (isStandardTime) {
    //   //           v.value = splitTime;
    //   //         } else {
    //   //           v.value = "";
    //   //         }
    //   //       }
    //   //       this.$set(this.form.prescription, v.fieldName, v.value);
    //   //     }
    //   //     if (v.fieldName == 'diagnosis' && v.value) {
    //   //       // 处理诊断字段显示
    //   //       // 填充诊断字段
    //   //       this.$set(this.form.patientMedicalDocs,"antidiastole", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"clinicalDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"diagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"inDiagnosis", v.value)
    //   //       this.$set(this.form.prescription,"initDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"initialDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"leaveDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"postoperativeDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"preoperativeDiagnosis", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"regularDiagnose", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"diagnosisResult", v.value)
    //   //       this.$set(this.form.patientMedicalDocs,"tentativeDiagnosis", v.value)
    //   //       this.$set(this.form.medicalCase,"diagnosis", v.value)
    //   //       // console.log(this.form.patientMedicalDocs,'this.form.patientMedicalDocs')
    //   //     }
    //   //   });
    //   // }
    //   //  type == 3 || || type == 16
    //   if (type == 4 || type == 5 || type == 10 || type == 11 || type == 12) {
    //     recognizeResult.forEach(v => {
    //       if (v.fieldName !== "patientName" && v.fieldName !== "age" && v.fieldName !== "sex") {
    //         // 日期处理
    //         if (v.fieldName == "checkDate" || v.fieldName == "chemotherapyDate" || v.fieldName == "diagnoseDate" || v.fieldName == "followUpDate" || v.fieldName == "inHospitalDate" || v.fieldName == "inspectDate" || v.fieldName == "isgivenDate" || v.fieldName == "leaveHospitalDate" || v.fieldName == "medicalRecordDate" || v.fieldName == "observeDate" || v.fieldName == "operationDate" || v.fieldName == "reportDate" || v.fieldName == "rescueDate" || v.fieldName == "screeningDate") {
    //           let splitTime = v.value.split(" ")[0];
    //           splitTime = splitTime.substring(0, 10);
    //           // 包含年
    //           if (splitTime.indexOf("年") != -1) {
    //             splitTime = splitTime.replace(/年/g, "-");
    //           }
    //           // 包含月
    //           if (splitTime.indexOf("月") != -1) {
    //             splitTime = splitTime.replace(/月/g, "-");
    //           }
    //           if (splitTime.indexOf("/") != -1) {
    //             splitTime = splitTime.replace(/\//g, "-");
    //           }
    //           if (splitTime.indexOf(".") != -1) {
    //             splitTime = splitTime.replace(/\./g, "-");
    //           }
    //           let isStandardTime = moment(splitTime, "YYYY-MM-DD", true).isValid();
    //           if (isStandardTime) {
    //             v.value = splitTime;
    //           } else {
    //             v.value = "";
    //           }
    //         }
    //         this.$set(this.form.patientMedicalDocs, v.fieldName, v.value);
    //       }
    //       // 处理检验表格数据
    //       if (type == 4 && v.inspectionInfo) {
    //         this.$set(v.inspectionInfo, "isEdit", false);
    //         if (!v.inspectionInfo.inputValue) {
    //           v.inspectionInfo.doseUnit = "";
    //         }
    //         // v.inspectionInfo.isEdit
    //         this.form.inspectionTable.push(v.inspectionInfo);
    //         // 去重
    //         let obj = {};
    //         let reduce = this.form.inspectionTable.reduce((curr, next) => {
    //           /*判断对象中是否已经有该属性  没有的话 push 到 curr数组*/
    //           obj[next.exceptionRecord + next.doseUnit + next.inputValue + next.firstCategoryId + next.firstCategoryName + next.id + next.name + next.secondCategoryId + next.secondCategoryName] ? "" : (obj[next.exceptionRecord + next.doseUnit + next.inputValue + next.firstCategoryId + next.firstCategoryName + next.id + next.name + next.secondCategoryId + next.secondCategoryName] = curr.push(next));
    //           return curr;
    //         }, []);
    //         // console.log('reduce', reduce);
    //         this.form.inspectionTable = reduce;
    //       }
    //       if (v.fieldName == "diagnosis" && v.value) {
    //         // 处理诊断字段显示
    //         // 填充诊断字段
    //         this.$set(this.form.patientMedicalDocs, "antidiastole", v.value);
    //         this.$set(this.form.patientMedicalDocs, "clinicalDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "diagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "inDiagnosis", v.value);
    //         this.$set(this.form.prescription, "initDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "initialDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "leaveDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "postoperativeDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "preoperativeDiagnosis", v.value);
    //         this.$set(this.form.patientMedicalDocs, "regularDiagnose", v.value);
    //         this.$set(this.form.patientMedicalDocs, "diagnosisResult", v.value);
    //         this.$set(this.form.patientMedicalDocs, "tentativeDiagnosis", v.value);
    //         this.$set(this.form.medicalCase, "diagnosis", v.value);
    //         // console.log(this.form.patientMedicalDocs,'this.form.patientMedicalDocs')
    //       }
    //       if (v.fieldName == "lengthOfStay") {
    //         this.$set(this.form.patientMedicalDocs, "lengthOfStay", v.value.indexOf("天") != -1 ? v.value.slice(0, v.value.length - 1) : v.value);
    //         this.hospitalDays = this.form.patientMedicalDocs.lengthOfStay;
    //       }
    //     });
    //   }
    // },
    // changeCheckProject(val) {
    //   this.form.patientMedicalDocs.checkId = this.inspectionList1.filter(v => v.name === val)[0].id;
    // },
    // changeDrug(val) {
    //   this.treatmentObj.drugName = val.name;
    //   this.treatmentObj.drugId = val.id;
    // },
    move(e) {
      let odiv = e.target; //获取目标元素

      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    // zoomInImg() {
    //   this.isPreview = true;
    //   this.zoomIndex = this.zoomIndex + 2;
    // },
    // zoomOutImg() {
    //   this.isPreview = true;
    //   if (this.zoomIndex <= 2) {
    //     return;
    //   }
    //   this.zoomIndex = this.zoomIndex - 2;
    // },
    // handlePreviewImg() {
    //   this.isPreview = !this.isPreview;
    // },
    editFileName() {
      this.fileNameSelect = false;
      this.picName = this.selectFileObj.fileName;
    },
    // 左旋转
    leftRotate() {
      if (!this.picName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      if (this.rightcountDeg === 0) {
        this.rightcountDeg = 360;
      }
      this.rightcountDeg = this.rightcountDeg - 90;
      this.directRotate = "left";
      let filePath;
      if (this.form.patientFilesItem.filePath.indexOf("/rotate,") != -1) {
        filePath = this.form.patientFilesItem.filePath.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath = this.form.patientFilesItem.filePath + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      api_patient_files({
        fileName: this.picName,
        id: this.selectFileObj.id,
        filePath: filePath
      }).then(res => {
        if (res.code == 0) {
          this.$set(this.selectFileObj, "filePath", filePath);
          // this.$forceUpdate()
          let updateIndex = this.filePicList.findIndex(v => v.id == this.selectFileObj.id);
          this.filePicList.splice(updateIndex, 1, this.selectFileObj);
        }
      });
    },
    // 右旋转
    rightRotate() {
      if (!this.picName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      if (this.rightcountDeg === 360) {
        this.rightcountDeg = 0;
      }
      this.rightcountDeg = this.rightcountDeg + 90;
      this.directRotate = "right";
      let filePath;
      if (this.form.patientFilesItem.filePath.indexOf("/rotate,") != -1) {
        filePath = this.form.patientFilesItem.filePath.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath = this.form.patientFilesItem.filePath + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      api_patient_files({
        fileName: this.picName,
        id: this.selectFileObj.id,
        filePath: filePath
      }).then(res => {
        if (res.code == 0) {
          this.$set(this.selectFileObj, "filePath", filePath);
          // this.$forceUpdate()
          let updateIndex = this.filePicList.findIndex(v => v.id == this.selectFileObj.id);
          this.filePicList.splice(updateIndex, 1, this.selectFileObj);
        }
      });
    },
    // 切换关联病程，清空type
    async clickArchivesEventChange(val) {
      // // this.form.type = ''
      // // this.$set(this.form,'type','')
      // await this.archivesEventChange(val);
      // this.form.type = "";
      this.showNewCourse = false
      await this.getArchivesDetail(val)
      this.clickArchivesEvent()
      if (this.selectArchivesEvent.eventName == '图文问诊') {
        this.form.type = this.selectArchivesEvent.type
      }
    },
    // //关联已有事件
    // async archivesEventChange(val) {
    //   // this.form.archivesEventId = val;
    //   // this.form.archivesEventName = val.value;
    //   // this.form.eventName = this.archivesIdarr.filter(v => v.id == val)[0].value.split("      ")[0]
    //   this.form.archivesEventName = this.archivesIdarr.filter(v => v.id == val)[0].value;
    //   this.form.eventName = this.form.archivesEventName.substring(0, 2);
    //   // this.form.eventName = val.value.split("      ")[0];
    //   // this.form.eventName = this.archivesIdarr.filter(v => v.id === val.id)[0].value
    //   let res = await getArchivesEventLog(val);
    //   if (res.code === 0) {
    //     this.archivesEventLog = res.data;
    //   }
    //   let antidiastole = this.archivesEventLog[0].antidiastole ? this.archivesEventLog[0].antidiastole + ";" : "";
    //   let clinicalDiagnosis = this.archivesEventLog[0].clinicalDiagnosis ? this.archivesEventLog[0].clinicalDiagnosis + ";" : "";
    //   let diagnosis = this.archivesEventLog[0].diagnosis ? this.archivesEventLog[0].diagnosis + ";" : "";
    //   let inDiagnosis = this.archivesEventLog[0].inDiagnosis ? this.archivesEventLog[0].inDiagnosis + ";" : "";
    //   let initDiagnosis = this.archivesEventLog[0].initDiagnosis ? this.archivesEventLog[0].initDiagnosis + ";" : "";
    //   let initialDiagnosis = this.archivesEventLog[0].initialDiagnosis ? this.archivesEventLog[0].initialDiagnosis + ";" : "";
    //   let leaveDiagnosis = this.archivesEventLog[0].leaveDiagnosis ? this.archivesEventLog[0].leaveDiagnosis + ";" : "";
    //   let postoperativeDiagnosis = this.archivesEventLog[0].postoperativeDiagnosis ? this.archivesEventLog[0].postoperativeDiagnosis + ";" : "";
    //   let preoperativeDiagnosis = this.archivesEventLog[0].preoperativeDiagnosis ? this.archivesEventLog[0].preoperativeDiagnosis + ";" : "";

    //   let regularDiagnose = this.archivesEventLog[0].regularDiagnose ? this.archivesEventLog[0].regularDiagnose + ";" : "";
    //   let diagnosisResult = this.archivesEventLog[0].diagnosisResult ? this.archivesEventLog[0].diagnosisResult + ";" : "";
    //   let tentativeDiagnosis = this.archivesEventLog[0].tentativeDiagnosis ? this.archivesEventLog[0].tentativeDiagnosis + ";" : "";

    //   // let diagnosis
    //   let diagnosisStr = antidiastole + clinicalDiagnosis + diagnosis + inDiagnosis + initDiagnosis + initialDiagnosis + leaveDiagnosis + postoperativeDiagnosis + preoperativeDiagnosis + regularDiagnose + diagnosisResult + tentativeDiagnosis;
    //   diagnosisStr = diagnosisStr.slice(0, diagnosisStr.length - 1);
    //   // console.log(diagnosisStr,'diagnosisStr')

    //   // 填充诊断字段
    //   this.$set(this.form.patientMedicalDocs, "antidiastole", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "clinicalDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "diagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "inDiagnosis", diagnosisStr);
    //   this.$set(this.form.prescription, "initDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "initialDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "leaveDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "postoperativeDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "preoperativeDiagnosis", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "regularDiagnose", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "diagnosisResult", diagnosisStr);
    //   this.$set(this.form.patientMedicalDocs, "tentativeDiagnosis", diagnosisStr);
    //   this.$set(this.form.medicalCase, "diagnosis", diagnosisStr);
    //   // 填充就诊医院和科室
    //   this.$set(this.form.patientMedicalDocs, "hospitalName", this.archivesEventLog[0].hospitalName);
    //   this.$set(this.form.patientMedicalDocs, "departmentName", this.archivesEventLog[0].departmentName);
    //   this.$set(this.form.medicalCase, "hospitalName", this.archivesEventLog[0].hospitalName);
    //   this.$set(this.form.medicalCase, "departmentName", this.archivesEventLog[0].departmentName);
    //   this.$set(this.form.prescription, "prescriberHospitalName", this.archivesEventLog[0].hospitalName);
    //   this.$set(this.form.prescription, "prescriberDepartmentName", this.archivesEventLog[0].departmentName);
    //   // 手术地点
    //   this.$set(this.form.patientMedicalDocs, "operationHospitalName", this.archivesEventLog[0].operationHospitalName);
    //   this.$set(this.form.patientMedicalDocs, "operationDepartmentName", this.archivesEventLog[0].operationDepartmentName);
    //   // 填充麻醉方式
    //   this.$set(this.form.patientMedicalDocs, "anesthesiaMethod", this.archivesEventLog[0].anesthesiaMethod);
    //   this.$set(this.form.patientMedicalDocs, "operationDoctor", this.archivesEventLog[0].operationDoctor);
    //   this.$set(this.form.patientMedicalDocs, "operationName", this.archivesEventLog[0].operationName);
    //   // console.log(this.form.eventName, "this.form.eventName");
    //   // console.log(this.archivesEventLog[0].date);
    //   // if (this.form.eventName == "门诊") {
    //   // 填充时间
    //   this.$set(this.form.medicalCase, "checkDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.prescription, "diagnoseDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.prescription, "prescriptionTime", this.archivesEventLog[0].date + " 00:00:00");
    //   this.$set(this.form.patientMedicalDocs, "diagnoseDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "operationDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "inspectDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "reportDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "checkDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "chemotherapyDate", this.archivesEventLog[0].date);

    //   this.$set(this.form.patientMedicalDocs, "observeDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "isgivenDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "rescueDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "inHospitalDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "leaveHospitalDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "medicalRecordDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "screeningDate", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "applyConsultationData", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "consultationData", this.archivesEventLog[0].date);
    //   this.$set(this.form.patientMedicalDocs, "followUpDate", this.archivesEventLog[0].date);
    //   // 出院小结计算住院天数
    //   if (this.form.type == 12) {
    //     if (this.form.patientMedicalDocs.inHospitalDate && this.form.patientMedicalDocs.leaveHospitalDate) {
    //       let a = Date.parse(this.form.patientMedicalDocs.inHospitalDate);
    //       let b = Date.parse(this.form.patientMedicalDocs.leaveHospitalDate);

    //       let c = b - a;
    //       let d = c / (1000 * 3600 * 24);
    //       this.hospitalDays = d;
    //     }
    //     // console.log(this.hospitalDays)
    //   }
    // },
    // hospitalDaysChange(val) {
    //   if (this.form.prentype == 2 && val != 1) {
    //     if (val != this.form.archivesEventName.split("      ")[1].replace(/\./g, "-")) {
    //       this.$set(this.form, "prentype", 1);
    //       this.form.eventName = this.form.archivesEventName.split("      ")[0];
    //       this.form.archivesEventId = "";
    //       this.$forceUpdate();
    //     }
    //   }
    //   if (this.form.patientMedicalDocs.inHospitalDate && this.form.patientMedicalDocs.leaveHospitalDate) {
    //     let a = Date.parse(this.form.patientMedicalDocs.inHospitalDate);
    //     let b = Date.parse(this.form.patientMedicalDocs.leaveHospitalDate);

    //     let c = b - a;
    //     let d = c / (1000 * 3600 * 24);
    //     this.hospitalDays = d;
    //   }
    // },
    // remoteMethod3(e) {
    //   api_inspection({
    //     status: false,
    //     name: e
    //   }).then(res => {
    //     this.inspectionList1 = res.data;
    //   });
    // },
    // // 切换诊疗类型
    // deledomChange() {
    //   this.deleteDom = false;

    //   let menzhenArr = [1, 2, 3, 4, 5, 6];
    //   let jizhenArr = [1, 2, 3, 4, 5, 7, 8];
    //   let zhuyuanArr = [3, 4, 5, 6, 9, 10, 11, 12, 13, 16];
    //   let yuanwaiArr = [14, 15];

    //   if (this.dsicmType) {
    //     if (this.form.eventName == "门诊") {
    //       if (menzhenArr.indexOf(this.dsicmType) != -1) {
    //         this.$set(this.form, "type", this.dsicmType);
    //         this.showDomChange();
    //       } else {
    //         // this.$set(this.form,'type','')
    //         this.form.type = "";
    //       }
    //     }
    //     if (this.form.eventName == "急诊") {
    //       if (jizhenArr.indexOf(this.dsicmType) != -1) {
    //         this.$set(this.form, "type", this.dsicmType);
    //         this.showDomChange();
    //       } else {
    //         this.form.type = "";
    //       }
    //     }
    //     if (this.form.eventName == "住院") {
    //       if (zhuyuanArr.indexOf(this.dsicmType) != -1) {
    //         this.$set(this.form, "type", this.dsicmType);
    //         this.showDomChange();
    //       } else {
    //         this.form.type = "";
    //       }
    //     }
    //     if (this.form.eventName == "院外") {
    //       if (yuanwaiArr.indexOf(this.dsicmType) != -1) {
    //         this.$set(this.form, "type", this.dsicmType);
    //         this.showDomChange();
    //       } else {
    //         this.form.type = "";
    //       }
    //     }
    //   } else {
    //     this.form.type = "";
    //   }

    //   if (this.ocrRecognizeUrl) {
    //   } else {
    //     this.ocrRecognizeUrl = "";
    //     this.recognizeStatus = 0;
    //     this.ocrRecognizeResult = [];
    //     this.textList = [];
    //     this.showOcrText = true;
    //     // clearInterval(this.ocrtimer);
    //     // this.ocrtimer = "";
    //     // this.count = 0;
    //     // this.ocrFlag = false;
    //     // this.precount = 0;
    //     // clearInterval(this.preOcrtimer);
    //     // this.preOcrtimer = "";
    //     // 清除定时器
    //     this.ocrTextCount = 0
    //     clearInterval(this.ocrTextTimer)
    //     this.ocrTextTimer = ""
    //     this.ocrTableCount = 0
    //     clearInterval(this.ocrTableTimer)
    //     this.ocrTableTimer = ""
    //   }
    // },
    // // 切换记录类型
    // async showDomChange() {
    //   this.deleteDom = true;
    //   this.$refs.formRef.clearValidate(); // 移除表单校验
    //   this.hospitalDays = "";
    //   // console.log(this.selectFileObj,'this.selectFileObj')

    //   // 已录入切换类型，清空数据，重新填入识别数据 // && this.selectFileObj.status == 1
    //   if (this.ocrRecognizeUrl && this.selectFileObj.status == 1) {
    //     this.handleOCRTypeData(DEEP_CLONE(this.ocrRecognizeResult), this.dsicmType);
    //     // if (
    //     //     this.form.eventName == "门诊" ||
    //     //     this.form.eventName == "急诊" ||
    //     //     this.form.eventName == "住院"
    //     //   ) {
    //     //     // console.log(this.ocrRecognizeResult,this.dsicmType,'this.ocrRecognizeResult,this.dsicmType')
    //     //     this.handleOCRTypeData(this.ocrRecognizeResult,this.dsicmType)
    //     //   }
    //   }
    //   // 关联病程
    //   if (this.form.archivesEventId) {
    //     await this.archivesEventChange(this.form.archivesEventId);
    //   }
    //   // if (!this.form.type) return;
    //   // let logArr = {};
    //   // logArr = this.archivesEventLog.filter(v => v.type == this.form.type)[0];
    //   // if (!logArr) return;
    //   // if (this.form.type == 2) {
    //   //   // this.$set(this.form.prescription,'diagnoseDate',logArr.date)
    //   //   this.$set(this.form.prescription, "hospitalName", logArr.hospitalName);
    //   //   this.$set(
    //   //     this.form.prescription,
    //   //     "departmentName",
    //   //     logArr.departmentName
    //   //   );
    //   // } else if (this.form.type == 1) {
    //   //   // this.$set(this.form.medicalCase,'checkDate',logArr.date)
    //   //   this.$set(this.form.medicalCase, "hospitalName", logArr.hospitalName);
    //   //   this.$set(
    //   //     this.form.medicalCase,
    //   //     "departmentName",
    //   //     logArr.departmentName
    //   //   );
    //   // } else {
    //   //   // this.$set(this.form.patientMedicalDocs,'diagnoseDate',logArr.date)
    //   //   this.$set(
    //   //     this.form.patientMedicalDocs,
    //   //     "hospitalName",
    //   //     logArr.hospitalName
    //   //   );
    //   //   this.$set(
    //   //     this.form.patientMedicalDocs,
    //   //     "departmentName",
    //   //     logArr.departmentName
    //   //   );
    //   // }
    // },
    // // 切换事件类型
    // prentypeChange() {
    //   // this.form.archivesEventName = "";
    //   this.form.archivesEventId = "";
    //   // // this.form.eventName = '门诊'
    //   // this.$set(this.form,'eventName','门诊')
    // },
    // 编辑整个表单按钮
    async handleEditForm() {
      this.editBack = true;
      // if (this.form.patientMedicalDocs.checkScans && this.form.patientMedicalDocs.checkScans.length) {
      //   // this.form.patientMedicalDocs.checkScansArr = this.form.patientMedicalDocs.checkScans.split(',')
      //   this.$set(this.form.patientMedicalDocs, "checkScansArr", this.form.patientMedicalDocs.checkScans.split(","));
      // }
      // 编辑时，表格显示编辑状态
      // this.form.standardTable.forEach(v => {
      //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
      //   this.$set(v,'isEdit',true)
      // })
      for (const row of this.form.standardTable) {
        this.$set(row,'standardFieldIdObj',row.focusFieldName)
        this.$set(row,'isEdit',true)
        //获取下拉数据
        if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
          let res1 = await getSelectStandardValue({
            standardFieldId: row.standardFieldId
          })
          if (res1.code == 0) {
            if (res1.data && res1.data.length) {
              this.$set(row,'selectDataList',res1.data)
            } else {
              this.$set(row,'selectDataList',[])
            }
            // row.selectDataList = res.data
            
          }
        }
      }

      this.form.inspectionTable.forEach(v => {
        // this.$set(v,'definitionItemId',`${this.resultPropertyObj[v.resultProperty]}-${v.standardFieldName}`)
        this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
        this.$set(v,'isEdit',true)
      })
      if (this.form.prescription.itemList) {
        // this.form.prescription.itemList.forEach(v => {
        //   if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
        //     this.$set(v,'definitionDrugId',v.drugName)
        //   }
        //   this.$set(v,'isEdit',true)
        // })

        for (const row of this.form.prescription.itemList) {
          // if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
          //   this.$set(row,'definitionDrugId',row.drugName)
          // }
          this.$set(row,'isEdit',true)

          //获取运动项目下拉数据
          if (this.form.prescription.type === 4) {
            let res5 = await getMoveItem({
              categoryId: row.sportId,
              status: false
            });
            if (res5.code === 0) {
              this.$set(row,'moveItemList',res5.data)
            }
          }
        }

      }
      
      this.form.standardTable = this.form.standardTable.map(item => {
        return {
          ...item,
          inputValue: item.inputValue.indexOf('<br/>') ? item.inputValue.replace(/<br*\/?>/g, '\n') : item.inputValue// 将<br/>换成\n
        }
      })

    },
    // async getOcrRecognize(id) {
      // let res = await getOcrLog(id);
      // if (res.code == 0) {
      //   // 已录入
      //   if (res.data) {
      //     this.ocrRecognizeUrl = res.data.recognizeUrl;
      //     this.ocrRecognizeResult = DEEP_CLONE(res.data.recognizeResult);
      //     this.textList = res.data.textList ? res.data.textList : [];
      //     this.recognizeStatus = res.data.status;
      //     this.dsicmType = res.data.dsicmType
      //     // if (this.dsicmType == 11 && res.data.recordType) {
      //     //   this.$set(this.form.patientMedicalDocs,"recordType",res.data.recordType);
      //     // }
      //   } else {
      //     // 未录入预处理
      //     this.preOcrtimer = setInterval(async () => {
      //       this.precount++
      //       let res1 = await getOcrLog(id);
      //       if (this.precount == 120) {
      //         clearInterval(this.preOcrtimer);
      //         // this.ocrFlag = false;
      //       }
      //       if (res1.code === 0) {
      //         if (res1.data && res1.data.status == 1) {
      //           clearInterval(this.preOcrtimer);
      //           // this.ocrFlag = false;
      //           this.ocrRecognizeUrl = res1.data.recognizeUrl;
      //           this.ocrRecognizeResult = DEEP_CLONE(res1.data.recognizeResult);
      //           this.textList = res1.data.textList ? res1.data.textList : [];
      //           this.recognizeStatus = res1.data.status;
      //           this.dsicmType = res1.data.dsicmType
      //           if (this.dsicmType == 11 && res.data.recordType) {
      //             this.$set(this.form.patientMedicalDocs,"recordType",res.data.recordType);
      //           }
      //         }
      //       }
      //     },1000)
      //   }
      // }
      // let res = await getOcrLogNew(id);
      // if (res.code == 0) {
      // }
    // },
    // // 开始/重新ocr识别
    // clickOCRDiscern() {
    //   this.getOcrText('loop')
    //   this.getOcrData('loop')
    // },
    async getOcrData(loopTag) {
      if (this.selectFileObj.status == 1 || loopTag == 'loop') {
        // for (let i = 0; i < 120; i++) {
        //   try {
        //     let res = await getOcrLogNew(this.selectFileObj.id);
        //     // if (this.count == 120) {
        //     //   clearInterval(this.ocrtimer);
        //     //   this.ocrFlag = false;
        //     // }
        //     if (res.code === 0) {
        //       if (res.data && res.data.status == 1) {
        //         clearInterval(this.ocrTableTimer)
                
        //         this.basicOcrObj = JSON.parse(res.data.basicObj)

        //         res.data.ocrBasicInfoVOS.forEach(v => {
        //           if (v.dataType == '日期') {
        //             // 日期处理
        //             let splitTime = v.inputValue.split(" ")[0];
        //             splitTime = splitTime.substring(0, 10);
        //             // 包含年
        //             if (splitTime.indexOf("年") != -1) {
        //               splitTime = splitTime.replace(/年/g, "-");
        //             }
        //             // 包含月
        //             if (splitTime.indexOf("月") != -1) {
        //               splitTime = splitTime.replace(/月/g, "-");
        //             }
        //             if (splitTime.indexOf("/") != -1) {
        //               splitTime = splitTime.replace(/\//g, "-");
        //             }
        //             if (splitTime.indexOf(".") != -1) {
        //               splitTime = splitTime.replace(/\./g, "-");
        //             }
        //             let isStandardTime = moment(splitTime, "YYYY-MM-DD", true).isValid();
        //             if (isStandardTime) {
        //               v.inputValue = splitTime;
        //             } else {
        //               v.inputValue = "";
        //             }
        //           }
        //         })

        //         console.log(this.form,'this.form')

        //         this.form.standardTable = this.form.standardTable.concat(res.data.ocrBasicInfoVOS)

        //         const standardFieldName = 'focusFieldId'
        //         this.form.standardTable = this.form.standardTable.reduce((all,next)=>all.some((item)=>item[standardFieldName]==next[standardFieldName])?all:[...all,next],[])

        //         this.ocrImportantWordArr = res.data.ocrBasicInfoVOS.concat(res.data.ocrInspectResult)
        //         if (res.data.ocrInspectResult.length) {
        //           this.form.specimenType = null
        //           this.form.specimenType = res.data.specimenType
                  
        //           this.form.inspectionTable = this.form.inspectionTable.concat(res.data.ocrInspectResult)

        //           const name = 'focusFieldId'
        //           // this.form.inspectionTable = this.form.inspectionTable.reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
        //           console.log(this.form.inspectionTable)

        //           this.allInspectTableData = this.form.inspectionTable.concat(res.data.ocrInspectResult).reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
        //           this.form.inspectionTable = this.allInspectTableData.filter(v => v.specimenType == this.form.specimenType)
        //         }
                


        //         // this.form.type = res.data.dsicmType
        //         this.dsicmType = res.data.dsicmType
        //         this.form.reportName = res.data.reportName
                
        //         if (this.editBack) {
        //           // 编辑时，表格显示编辑状态
        //           // this.form.standardTable.forEach(v => {
        //           //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
        //           //   this.$set(v,'isEdit',true)
        //           // })
        //           for (const row of this.form.standardTable) {
        //             this.$set(row,'standardFieldIdObj',row.focusFieldName)
        //             this.$set(row,'isEdit',true)
        //             //获取下拉数据
        //             if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
        //               let res1 = await getSelectStandardValue({
        //                 standardFieldId: row.standardFieldId
        //               })
        //               if (res1.code == 0) {
        //                 if (res1.data && res1.data.length) {
        //                   this.$set(row,'selectDataList',res1.data)
        //                 } else {
        //                   this.$set(row,'selectDataList',[])
        //                 }
        //                 // row.selectDataList = res.data
                        
        //               }
        //             }
        //           }
        //           this.form.inspectionTable.forEach(v => {
        //             // this.$set(v,'definitionItemId',`${this.resultPropertyObj[v.resultProperty]}-${v.standardFieldName}`)
        //             this.$set(v,'definitionItemId',v.focusFieldName ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
        //             this.$set(v,'isEdit',true)
        //           })
        //           // if (this.form.prescription.itemList) {
        //           //   // this.form.prescription.itemList.forEach(v => {
        //           //   //   if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
        //           //   //     this.$set(v,'definitionDrugId',v.drugName)
        //           //   //   }
        //           //   //   this.$set(v,'isEdit',true)
        //           //   // })
        //           //   for (const row of this.form.prescription.itemList) {
        //           //     if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
        //           //       this.$set(row,'definitionDrugId',row.drugName)
        //           //     }
        //           //     this.$set(row,'isEdit',true)

        //           //     //获取运动项目下拉数据
        //           //     if (this.form.prescription.type === 4) {
        //           //       let res5 = await getMoveItem({
        //           //         categoryId: row.sportId,
        //           //         status: false
        //           //       });
        //           //       if (res5.code === 0) {
        //           //         this.$set(row,'moveItemList',res5.data)
        //           //       }
        //           //     }
        //           //   }
        //           // }
        //         }

        //         // this.$set(this.form,'specimenType',res.data.specimenType)
        //         break;
        //       }
        //     }
        //   } catch(err){
        //     console.log(err)
        //     break;
        //   } 
        // }


        this.ocrTableTimer = setInterval(async () => {
          this.ocrTableCount++
          if (this.ocrTableCount == 121) {
            clearInterval(this.ocrTableTimer);
            this.ocrTableTimer = ''
            this.ocrTableCount = 0
            return
          }
          getOcrLogNew(this.selectFileObj.id).then(async(res) => {
            if (res.code === 0) {
              if (res.data && res.data.status == 1) {
                clearInterval(this.ocrTableTimer)
                
                this.basicOcrObj = JSON.parse(res.data.basicObj)

                res.data.ocrBasicInfoVOS.forEach(v => {
                  if (v.dataType == '日期' && v.inputValue) {
                    // 日期处理
                    let splitTime = v.inputValue.split(" ")[0];
                    splitTime = splitTime.substring(0, 10);
                    // 包含年
                    if (splitTime.indexOf("年") != -1) {
                      splitTime = splitTime.replace(/年/g, "-");
                    }
                    // 包含月
                    if (splitTime.indexOf("月") != -1) {
                      splitTime = splitTime.replace(/月/g, "-");
                    }
                    if (splitTime.indexOf("/") != -1) {
                      splitTime = splitTime.replace(/\//g, "-");
                    }
                    if (splitTime.indexOf(".") != -1) {
                      splitTime = splitTime.replace(/\./g, "-");
                    }
                    let isStandardTime = moment(splitTime, "YYYY-MM-DD", true).isValid();
                    if (isStandardTime) {
                      v.inputValue = splitTime;
                    } else {
                      v.inputValue = "";
                    }
                  }
                })

                // console.log(this.form,'this.form')

                this.form.standardTable = this.form.standardTable.concat(res.data.ocrBasicInfoVOS)

                const standardFieldName = 'focusFieldId'
                this.form.standardTable = this.form.standardTable.reduce((all,next)=>all.some((item)=>item[standardFieldName]==next[standardFieldName])?all:[...all,next],[])

                // 处理单位显示
                res.data.ocrInspectResult.forEach(v => {
                  v.unitList = v.unitList ? v.unitList : (v.doseUnit ? v.doseUnit.split(',') : [])
                  v.doseUnit = v.unitList.length ? v.unitList[0] : ''
                })

                this.ocrImportantWordArr = res.data.ocrBasicInfoVOS.concat(res.data.ocrInspectResult)
                if (res.data.ocrInspectResult.length) {
                  this.form.specimenType = null
                  this.form.specimenType = res.data.specimenType
                  
                  this.form.inspectionTable = res.data.ocrInspectResult.concat(this.form.inspectionTable)

                  const name = 'focusFieldId'
                  // this.form.inspectionTable = this.form.inspectionTable.reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
                  console.log(this.form.inspectionTable)

                  this.allInspectTableData = res.data.ocrInspectResult.concat(this.form.inspectionTable).reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
                  this.form.inspectionTable = this.allInspectTableData.filter(v => v.specimenType == this.form.specimenType)
                }
                


                // this.form.type = res.data.dsicmType
                this.dsicmType = res.data.dsicmType
                this.form.reportName = res.data.reportName
                
                if (this.editBack) {
                  // 编辑时，表格显示编辑状态
                  // this.form.standardTable.forEach(v => {
                  //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
                  //   this.$set(v,'isEdit',true)
                  // })
                  for (const row of this.form.standardTable) {
                    this.$set(row,'standardFieldIdObj',row.focusFieldName)
                    this.$set(row,'isEdit',true)
                    //获取下拉数据
                    if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
                      let res1 = await getSelectStandardValue({
                        standardFieldId: row.standardFieldId
                      })
                      if (res1.code == 0) {
                        if (res1.data && res1.data.length) {
                          this.$set(row,'selectDataList',res1.data)
                        } else {
                          this.$set(row,'selectDataList',[])
                        }
                        // row.selectDataList = res.data
                        
                      }
                    }
                  }
                  this.form.inspectionTable.forEach(v => {
                    // this.$set(v,'definitionItemId',`${this.resultPropertyObj[v.resultProperty]}-${v.standardFieldName}`)
                    this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
                    this.$set(v,'isEdit',true)
                  })
                  // if (this.form.prescription.itemList) {
                  //   // this.form.prescription.itemList.forEach(v => {
                  //   //   if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
                  //   //     this.$set(v,'definitionDrugId',v.drugName)
                  //   //   }
                  //   //   this.$set(v,'isEdit',true)
                  //   // })
                  //   for (const row of this.form.prescription.itemList) {
                  //     if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
                  //       this.$set(row,'definitionDrugId',row.drugName)
                  //     }
                  //     this.$set(row,'isEdit',true)

                  //     //获取运动项目下拉数据
                  //     if (this.form.prescription.type === 4) {
                  //       let res5 = await getMoveItem({
                  //         categoryId: row.sportId,
                  //         status: false
                  //       });
                  //       if (res5.code === 0) {
                  //         this.$set(row,'moveItemList',res5.data)
                  //       }
                  //     }
                  //   }
                  // }
                }

                // this.$set(this.form,'specimenType',res.data.specimenType)
              }
            }
          }).catch(e => {
            clearInterval(this.ocrTableTimer);
            this.ocrTableTimer = ''
            this.ocrTableCount = 0
          })
        },30000)
      }
      if (this.selectFileObj.status == 2) {
        let res = await getOcrLogNew(this.selectFileObj.id)
        if (res.code === 0) {
          if (res.data && res.data.status == 1) {
            res.data.ocrBasicInfoVOS.forEach(v => {
              if (v.dataType == '日期' && v.inputValue) {
                // 日期处理
                let splitTime = v.inputValue.split(" ")[0];
                splitTime = splitTime.substring(0, 10);
                // 包含年
                if (splitTime.indexOf("年") != -1) {
                  splitTime = splitTime.replace(/年/g, "-");
                }
                // 包含月
                if (splitTime.indexOf("月") != -1) {
                  splitTime = splitTime.replace(/月/g, "-");
                }
                if (splitTime.indexOf("/") != -1) {
                  splitTime = splitTime.replace(/\//g, "-");
                }
                if (splitTime.indexOf(".") != -1) {
                  splitTime = splitTime.replace(/\./g, "-");
                }
                let isStandardTime = moment(splitTime, "YYYY-MM-DD", true).isValid();
                if (isStandardTime) {
                  v.inputValue = splitTime;
                } else {
                  v.inputValue = "";
                }
              }
            })


            // console.log(this.form,'this.form')

            this.form.standardTable = this.form.standardTable.concat(res.data.ocrBasicInfoVOS)

            const standardFieldName = 'focusFieldId'
            this.form.standardTable = this.form.standardTable.reduce((all,next)=>all.some((item)=>item[standardFieldName]==next[standardFieldName])?all:[...all,next],[])

            this.form.inspectionTable = res.data.ocrInspectResult.concat(this.form.inspectionTable)
            this.ocrImportantWordArr = res.data.ocrBasicInfoVOS.concat(res.data.ocrInspectResult)
            // this.ocrImportantWordArr = [
            //   {
            //     "standardFieldId": "10215",
            //     "standardFieldName": "报告日期",
            //     "focusFieldId": null,
            //     "focusFieldName": null,
            //     "isFocus": false,
            //     "dataType": "日期",
            //     "html": "2022-02-09 15:23:44<br/>",
            //     "id": null,
            //     "name": null,
            //     "exceptionRecord": null,
            //     "firstCategoryId": null,
            //     "firstCategoryName": null,
            //     "secondCategoryId": null,
            //     "secondCategoryName": null,
            //     "doseUnit": "",
            //     "unitList": null,
            //     "ocrRange": null,
            //     "inputValue": "2022-02-09 15:23:44\n",
            //     "resultProperty": null,
            //     billDemo: 'dsicm-medical/f1031b9ef80748d3adfaa1e2c35ea059.jpg'
            //   },
            //   {
            //     "standardFieldId": "10226",
            //     "standardFieldName": "检查所见",
            //     "focusFieldId": null,
            //     "focusFieldName": null,
            //     "isFocus": false,
            //     "dataType": "字符串",
            //     "html": "及其解释:<br/>经置管注入20ml造影剂后，透视下摄片观察，宫腔显影可，形态无异常，双侧输卵管间质部及壶腹部造影剂通过良好，走行自然，远端可见造影剂充盈显影，双侧输卵管远端积水扩张。<br/>停注造影剂拔管后摄片观察，盆腔区未见造影剂弥散，双侧伞端可见造影剂淤积膨隆。<br/>总结意见：<br/>考虑双侧输卵管峡部、伞端积水，请结合临床。",
            //     "id": null,
            //     "name": null,
            //     "exceptionRecord": null,
            //     "firstCategoryId": null,
            //     "firstCategoryName": null,
            //     "secondCategoryId": null,
            //     "secondCategoryName": null,
            //     "doseUnit": "",
            //     "unitList": null,
            //     "ocrRange": null,
            //     "inputValue": "及其解释:\n经置管注入20ml造影剂后，透视下摄片观察，宫腔显影可，形态无异常，双侧输卵管间质部及壶腹部造影剂通过良好，走行自然，远端可见造影剂充盈显影，双侧输卵管远端积水扩张。\n停注造影剂拔管后摄片观察，盆腔区未见造影剂弥散，双侧伞端可见造影剂淤积膨隆。\n总结意见：\n考虑双侧输卵管峡部、伞端积水，请结合临床。",
            //     "resultProperty": null,
            //     billDemo: ''
            //   },
            //   {
            //     "standardFieldId": "10226",
            //     "standardFieldName": "过往病史",
            //     "focusFieldId": null,
            //     "focusFieldName": null,
            //     "isFocus": false,
            //     "dataType": "字符串",
            //     "html": "及其解释:<br/>经置管注入20ml造影剂后，透视下摄片观察，宫腔显影可，形态无异常，双侧输卵管间质部及壶腹部造影剂通过良好，走行自然，远端可见造影剂充盈显影，双侧输卵管远端积水扩张。<br/>停注造影剂拔管后摄片观察，盆腔区未见造影剂弥散，双侧伞端可见造影剂淤积膨隆。<br/>总结意见：<br/>考虑双侧输卵管峡部、伞端积水，请结合临床。",
            //     "id": null,
            //     "name": null,
            //     "exceptionRecord": null,
            //     "firstCategoryId": null,
            //     "firstCategoryName": null,
            //     "secondCategoryId": null,
            //     "secondCategoryName": null,
            //     "doseUnit": "",
            //     "unitList": null,
            //     "ocrRange": null,
            //     "inputValue": "及其解释:\n经置管注入20ml造影剂后，透视下摄片观察，宫腔显影可，形态无异常，双侧输卵管间质部及壶腹部造影剂通过良好，走行自然，远端可见造影剂充盈显影，双侧输卵管远端积水扩张。\n停注造影剂拔管后摄片观察，盆腔区未见造影剂弥散，双侧伞端可见造影剂淤积膨隆。\n总结意见：\n考虑双侧输卵管峡部、伞端积水，请结合临床。",
            //     "resultProperty": null,
            //     billDemo: 'wechat/patient/ab0c13b793054bbaaf432231be7ebc34.jpg'
            //   }
            // ]

            const name = 'focusFieldId'
            // this.form.inspectionTable = this.form.inspectionTable.reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
            this.allInspectTableData = res.data.ocrInspectResult.concat(this.form.inspectionTable).reduce((all,next)=>all.some((item)=>item[name]==next[name])?all:[...all,next],[])
            this.form.inspectionTable = this.allInspectTableData.filter(v => v.specimenType == this.form.specimenType)

            // this.form.type = res.data.dsicmType
            this.dsicmType = res.data.dsicmType

            // if (this.editBack) {
            //   // 编辑时，表格显示编辑状态
            //   // this.form.standardTable.forEach(v => {
            //   //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
            //   //   this.$set(v,'isEdit',true)
            //   // })
            //   for (const row of this.form.standardTable) {
            //     this.$set(row,'standardFieldIdObj',row.standardFieldName)
            //     this.$set(row,'isEdit',true)
            //     // //获取下拉数据
            //     // if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
            //     //   let res1 = await getSelectStandardValue({
            //     //     standardFieldId: row.standardFieldId
            //     //   })
            //     //   if (res1.code == 0) {
            //     //     if (res1.data && res1.data.length) {
            //     //       this.$set(row,'selectDataList',res1.data)
            //     //     } else {
            //     //       this.$set(row,'selectDataList',[])
            //     //     }
            //     //     // row.selectDataList = res.data
                    
            //     //   }
            //     // }
            //   }
            //   this.form.inspectionTable.forEach(v => {
            //     this.$set(v,'definitionItemId',`${v.firstCategoryName}-${v.name}`)
            //     this.$set(v,'isEdit',true)
            //   })
            //   if (this.form.prescription.itemList) {
            //     this.form.prescription.itemList.forEach(v => {
            //       if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
            //         this.$set(v,'definitionDrugId',v.drugName)
            //       }
            //       this.$set(v,'isEdit',true)
            //     })
            //   }
            // }
          }
        }
      }
    },
    async getOcrText(loopTag) {
      if (this.selectFileObj.status == 1 || loopTag == 'loop') {
        // for (let i = 0; i < 120; i++) {
        //   try {
        //     let res = await getOcrLogText(this.selectFileObj.id);
        //     if (res.code === 0) {
        //       if (res.data && res.data.status == 1) {
        //         clearInterval(this.ocrTextTimer)
        //         this.ocrRecognizeUrl = res.data.recognizeUrl
        //         this.textList = res.data.textList
        //         this.ocrRecognizeResult = res.data.originalInfoVOS
        //         break;
        //       }
        //     }
        //   } catch(err){
        //     console.log(err)
        //     break;
        //   } 
        // }


        this.ocrTextTimer = setInterval(async () => {
          this.ocrTextCount++
          if (this.ocrTextCount == 121) {
            clearInterval(this.ocrTextTimer)
            this.ocrTextTimer = ''
            this.ocrTextCount = 0
            return
          }
          getOcrLogText(this.selectFileObj.id).then(res => {
            if (res.code === 0) {
              if (res.data && res.data.status == 1) {
                clearInterval(this.ocrTextTimer)
                this.ocrRecognizeUrl = res.data.recognizeUrl
                this.textList = res.data.textList
                this.ocrRecognizeResult = res.data.originalInfoVOS
              }
            }
          }).catch(e => {
            clearInterval(this.ocrTextTimer)
            this.ocrTextTimer = ''
            this.ocrTextCount = 0
          })
          
        },30000)
      }
      if (this.selectFileObj.status == 2) {
        let res = await getOcrLogText(this.selectFileObj.id)
        if (res.code === 0) {
          if (res.data && res.data.status == 1) {
            this.ocrRecognizeUrl = res.data.recognizeUrl
            this.textList = res.data.textList
            this.ocrRecognizeResult = res.data.originalInfoVOS
          }
        }
      }
      
      // // this.selectFileObj.id
      // let res = await getOcrLogText(this.crossReferenItem.id);
      // if (res.code == 0) {
      //   this.textList = res.data.textList;
      //   this.ocrRecognizeResult = res.data.originalInfoVOS;
      // }
    },
    // 未录入状态的
    async refeDialog(item) {
      // console.log(this.selectFileObj)
      
      if (this.routeEntry == 7 || this.routeEntry == 6) {
        await this.getNewByEventDetail(this.selectFileObj)
      }
      
      
    },
    async noEntryData(item) {
      // 清除定时器
      this.ocrTextCount = 0
      clearInterval(this.ocrTextTimer)
      this.ocrTextTimer = ""
      this.ocrTableCount = 0
      clearInterval(this.ocrTableTimer)
      this.ocrTableTimer = ""

      clearInterval(this.ocrtimer);
      this.ocrtimer = "";
      this.count = 0;
      this.ocrFlag = false;


      this.form.standardTable = []
      this.form.inspectionTable = []
      this.form.prescription = {}

      // 未录入

        // ocr识别文件
        await this.getOcrText()
        // return
        // 识别录入数据
        await this.getOcrData()
        // await this.getKinsFolk();
        this.showOcrText = true;
        this.patientFilesItemId = item.id;
        // console.log(item.id, "item.id");
        // apiGetPatientFiles 2.0.7版本弃用
        let res = await apiGetPatientFiles({
          patientFilesItemId: this.patientFilesItemId
        })
        if (res.code == 0) {
          // }).then(res => {
          this.originalEntryInfo = DEEP_CLONE(res.data)
          let dataObj = DEEP_CLONE(res.data);
          if (res.data.patientRelativeId) {
            dataObj.itemBelong = 2
          } else {
            dataObj.itemBelong = 1
          }

          // this.form.standardTable = dataObj.ocrJsonDTO.ocrBasicInfoDTOS
          // this.form.inspectionTable = dataObj.ocrJsonDTO.ocrInspectDTOS
          // dataObj.itemBelong = 1
          this.form = dataObj
          // dataObj.patientFilesItem.ocrTime = '2021-09-08'
          this.ocrTime = dataObj.patientFilesItem.ocrTime
          if (!this.form.standardTable || this.form.standardTable.length == 0) {
            this.$set(this.form,'standardTable',[])
          }
          if (!this.form.inspectionTable || this.form.inspectionTable.length == 0) {
            this.$set(this.form,'inspectionTable',[])
          }

          this.activeName = "first";
          // this.getOcrRecognize(item.id);
          this.patientFilesId = res.data.id;

          // console.log(this.form)
          // if (!this.form.prescription) {
          //   this.form.prescription = {}
          // }

          this.hospitalDays = this.form.patientMedicalDocs.lengthOfStay;
          this.form.archivesEventName = res.data.archivesEventName ? res.data.archivesEventName : "";
          this.form.eventName = this.form.eventName ? this.form.eventName : this.form.archivesEventName.substring(0, 2);

          // patientFilesItem
          this.fileListArr.push(this.form.patientFilesItem);
          this.filePicList = this.form.fileList;
          // this.selectFileObj = this.fileListArr[0];
          this.selectFileObj = this.form.patientFilesItem; // 匹配当前文件
          // this.picName = this.selectFileObj.fileName;

          this.selectFileObj = this.form.patientFilesItem;
          // console.log(this.selectFileObj, "selectFileObj");
          this.picName = this.selectFileObj.fileName;
          // console.log(this.picName, "this.picName");
          // 有旋转角度的
          if (this.selectFileObj.filePath.indexOf("/rotate,") != -1) {
            this.rightcountDeg = Number(this.selectFileObj.filePath.split("/rotate,")[1]);
            this.previewPicturesUrl = this.selectFileObj.filePath.split("?x-oss-process=image")[0];
          } else {
            this.rightcountDeg = 0;
            this.previewPicturesUrl = this.selectFileObj.filePath;
          }
          if (res.data.archivesEventId) {
            this.form.prentype = 2;
            // this.deleteDom = true;
          } else {
            this.form.prentype = 1;
          }
          // console.log(this.previewPicturesUrl, "this.previewPicturesUrl");

          if (this.selectFileObj.status == 1) {
            // 未录入
            // this.editBack = true;
            this.form.eventName = "";
            this.form.inspectionTable = [];
          } else {
            // 已录入
            // this.editBack = false;

            if (this.form.inspectionTable) {
              // this.form.inspectionTable.map(v => {
              //   // item.isEdit = false
              //   this.$set(v, "isEdit", false);
              // });
            } else {
              this.form.inspectionTable = [];
            }
          }
          // this.changeItemBelong();
          this.searchArchivesEvent()
        }

    },
    async yetEntryData(item) {

      // 已录入
      
      await this.entryFileDetail(this.selectFileObj)

    },
    // 病人管理——诊疗事件详情查询
    async getNewByEventDetail(item) {
      // console.log(item)
      // return
      // await this.getKinsFolk()
      this.showOcrText = true
      this.patientFilesItemId = item.id
      // console.log(item.id, "item.id");
      // apiGetPatientFiles 2.0.7版本弃用
      let res = await getNewByEventMedicalId({
        eventMedicalId: item.id
      })
      if (res.code == 0) {
        // }).then(res => {
        this.originalEntryInfo = DEEP_CLONE(res.data)
        let dataObj = DEEP_CLONE(res.data);
        if (res.data.patientRelativeId) {
          dataObj.itemBelong = 2
        } else {
          dataObj.itemBelong = 1
        }
        // this.selectArchivesEvent.id = dataObj.archivesEventId
        // this.selectArchivesEvent.eventName = dataObj.eventName

        
        // dataObj.itemBelong = 1
        this.form = dataObj
        // 获取当前录入病程详情
        this.getArchivesDetail(this.form.archivesEventId)
        // 删除的病程回显
        if (this.form.archivesEventId && this.form.archivesEventName.indexOf('null') != -1) {
          this.form.archivesEventId = ''
        } else {
          // this.selectArchivesEvent.id = dataObj.archivesEventId
          // this.selectArchivesEvent.eventName = dataObj.eventName
        }
        // console.log(this.form.archivesEventId,'this.form.archivesEventId')
        this.$set(this.form,'standardTable',dataObj.ocrJsonDTO.ocrBasicInfoDTOS)
        this.$set(this.form,'inspectionTable',dataObj.ocrJsonDTO.ocrInspectDTOS ? dataObj.ocrJsonDTO.ocrInspectDTOS : [])
        this.allInspectTableData = dataObj.ocrJsonDTO.ocrInspectDTOS
        // this.form.standardTable = dataObj.ocrJsonDTO.ocrBasicInfoDTOS
        // this.form.inspectionTable = dataObj.ocrJsonDTO.ocrInspectDTOS

        this.form.prescription = dataObj.ocrJsonDTO.prescription
        if (!this.form.prescription) {
          this.form.prescription = {}
        }
        if (this.editBack) {
          // 编辑时，表格显示编辑状态
          // this.form.standardTable.forEach(v => {
          //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
          //   this.$set(v,'isEdit',true)
          // })
          for (const row of this.form.standardTable) {
            this.$set(row,'standardFieldIdObj',row.focusFieldName)
            this.$set(row,'isEdit',true)
            //获取下拉数据
            if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
              let res1 = await getSelectStandardValue({
                standardFieldId: row.standardFieldId
              })
              if (res1.code == 0) {
                if (res1.data && res1.data.length) {
                  this.$set(row,'selectDataList',res1.data)
                } else {
                  this.$set(row,'selectDataList',[])
                }
                // row.selectDataList = res.data
                
              }
            }
            if (row.dataType == '多选' || row.dataType == '多选下拉' || row.standardFieldName == '省市区') {
              if (row.standardFieldName == '省市区') {
                this.resetCascader++
              }
              if (row.inputValue) {
                row.inputValue = row.inputValue.split(',')
              } else {
                row.inputValue = []
              }
            }
          }

          this.form.inspectionTable.forEach(v => {
            // this.$set(v,'definitionItemId',`${this.resultPropertyObj[v.resultProperty]}-${v.standardFieldName}`)
            this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
            this.$set(v,'isEdit',true)
          })
          // console.log(this.form.inspectionTable,'this.form.inspectionTable')
          if (this.form.prescription.itemList) {
            // this.form.prescription.itemList.forEach(v => {
            //   if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
            //     this.$set(v,'definitionDrugId',v.drugName)
            //   }
            //   this.$set(v,'isEdit',true)
            // })
            for (const row of this.form.prescription.itemList) {
              // if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
              //   this.$set(row,'definitionDrugId',row.drugName)
              // }
              this.$set(row,'isEdit',true)

              //获取运动项目下拉数据
              if (this.form.prescription.type === 4) {
                let res5 = await getMoveItem({
                  categoryId: row.sportId,
                  status: false
                });
                if (res5.code === 0) {
                  this.$set(row,'moveItemList',res5.data)
                }
              }
            }
          }
        }
        // // 标准字段值回显
        // for (const row of this.form.standardTable) {
        //   // 获取标准字段值下拉数据
        //   let res1 = await getSelectStandardValue({
        //     standardFieldId: row.standardFieldId
        //   })
        //   if (res1.code == 0) {
        //     if (res1.data && res1.data.length) {
        //       this.$set(row,'selectDataList',res1.data)
        //     } else {
        //       this.$set(row,'selectDataList',[])
        //     }
        //     // row.selectDataList = res.data
            
        //   }
        //   if (row.dataType == '多选' || row.dataType == '多选下拉' || row.standardFieldName == '省市区') {
        //     if (row.standardFieldName == '省市区') {
        //       this.resetCascader++
        //     }
        //     if (row.inputValue) {
        //       row.inputValue = row.inputValue.split(',')
        //     } else {
        //       row.inputValue = []
        //     }
        //   }
        // }
        // console.log('this.form.prescription',this.form.prescription)
        this.activeName = "first";
        // this.getOcrRecognize(item.id);
        this.patientFilesId = res.data.id;

        this.hospitalDays = this.form.patientMedicalDocs.lengthOfStay;
        this.form.archivesEventName = res.data.archivesEventName ? res.data.archivesEventName : "";
        this.form.eventName = this.form.eventName ? this.form.eventName : this.form.archivesEventName.substring(0, 2);

        // patientFilesItem
        this.fileListArr.push(this.form.patientFilesItem);
        this.filePicList = this.form.fileList;
        // this.selectFileObj = this.fileListArr[0];
        this.selectFileObj = this.form.patientFilesItem; // 匹配当前文件
        // this.picName = this.selectFileObj.fileName;

        this.selectFileObj = this.form.patientFilesItem ? this.form.patientFilesItem : {};
        if (this.routeEntry == 6) {
          // console.log(this.selectFileObj, "selectFileObj");
          this.picName = this.selectFileObj.fileName;
          // console.log(this.picName, "this.picName");
          // 有旋转角度的
          if (this.selectFileObj.filePath.indexOf("/rotate,") != -1) {
            this.rightcountDeg = Number(this.selectFileObj.filePath.split("/rotate,")[1]);
            this.previewPicturesUrl = this.selectFileObj.filePath.split("?x-oss-process=image")[0];
          } else {
            this.rightcountDeg = 0;
            this.previewPicturesUrl = this.selectFileObj.filePath;
          }
        }

        if (this.selectFileObj.status == 1) {
          // 未录入
          // this.editBack = true;
          this.form.eventName = "";
          this.form.inspectionTable = [];
        } else {
          // 已录入
          // this.editBack = false;

          if (this.form.inspectionTable) {
            // this.form.inspectionTable.map(v => {
            //   // item.isEdit = false
            //   this.$set(v, "isEdit", false);
            // });
          } else {
            this.form.inspectionTable = [];
          }
        }
        // this.changeItemBelong();
        this.searchArchivesEvent()

        // });
        // console.log(this.form,'表单数据')
      }
    },
    // 已录入查询详情
    async entryFileDetail(item) {
      // 清除定时器
      this.ocrTextCount = 0
      clearInterval(this.ocrTextTimer)
      this.ocrTextTimer = ""
      this.ocrTableCount = 0
      clearInterval(this.ocrTableTimer)
      this.ocrTableTimer = ""

      clearInterval(this.ocrtimer);
      this.ocrtimer = "";
      this.count = 0;
      this.ocrFlag = false;

      // this.form.standardTable = []
      // this.form.inspectionTable = []
      // this.form.prescription = {}
      
      // ocr识别文件
      await this.getOcrText()
      // return
      this.form.standardTable = []
      this.form.inspectionTable = []
      this.form.prescription = {}
      // 识别录入数据
      await this.getOcrData()

      // await this.getKinsFolk()
      this.showOcrText = true
      this.patientFilesItemId = item.id
      // console.log(item.id, "item.id");
      // apiGetPatientFiles 2.0.7版本弃用
      let res = await getNewByRefId({
        refId: item.id
      })
      // console.log(res,"resresresres");
      if (res.code == 0) {
        // }).then(res => {
        this.originalEntryInfo = DEEP_CLONE(res.data)
        let dataObj = DEEP_CLONE(res.data);
        // dataObj.patientFilesItem.ocrTime = '2021-09-08'
        this.ocrTime = dataObj.patientFilesItem.ocrTime
        if (res.data.patientRelativeId) {
          dataObj.itemBelong = 2
        } else {
          dataObj.itemBelong = 1
        }

        
        // dataObj.itemBelong = 1
        this.form = dataObj
        this.form.draftId = res.data.draftId
        // console.log(dataObj,'dataObj');
        // 获取当前录入病程详情
        if (this.form.patientFilesItem.status == 5) {
          this.form.archivesEventId = this.form.draftArchivesEventId
          this.getArchivesDetail(this.form.draftArchivesEventId)
        } else {
          this.getArchivesDetail(this.form.archivesEventId)
        }
        // 删除的病程回显
        if (this.form.archivesEventId && this.form.archivesEventName.indexOf('null') != -1) {
          this.form.archivesEventId = ''
        } else {
          // this.selectArchivesEvent.id = dataObj.archivesEventId
          // this.selectArchivesEvent.eventName = dataObj.eventName
        }
        // console.log(this.form.archivesEventName,'this.form.archivesEventName')
        // console.log(this.form.archivesEventId,'this.form.archivesEventId')
        this.$set(this.form,'standardTable',dataObj.ocrJsonDTO.ocrBasicInfoDTOS)
        this.$set(this.form,'inspectionTable',dataObj.ocrJsonDTO.ocrInspectDTOS ? dataObj.ocrJsonDTO.ocrInspectDTOS : [])
        // this.form.inspectionTable = dataObj.ocrJsonDTO.ocrInspectDTOS
        this.allInspectTableData = dataObj.ocrJsonDTO.ocrInspectDTOS

        this.form.prescription = dataObj.ocrJsonDTO.prescription;
        if (!this.form.prescription) {
          this.form.prescription = {}
        }
        // console.log(this.editBack,'this.editBack')
        if (this.editBack) {
          // 编辑时，表格显示编辑状态
          // this.form.standardTable.forEach(v => {
          //   this.$set(v,'standardFieldIdObj',v.standardFieldName)
          //   this.$set(v,'isEdit',true)
          // })
          for (const row of this.form.standardTable) {
            this.$set(row,'standardFieldIdObj',row.focusFieldName)
            this.$set(row,'isEdit',true)
            //获取下拉数据
            if (row.dataType == '单选下拉' || row.dataType == '多选下拉' || row.dataType == '多选') {
              let res1 = await getSelectStandardValue({
                standardFieldId: row.standardFieldId
              })
              if (res1.code == 0) {
                if (res1.data && res1.data.length) {
                  this.$set(row,'selectDataList',res1.data)
                } else {
                  this.$set(row,'selectDataList',[])
                }
                // row.selectDataList = res.data
                
              }
            }
            if (row.dataType == '多选' || row.dataType == '多选下拉' || row.standardFieldName == '省市区') {
              if (row.standardFieldName == '省市区') {
                this.resetCascader++
              }
              if (row.inputValue) {
                row.inputValue = row.inputValue.split(',')
              } else {
                row.inputValue = []
              }
            }
          }

          this.form.inspectionTable.forEach(v => {
            // this.$set(v,'definitionItemId',`${v.firstCategoryName}-${v.name}`)
            // this.$set(v,'definitionItemId',`${this.resultPropertyObj[v.resultProperty]}-${v.standardFieldName}`)
            this.$set(v,'definitionItemId',v.focusFieldName && v.resultProperty !== null ? `${this.resultPropertyObj[v.resultProperty]}-${v.focusFieldName}` : v.name)
            this.$set(v,'isEdit',true)
          })
          if (this.form.prescription.itemList) {
            // this.form.prescription.itemList.forEach(v => {
            //   if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
            //     this.$set(v,'definitionDrugId',v.drugName)
            //   }
            //   this.$set(v,'isEdit',true)
            // })
            for (const row of this.form.prescription.itemList) {
              // if (this.form.prescription.type == 1 || this.form.prescription.type == 5) {
              //   this.$set(row,'definitionDrugId',row.drugName)
              // }
              this.$set(row,'isEdit',true)

              //获取运动项目下拉数据
              if (this.form.prescription.type === 4) {
                let res5 = await getMoveItem({
                  categoryId: row.sportId,
                  status: false
                });
                if (res5.code === 0) {
                  // console.log(res5.data,'res5.data')
                  this.$set(row,'moveItemList',res5.data)
                }
              }
            }
          }
        }
        // // 标准字段值回显
        // for (const row of this.form.standardTable) {
        //   // 获取标准字段值下拉数据
        //   let res1 = await getSelectStandardValue({
        //     standardFieldId: row.standardFieldId
        //   })
        //   if (res1.code == 0) {
        //     if (res1.data && res1.data.length) {
        //       this.$set(row,'selectDataList',res1.data)
        //     } else {
        //       this.$set(row,'selectDataList',[])
        //     }
        //     // row.selectDataList = res.data
            
        //   }
        //   if (row.dataType == '多选' || row.dataType == '多选下拉' || row.standardFieldName == '省市区') {
        //     if (row.standardFieldName == '省市区') {
        //       this.resetCascader++
        //     }
        //     if (row.inputValue) {
        //       row.inputValue = row.inputValue.split(',')
        //     } else {
        //       row.inputValue = []
        //     }
        //   }
        // }


        // console.log(this.form.prescription,'this.form.prescription')
        this.activeName = "first";
        // this.getOcrRecognize(item.id);
        this.patientFilesId = res.data.id;

        this.hospitalDays = this.form.patientMedicalDocs.lengthOfStay;
        this.form.archivesEventName = res.data.archivesEventName ? res.data.archivesEventName : "";
        this.form.eventName = this.form.eventName ? this.form.eventName : this.form.archivesEventName.substring(0, 2);

        // patientFilesItem
        this.fileListArr.push(this.form.patientFilesItem);
        this.filePicList = this.form.fileList;
        // this.selectFileObj = this.fileListArr[0];
        this.selectFileObj = this.form.patientFilesItem; // 匹配当前文件
        // this.picName = this.selectFileObj.fileName;

        // this.selectFileObj = this.form.patientFilesItem;
        // console.log(this.selectFileObj, "selectFileObj");
        this.picName = this.selectFileObj.fileName;
        // console.log(this.picName, "this.picName");
        // 有旋转角度的
        if (this.selectFileObj.filePath.indexOf("/rotate,") != -1) {
          this.rightcountDeg = Number(this.selectFileObj.filePath.split("/rotate,")[1]);
          this.previewPicturesUrl = this.selectFileObj.filePath.split("?x-oss-process=image")[0];
        } else {
          this.rightcountDeg = 0;
          this.previewPicturesUrl = this.selectFileObj.filePath;
        }

        if (this.selectFileObj.status == 1) {
          // 未录入
          // this.editBack = true;
          this.form.eventName = "";
          this.form.inspectionTable = [];
        } else {
          // 已录入
          // this.editBack = false;

          if (this.form.inspectionTable) {
            // this.form.inspectionTable.map(v => {
            //   // item.isEdit = false
            //   this.$set(v, "isEdit", false);
            // });
          } else {
            this.form.inspectionTable = [];
          }
        }
        // this.changeItemBelong();
        this.searchArchivesEvent()

        // });
        // console.log(this.form,'表单数据')
      }
    },
    // /**
    //  * @description:  输入字段查询药品名字
    //  * @param {*}
    //  * @return {*}
    //  */
    // remoteMethod1(val) {
    //   api_getdrug({
    //     name: val
    //   }).then(res => {
    //     this.druglist = res.data;
    //   });
    // },
    // //表格选中药品change 事件
    // drugClick(val) {
    //   this.form.prescription.itemList[this.drugIndex].drugName = val.name;
    //   this.form.prescription.itemList[this.drugIndex].drugId = val.id;
    //   this.form.prescription.itemList[this.drugIndex].drugSpecification = val.specifications;
    // },
    // drugClick1(val) {
    //   this.addPrescription.drugName = val.name;
    //   this.addPrescription.drugId = val.id;
    //   this.addPrescription.drugSpecification = val.specifications;
    // },
    // 切换归属
    async changeItemBelong(val, mark) {
      this.form.archivesEventId = ''
      this.form.archivesEventName = ''
      this.selectArchivesEvent = {}
      this.searchArchivesEvent()
    },
    // 查询病程记录
    async searchArchivesEvent() {
      // // this.selectArchivesEvent = {}
      // let res = await archivesEventPage({
      //   patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
      //   patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id,
      //   start: this.courseTime ? this.courseTime[0] : null,
      //   end: this.courseTime ? this.courseTime[1] : null,
      //   size: 5000,
      //   current: 1,
      //   isSelf: this.form.itemBelong == 1 ? true : false
      // })
      // // console.log(res)
      // if (res.code == 0) {
      //   this.archivesEventData = res.data.records
      //   if (!this.archivesEventData.length) {
      //     this.selectArchivesEvent = {}
      //   }
      // }
      //获取关联病程
      let res = await archivesEventPage({
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
        patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id,
        start: null,
        end: null,
        size: 5000,
        current: 1,
        isSelf: this.form.itemBelong == 1 ? true : false
      })
      // console.log(res)
      if (res.code == 0) {
        this.archivesIdarr = res.data.records
        // if (!this.archivesIdarr.length) {
        //   this.selectArchivesEvent = {}
        // }
      }
      // let res = await api_archives_options({
      //   patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
      //   patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id
      // })
      // // console.log(res)
      // if (res.code == 0) {
      //   // console.log(res.data,'res.data')
      //   this.archivesIdarr = res.data;
      //   // console.log(this.archivesIdarr,'this.archivesIdarr')
      // }
    },
    // async querySearch(queryString, cb) {
    //   let res = await getPlaceList({
    //     keyWord: queryString,
    //     type: 1
    //   });
    //   if (res.code === 0) {
    //     res.data.forEach(ele => {
    //       ele.value = ele.name;
    //     });
    //     this.hospitalList = res.data;
    //     cb(this.hospitalList);
    //   }
    // },
    // async queryDepartment(queryString, cb) {
    //   // let res = await getDepartmentList({
    //   //   keyword: queryString
    //   // })
    //   // if (res.code === 0) {
    //   //   res.data.forEach(ele => {
    //   //     ele.value = ele.name
    //   //   })
    //   //   this.departmentList = res.data
    //   //   cb(this.departmentList)
    //   // }
    //   let res = await getPlaceList({
    //     keyWord: queryString,
    //     type: 2
    //   });
    //   if (res.code === 0) {
    //     res.data.forEach(ele => {
    //       ele.value = ele.name;
    //     });
    //     this.departmentList = res.data;
    //     cb(this.departmentList);
    //   }
    // },
    //对照录入文件删除按钮
    deleteFileItem() {
      if (this.filePicList.length > 1) {
        let currentImgIndex = this.filePicList.findIndex(v => v.filePath == this.selectFileObj.filePath)
        this.filePicList.splice(currentImgIndex, 1)
        this.form.patientFilesItem = this.filePicList[0]
        this.picName = this.form.patientFilesItem.fileName
        this.selectFileObj = this.form.patientFilesItem
        this.selectFileObj = this.filePicList[0]
        // 有旋转角度的
        if (this.selectFileObj.filePath.indexOf("/rotate,") != -1) {
          this.rightcountDeg = Number(this.selectFileObj.filePath.split("/rotate,")[1]);
          this.previewPicturesUrl = this.selectFileObj.filePath.split("?x-oss-process=image")[0];
        } else {
          this.rightcountDeg = 0;
          this.previewPicturesUrl = this.selectFileObj.filePath;
        }
      } else {
        this.$message.error("必须保留一项");
      }
    },
    /**
     * @description: 检验层方法
     * @param {*}
     * @return {*}
     */
    //获取检验类别
    // getConditionList() {
    //   getCategoryByCondition({ status: false, type: 2, parentId: 0 }).then(
    //     res => {
    //       if (res.code == 0) {
    //         this.pushMedicalDocsList = res.data;
    //       }
    //     }
    //   );
    // },
    focusInspectName() {
      if (!this.form.specimenType) {
        this.$message.error("请选择标本后录入检验指标")
        return
      }
      this.inspectionList = this.cloneInspectionList
      let inspectFocusFieldIds = this.form.inspectionTable.map(v => v.focusFieldId)
      // console.log(inspectFocusFieldIds)
      this.inspectionList.forEach(v => {
        if (inspectFocusFieldIds.indexOf(v.focusFieldId) != -1) {
          // v.disabled = true
          this.$set(v,'disabledItem',true)
        } else {
          this.$set(v,'disabledItem',false)
        }
      })
    },
    addExamineData() {
      if (!this.form.specimenType) {
        this.$message.error("请选择标本类型")
        return
      }

      this.itemQuery = "";
      // let editArr = [];
      // this.inspectionList = [];
      this.codePage.current = 1;
      // editArr = this.form.inspectionTable.filter(item => item.isEdit === true);
      // if (editArr.length === 1) {
      //   this.$message.error("请完成当前编辑");
      //   return;
      // }
      // let preCheckoutRowObj = this.form.inspectionTable[this.form.inspectionTable.length - 1];
      this.form.inspectionTable.push({
        // secondCategoryId: "",
        // name: "",
        // id: "",
        // abbreviation: "",
        // doseUnit: "",
        // range: "",
        // inputValue: "",
        // isEdit: true,
        // exceptionRecord: 3,
        // unitList: []

        standardFieldId: "",
        standardFieldName: "",
        isFocus: true,
        dataType: null,
        html: "",
        name: "",
        id: "",
        exceptionRecord: 3,
        // firstCategoryId: "",
        // firstCategoryName: "",
        // secondCategoryId: "",
        // secondCategoryName: "",
        doseUnit: "",
        unitList: [],
        ocrRange: "",
        inputValue: "",
        resultProperty: null,
        isEdit: true,
        references: '',
        referencesList: [],
        fieldDescription: ''
      });
      // let inspectFocusFieldIds = this.form.inspectionTable.map(v => v.focusFieldId)
      // this.inspectionList.forEach(v => {
      //   if (inspectFocusFieldIds.indexOf(v.focusFieldId) != -1) {
      //     // v.disabled = true
      //     this.$set(v,'disabledItem',true)
      //   } else {
      //     this.$set(v,'disabledItem',false)
      //   }
      // })

      // if (preCheckoutRowObj.secondCategoryId) {
      //   getInspectionList({
      //       secondCategoryId:preCheckoutRowObj.secondCategoryId,
      //       status:true,
      //   }).then(res=>{
      //       if(res.code == 0){
      //         this.inspectionList = res.data
      //       }
      //   })
      // }
    },

    //处方类型change事件
    selectChange() {
      this.form.prescription.itemList = [];
      // this.categoryChose = false; //添加检验
      // this.prescriptionChose = false; //添加西药
      // this.chineseMedicine = false; //添加中药
      // this.sportData = false; //添加运动处方
      // this.treamentShow = false; //添加治疗处方
    },
    //列表选择项目后触发得事件
    async listNameChange(val, row) {
      this.$set(row,'definitionItemId',`${this.resultPropertyObj[val.resultProperty]}-${val.focusFieldName}`)

      
      // console.log(row)
      // row.doseUnit = ""; // 切换后清空检验项目
      // row.unitList = [];

      // // 清空row行内数据
      // row.standardFieldId = ""
      // row.standardFieldName = ""
      // row.isFocus = false
      // row.dataType = null
      // row.html = ""
      // // row.name = ""
      // row.id = ""
      // // row.exceptionRecord = 3
      // row.firstCategoryId = ""
      // row.firstCategoryName = ""
      // row.secondCategoryId = ""
      // row.secondCategoryName = ""
      // // row.doseUnit = ""
      // // row.unitList = []
      // row.ocrRange = ""
      // 切换清空检验结果
      row.inputValue = ""
      row.references = ''
      // row.resultProperty = null
      // // isEdit: true

      // row.isFocus = false
      // row.focusFieldId = ''
      // row.focusFieldName = ''
      // row.standardFieldId = ''
      // row.standardFieldName = ''

      // let selectItem = this.inspectionList.filter(item => item.focusFieldId === val)[0];

      row.id = val.inspectionInfoId
      row.name = val.inspectionName;
      row.doseUnit = val.unitList && val.unitList.length ? val.unitList[0] : '';
      row.unitList = val.unitList
      row.focusFieldId = val.focusFieldId
      row.focusFieldName = val.focusFieldName
      row.standardFieldId = val.standardFieldId
      row.standardFieldName = val.standardFieldName
      row.resultProperty = val.resultProperty
      row.dataType = val.dataType
      row.specimenType = val.specimenType

      row.referencesList = val.referencesList

      row.fieldDescription = val.fieldDescription

      row.addItem = false;

      let inspectFocusFieldIds = this.form.inspectionTable.map(v => v.focusFieldId)
      this.inspectionList.forEach(v => {
        if (inspectFocusFieldIds.indexOf(v.focusFieldId) != -1) {
          // v.disabled = true
          this.$set(v,'disabledItem',true)
        } else {
          this.$set(v,'disabledItem',false)
        }
      })


      // if (!val) return;
      // let selectItem = this.inspectionList.filter(item => item.id === val)[0];
      // console.log(selectItem)
      // if (selectItem) {
      //   // console.log(selectItem,'检验项目selectItem')
      //   // this.form.inspectionTable[this.categoryIndex].id = e.id
      //   row.name = selectItem.name;
      //   // row.abbreviation = selectItem.abbreviation
      //   // row.doseUnit = selectItem.doseUnit
      //   row.doseUnit = selectItem.doseUnitList.length ? selectItem.doseUnitList[0] : '';
      //   // row.unitList = selectItem.doseUnit ? [selectItem.doseUnit] : []
      //   row.unitList = selectItem.doseUnitList
      //   // // row.range = selectItem.range
      //   // row.secondCategoryName = selectItem.secondCategoryName;

      //   // row.secondCategoryId = selectItem.secondCategoryId;
      //   // row.firstCategoryId = selectItem.firstCategoryId;
      //   // row.firstCategoryName = selectItem.firstCategoryName;
      //   row.addItem = false;

      //   row.id = selectItem.id
      //   console.log('this.form.type', this.form.type)
      //   // let res = await inspectionInfoFocus({
      //   //   // standardFieldId: val,
      //   //   // id: row.id,
      //   //   ...row,
      //   //   wholeCourseId: this.selectFileObj.wholeCourseId,
      //   //   patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
      //   //   type: this.form.type
      //   // })
      //   // if (res.code == 0) {
      //   //   row.isFocus = res.data.isFocus
      //   //   row.focusFieldId = res.data.focusFieldId
      //   //   row.focusFieldName = res.data.focusFieldName
      //   //   row.standardFieldId = res.data.standardFieldId
      //   //   row.standardFieldName = res.data.standardFieldName
      //   // }
      // } else {
      //   row.name = val;
      //   row.addItem = true;
      // }
      // console.log(row)
    },
    // // 切换单位
    listUnitChange(val, row) {
      if (!val) return;
      if (!row.unitList) {
        row.unitList = [];
      }
      let selectUnit = row.unitList.filter(item => item == val)[0];
      // console.log(selectUnit);
      if (!selectUnit) {
        row.addUnit = true;
      } else {
        row.addUnit = false;
      }
      // console.log(row)
    },
    // //列表编辑数据
    // async categoryEdit(index, row) {
    //   let editArr = [];
    //   editArr = this.form.inspectionTable.filter(item => item.name === row.name);
    //   if (editArr.length > 1) {
    //     this.$message.error("检验项目不可重复");
    //     return;
    //   }
    //   // debugger
    //   if (!row.isEdit) {
    //     this.inspectionList = [];
    //     this.codePage.current = 1;
    //     // await this.pushCategoryChange(row.secondCategoryId)
    //     await this.getInspectionItemList(1, row.name);
    //     let editArr = [];
    //     editArr = this.form.inspectionTable.filter(item => item.isEdit === true);
    //     if (editArr.length === 1) {
    //       this.$message.error("请完成当前编辑");
    //       return;
    //     }
    //     // // 点击编辑时获取检验项目是否重点
    //     // let res = await inspectionInfoFocus({
    //     //   // standardFieldId: val,
    //     //   // id: row.id,
    //     //   ...row,
    //     //   wholeCourseId: this.selectFileObj.wholeCourseId,
    //     //   patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId,
    //     //   type: this.form.type
    //     // })
    //     // if (res.code == 0) {
    //     //   row.isFocus = res.data.isFocus
    //     //   row.focusFieldId = res.data.focusFieldId
    //     //   row.focusFieldName = res.data.focusFieldName
    //     //   row.standardFieldId = res.data.standardFieldId
    //     //   row.standardFieldName = res.data.standardFieldName
    //     // }
    //     // // row.isEdit = true;
    //     this.$set(row,'isEdit',true)
    //   } else {
    //     let arr = [];
    //     Object.keys(row).forEach(ele => {
    //       arr.push("inspectionTable." + index + "." + ele);
    //     });
    //     // let arr = []
    //     let valiResArr = [];
    //     this.$refs.formRef.validateField(arr, error => {
    //       valiResArr.push(error);
    //       // if(!error){
    //       //     //当校验通过时，这里面写逻辑代码
    //       //   row.isEdit = false
    //       // }
    //     });
    //     let ispass = valiResArr.every(item => {
    //       return item == false;
    //     });
    //     if (ispass) {
    //       // console.log(row)
    //       // return
    //       // 数据库里没有检验项目，手动新增的数据，需要保存(addItem为true)，保存检验项目和单位
    //       if (row.addItem) {
    //         let res = await saveInspectRow({
    //           type: 1,
    //           name: row.name,
    //           doseUnit: row.doseUnit,
    //           imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
    //           exceptionRecord: row.exceptionRecord,
    //           inputValue: row.inputValue,
    //           sourceType: 1
    //         });
    //         if (res.code == 0) {
    //           row.id = res.data.id;
    //           row.addItem = false;
    //         }
    //       } else {
    //         // 数据库里没有单位，需要保存
    //         if (row.addUnit && row.doseUnit) {
    //           let res = await saveInspectRow({
    //             type: 2,
    //             name: row.name,
    //             doseUnit: row.doseUnit,
    //             imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
    //             exceptionRecord: row.exceptionRecord,
    //             inputValue: row.inputValue,
    //             sourceType: 1
    //           });
    //           if (res.code == 0) {
    //             // row.id = res.data.id
    //             row.addUnit = false;
    //           }
    //         }
    //       }
    //       //当校验通过时，这里面写逻辑代码
    //       // row.isEdit = false;
    //       this.$set(row,'isEdit',false)
    //     }
    //   }

    //   // this.categoryIndex = index
    //   // if (row.isEdit) {
    //   //     this.$delete(row, 'isEdit')
    //   // } else {
    //   //     this.$set(row, 'isEdit', true);
    //   // }
    // },
    //列表删除数据
    categoryDelete(index, row) {
      this.$confirm("是否要删除", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(() => {
        this.form.inspectionTable.splice(index, 1);
      });
    },

    // /**
    //  * @description: 处方西药层方法
    //  * @param {*}
    //  * @return {*}
    //  */
    // //新增药品保存按钮
    // prescriptionPush() {
    //   this.form.prescription.itemList.push(this.addPrescription);
    //   this.prescriptionChose = false;
    // },
    //获取频率单位用法 运动类型
    getFrequencyList() {
      // medication_frequency("medication_frequency").then(res => {
      //   //频率
      //   this.medicationList = res.data;
      // });
      // medication_frequency("drug_specs").then(res => {
      //   //单位
      //   this.drugUnitList = res.data;
      // });
      // medication_frequency("route_of_administration").then(res => {
      //   //用法
      //   this.administrationList = res.data;
      // });
      standard_list({
        status: false,
        type: 6
      }).then(res => {
        //运动类型
        this.standardList = res.data;
      });
      api_operate_position().then(res => {
        this.checkPrArr = res.data;
      });
      // 部位方位、拍摄方位
      api_part_orientation().then(res => {
        this.partOrientationList = res.data;
      });
      api_shoot_orientation().then(res => {
        this.shootOrientationList = res.data;
      });
    },
    // //新增西药  获取频率接口
    // addPrescriptionObj() {
    //   this.addPrescription = {};
    //   this.prescriptionChose = true;
    // },
    // //列表编辑
    // westernMedicineEdit(index, row) {
    //   if (row.isEdit) {
    //     this.$delete(row, "isEdit");
    //   } else {
    //     this.drugIndex = index;
    //     this.$set(row, "isEdit", true);
    //   }
    // },
    // //列表删除
    // westernMedicineDel(index, row) {
    //   this.$confirm("是否要删除", "确认信息", {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消"
    //   }).then(() => {
    //     this.form.prescription.itemList.splice(index, 1);
    //   });
    // },
    // /**
    //  * @description: 处方中药层方法
    //  * @param {*}
    //  * @return {*}
    //  */
    // addChineseMedicine() {
    //   this.chineseMedicineObj.medicationUnitName = "g";
    //   this.chineseMedicine = true;
    // },
    // //列表编辑
    // chineseMedicineEdit(index, row) {
    //   if (row.isEdit) {
    //     this.$delete(row, "isEdit");
    //   } else {
    //     this.$set(row, "isEdit", true);
    //   }
    // },
    // //列表删除
    // chineseMedicineDel(index, row) {
    //   this.$confirm("是否要删除", "确认信息", {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消"
    //   }).then(() => {
    //     this.form.prescription.itemList.splice(index, 1);
    //   });
    // },
    // //新增中药保存按钮
    // pushChineseMedicine() {
    //   this.form.prescription.itemList.push(this.chineseMedicineObj);
    //   this.chineseMedicineObj = {};
    //   this.chineseMedicine = false;
    // },

    // /**
    //  * @description: 处方运动处方层方法
    //  * @param {*}
    //  * @return {*}
    //  */
    // //运动分类change事件
    // standardChange(e) {
    //   movement_list({
    //     categoryId: e.id,
    //     status: false
    //   }).then(res => {
    //     this.movementList = res.data;
    //   });
    //   this.addCategoryObj.category = e.categoryName;
    //   this.addCategoryObj.sportId = e.id;
    // },
    // //运动项目change事件
    // movementChange(e) {
    //   this.addCategoryObj.drugName = e.name;
    //   this.addCategoryObj.sportCategoryId = e.id;
    // },
    // //新增一条运动处方
    // addSportData() {
    //   this.sportData = true;
    //   this.addCategoryObj = {};
    // },
    // //新增运动处方保存按钮
    // pushCategoryObj() {
    //   this.form.prescription.itemList.push(this.addCategoryObj);
    //   this.sportData = false;
    // },
    // //运动处方列表编辑
    // sportsEdit(index, row) {
    //   if (row.isEdit) {
    //     this.$delete(row, "isEdit");
    //   } else {
    //     this.$set(row, "isEdit", true);
    //     movement_list({
    //       categoryId: row.sportId,
    //       status: true
    //     }).then(res => {
    //       this.movementList = res.data;
    //     });
    //   }
    // },
    // //运动处方列表删除
    // sportsDel(index, row) {
    //   this.$confirm("是否要删除", "确认信息", {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消"
    //   }).then(() => {
    //     this.form.prescription.itemList.splice(index, 1);
    //   });
    // },

    // /**
    //  * @description: 处方治疗处方层方法
    //  * @param {*}
    //  * @return {*}
    //  */
    // //模糊搜索治疗项目
    // treatmentMethod(e) {
    //   treatment_list({
    //     keyword: e
    //   }).then(res => {
    //     this.treatmentList = res.data;
    //   });
    // },
    // //治疗列表编辑
    // treamentEdit(index, row) {
    //   if (row.isEdit) {
    //     this.$delete(row, "isEdit");
    //   } else {
    //     this.$set(row, "isEdit", true);
    //   }
    // },
    // //治疗列表删除
    // treamentDel(index, row) {
    //   this.$confirm("是否要删除", "确认信息", {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消"
    //   }).then(() => {
    //     this.form.prescription.itemList.splice(index, 1);
    //   });
    // },
    // //新增治疗列表
    // addTreatment() {
    //   this.treamentShow = true;
    //   this.treatmentObj = {};
    // },
    // //新增治疗保存按钮
    // pushTreatment() {
    //   this.form.prescription.itemList.push(this.treatmentObj);
    //   this.treamentShow = false;
    // },

    /**
     * @description: el组件无法赋值输入公用方法
     * @param {*}
     * @return {*}
     */
    change(e) {
      this.$forceUpdate();
    },
    //点击返回上一层
    choseFileBackOn() {
      this.choseFillInfo = false;
      this.fillInfo = true;
    },
    //搜索
    searchFrom() {
      this.addFilesList();
    },
    //添加未录入文件到下拉框
    addFilestoArr() {
      this.btnLoading = true;
      let noCheck = [];
      // this.fileObjId = [];
      this.choseFileList.forEach(item => {
        if (item.checkTrue == true) {
          this.fileListArr.push(item);
          this.filePicList.push(item);
          this.fileObjId.push(item.id);
          noCheck.push(item);
        }
      });
      if (!noCheck.length) {
        this.$message.error("请勾选文件后添加");
        this.btnLoading = false;
      } else {
        this.addFilesList();
        this.$message({
          message: "添加成功",
          type: "success"
        });
        this.btnLoading = false;
        this.choseFillInfo = false;
        this.fillInfo = true;
        this.edit = true;
      }
    },
    //重置搜索框以及日期
    resetForm() {
      this.searchTime = "";
      this.searchKey = "";
    },
    //点击添加文件
    addFilesList() {
      this.activeName = "first";
      this.choseFillInfo = true;
      this.fillInfo = false;
      let patientInputGroupIdVal = null;
      if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
        patientInputGroupIdVal = this.$route.query.inputGroupId ? this.$route.query.inputGroupId : this.selectFileObj.inputGroupId;
      }
      api_getOtherFiles({
        itemIds: this.fileObjId,
        patientFilesItemId: this.patientFilesItemId,
        searchKey: this.searchKey,
        start: this.searchTime[0] ? this.searchTime[0] + " " + "00:00:00" : "",
        end: this.searchTime[1] ? this.searchTime[1] + " " + "23:59:59" : "",
        inputGroupId: patientInputGroupIdVal
      }).then(res => {
        res.data.forEach(item => {
          item.checkTrue = false;
        });
        this.choseFileList = res.data;

        this.selectFileObj = this.filePicList[this.filePicList.length - 1]
        this.fileChange(this.selectFileObj)
      });
    },
    //对照录入弹窗文件选择事件
    async fileChange(val,noneed) {
      if (noneed !== 'noneed') {
        // 存储未录入的上次的数据
        let cloneFormData = DEEP_CLONE(this.form)
        this.$store.commit("All_Entry_FormData", cloneFormData);
      }
      // this.rightcountDeg = 0
      // this.selectFileObj = val;
      this.form.patientFilesItem = val;
      this.picName = val.fileName;
      // 有旋转角度的
      if (val.filePath.indexOf("/rotate,") != -1) {
        this.rightcountDeg = Number(val.filePath.split("/rotate,")[1]);
        this.previewPicturesUrl = val.filePath.split("?x-oss-process=image")[0];
      } else {
        this.rightcountDeg = 0;
        this.previewPicturesUrl = val.filePath;
      }
      this.ocrRecognizeUrl = "";
      this.recognizeStatus = 0;
      this.ocrRecognizeResult = [];
      this.textList = [];
      this.showOcrText = true;
      // ocr识别
      // this.getOcrRecognize(val.id);
      this.getOcrText()
      this.getOcrData()
    },
    //修改新增图片文件名字
    updateFimeName() {
      if (!this.picName) {
        this.$message.error("文件名不能为空");
        return false;
      }
      let filePath;
      if (this.form.patientFilesItem.filePath.indexOf("/rotate,") != -1) {
        filePath = this.form.patientFilesItem.filePath.split(",")[0] + "," + this.rightcountDeg;
      } else {
        filePath = this.form.patientFilesItem.filePath + "?x-oss-process=image/rotate," + this.rightcountDeg;
      }
      api_patient_files({
        fileName: this.picName,
        id: this.selectFileObj.id,
        filePath: filePath
      }).then(res => {
        if (res.code == 0) {
          this.$message({message: "修改成功",type: "success"})
          this.selectFileObj.fileName = this.picName
          this.fileNameSelect = true
          // this.selectFileObj.fileName = this.picName
          this.$set(this.selectFileObj, "fileName", this.picName)
          let updateIndex = this.filePicList.findIndex(v => v.id == this.selectFileObj.id)
          this.filePicList.splice(updateIndex, 1, this.selectFileObj)
        }
        // 刷新入录列表左侧
        if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
          this.$parent.handleTabClick()
        }
      })
    },
    //修改新增图片文件名字
    updateAddPicName() {
      if (!this.addPicName) {
        this.$message.error("文件名不能为空")
        return false
      }
      api_patient_files({
        fileName: this.addPicName,
        id: this.lookAddPicObj.id,
        filePath: this.lookAddPicObj.filePath
      }).then(res => {
        if (res.code == 0) {
          this.$message({message: "修改成功", type: "success"})
          this.showLargePic = false
          // 刷新新增图片列表
          this.addFilesList()
        }
      });
    },
    // 取消录入
    async cancelEntery(tag) {
      if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
        this.handleCloseCross(tag);
      }
    },
    // 继续录入
    async continueEntery() {
      let res = await lockInGroupFile(this.$route.query.inputGroupId || this.selectFileObj.inputGroupId);
      if (res.code == 0) {
        this.enteryTipStatus = false;
      } else {
        this.$message.error(res.msg);
        if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
          this.$router.back();
        } else {
          this.$emit("clickClose");
        }
      }
    },
    /**
     * @description: 对照录入保存表单
     * @param {*}
     * @return {*}
     */
    preservationForm() {
      if (!this.selectArchivesEvent.id) {
        this.$message.error("请选择病程");
        return;
      }
      if (!this.form.type) {
        this.$message.error("请选择记录类型");
        return;
      }
      if (this.showNewCourse) {
        this.$message.error("请先保存病程");
        return;
      }
      if (this.form.inspectionTable.length && !this.form.specimenType) {
        this.$message.error("请选择标本类型")
        return
      }
      this.form.standardTable = this.form.standardTable.map(item => {
        if ((item.dataType == '字符串' || item.dataType == '富文本') && typeof item.inputValue == 'string' && item.inputValue.match(/^[ ]*$/)) {
          item.inputValue = item.inputValue.replace(/\s+/g, '')
        }
        return {
          ...item
        }
      })

      // let isPassStandard = this.form.standardTable.filter(v => v.isEdit)
      // if (isPassStandard.length) {
      //   this.$message.error("请保存标准字段表格数据");
      //   return;
      // }

      // let isPassInspect = this.form.inspectionTable.filter(v => v.isEdit)
      // if (isPassInspect.length) {
      //   this.$message.error("请保存检验表格数据");
      //   return;
      // }

      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // let names = this.form.inspectionTable.map(item => item["name"]);
          // let nameSet = new Set(names);
          
          // if (nameSet.size == names.length) {
          //   // console.log("没有重复值");
          // } else {
          //   // console.log("有重复值");
          //   this.$message.error("检验项目不可重复");
          //   return;
          // }

          // 保存新增的检验项目或者检验单位
          for (const row of this.form.inspectionTable) {
            row.specimenType = this.form.specimenType
            // 数据库里没有检验项目，手动新增的数据，需要保存(addItem为true)，保存检验项目和单位
            if (row.addItem) {
              // let res = await saveInspectRow({
              //   type: 1,
              //   name: row.name,
              //   doseUnit: row.doseUnit,
              //   imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
              //   exceptionRecord: row.exceptionRecord,
              //   inputValue: row.inputValue,
              //   sourceType: 1
              // });
              // if (res.code == 0) {
              //   row.id = res.data.id;
              //   row.addItem = false;
              // }
            } else {
              // 数据库里没有单位，需要保存
              if (row.addUnit && row.doseUnit) {
                let res = await saveInspectRow({
                  type: 2,
                  name: row.name,
                  doseUnit: row.doseUnit,
                  imageUrls: this.imgOss + this.previewPicturesUrl, //this.imgOss + this.previewPicturesUrl
                  exceptionRecord: row.exceptionRecord,
                  inputValue: row.inputValue,
                  sourceType: 1
                });
                if (res.code == 0) {
                  // row.id = res.data.id
                  row.addUnit = false;
                }
              }
            }
          }

          if (!this.typeFlag) return;
          this.typeFlag = false;

          // this.form.fileItemList = this.form.fileList.filter(v => v.disabled == false);

          // if (this.form.fileItemList.length == 0) {
          //   this.form.fileItemList = [this.form.fileList[0]];
          // }
          // this.form.clinicalEvents = 1;
          let patientInputGroupIdVal = null;
          let clinicalEvents = 0
          // 诊疗事件不加锁
          if (this.routeEntry == 5 || this.routeEntry == 7) {
            clinicalEvents = 1
          } else {
            if (this.$route.query.inputGroupId || this.selectFileObj.inputGroupId) {
              patientInputGroupIdVal = this.$route.query.inputGroupId ? this.$route.query.inputGroupId : this.selectFileObj.inputGroupId;
            }
          }
          // console.log('this.originalEntryInfo:',this.originalEntryInfo);
          let standardTableClone = DEEP_CLONE(this.form.standardTable)
          standardTableClone.forEach(v => {
            if (v.inputValue instanceof Array) {
              v.inputValue = v.inputValue.join(',')
            }
            if (v.inputValue === true) {
              v.inputValue = '是'
            }
            if (v.inputValue === false) {
              v.inputValue = '否'
            }
            delete v.selectDataList
            delete v.standardFieldIdObj
          })
          saveCrossEntry({
            clinicalEvents: clinicalEvents,
            type: this.form.type,
            patientInputGroupId: patientInputGroupIdVal,
            ocrJsonDTO: {
              prescription: this.form.prescription,
              ocrBasicInfoDTOS: standardTableClone,
              ocrInspectDTOS: this.form.inspectionTable
            },
            archivesEventId: this.selectArchivesEvent.id,
            fileItemList: this.form.fileList,
            eventName: this.selectArchivesEvent.eventName,
            patientRelativeId: this.form.itemBelong == 1 ? null : this.kinsFolkForm.id,
            // // 修改的情况
            // 查询返回的id
            id: this.form.id,
            // 老的archivesEventId
            oldArchivesEventId: this.originalEntryInfo.archivesEventId,
            // 新的（记录类型相同，取返回的refId；类型不同，为空）
            // 有图片的时候切换type也要传入this.form.refId
            eventMedicalId: this.originalEntryInfo.type == this.form.type ? this.form.refId : (this.previewPicturesUrl ? this.form.refId : null),
            patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
            reportName: this.form.reportName,
            specimenType: this.form.specimenType,
          })
            .then(res => {
              this.typeFlag = true;
              if (res.code == 0) {
                if (clinicalEvents == 0) {
                  // 保存后记录保存id、archivesEventId、originalEntryInfo
                  this.form.id = res.data.id
                  // this.form.archivesEventId = res.data.archivesEventId
                  this.originalEntryInfo.archivesEventId = res.data.archivesEventId
                  this.form.type = res.data.type
                  this.originalEntryInfo.type = res.data.type
                  this.form.refId = res.data.refId
                  this.filePicList = res.data.fileList
                }

                // 保存后刷新文件下拉列表名称
                // this.filePicList.forEach(v => {
                //   v.fileName = this.form.reportName
                // })


                if (this.routeEntry == 5 || this.routeEntry == 7 || this.routeEntry == 6) {
                  // 关闭弹框
                  this.$emit("clickClose")
                  // 刷新病人管理诊疗事件
                  this.$emit("getArchivesEvent")
                }
                // this.crossReferenceEntry = false
                this.editBack = false;
                // 表格置为查看状态
                
                // this.form.standardTable = this.form.standardTable.map(item => {
                //   return {
                //     ...item,
                //     inputValue: JSON.stringify(item.inputValue).indexOf('\n') ? item.inputValue.replace(/\n/g, '<br/>') : item.inputValue
                //   }
                // })
                this.form.standardTable.forEach(v => {
                  if ((v.dataType == '字符串' || v.dataType == '富文本')) {
                    v.inputValue = JSON.stringify(v.inputValue).indexOf('\n') ? v.inputValue.replace(/\n/g, '<br/>') : v.inputValue
                  }
                  this.$set(v,'isEdit',false)
                })
                this.allInspectTableData = this.form.inspectionTable
                this.form.inspectionTable.forEach(v => {
                  this.$set(v,'isEdit',false)
                })
                if (this.form.prescription.itemList) {
                  this.form.prescription.itemList.forEach(v => {
                    this.$set(v,'isEdit',false)
                  })
                }
                this.patientFilesId = res.data.id;
                // clearInterval(this.ocrtimer);
                // clearInterval(this.preOcrtimer);
                // 清除定时器
                this.ocrTextCount = 0
                clearInterval(this.ocrTextTimer)
                this.ocrTextTimer = ""
                this.ocrTableCount = 0
                clearInterval(this.ocrTableTimer)
                this.ocrTableTimer = ""

                clearInterval(this.ocrtimer);
                this.ocrtimer = "";
                this.count = 0;
                this.ocrFlag = false;

                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                // 入录详情列表刷新
                if (this.$route.query.enterType == 1 || this.$route.query.enterType == 2) {
                  this.$parent.handleTabClick();
                }
                // 疗程管理--对照录入列表刷新
                if (this.routeEntry == 3) {
                  // 刷新病历夹列表
                  this.$emit("searchFolder")
                }


                // 异常指标提示(保存后触发)
                // let tips = 此患者异常数据已推送至XXX，是否重复推送？
                if(res.data.haveAnomalyIndex == 0){
                  
                }else if(res.data.haveAnomalyIndex == 1){                  
                  this.$confirm('当前录入数据内，监测到患者异常数据，是否推送？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    customClass: 'message-confirm'
                  }).then(async () => {
                    let res = await push({
                      patientFilesId: this.form.id,
                      patientFilesItemId: this.patientFilesItemId,
                    })
                    if (res.code === 0) {
                      this.$message.success('推送成功')
                    }
                  }).catch(async(err) => {
                    // console.log('取消推送')
                    let res = await noPushOcrAnomaly({
                      patientFilesId: this.form.id,
                      patientFilesItemId: this.patientFilesItemId,
                    })
                    if (res.code === 0) {}
                  })
                }else if(res.data.haveAnomalyIndex == 2){
                  this.$confirm('此患者异常数据已推送，是否重复推送？', '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    customClass: 'message-confirm'
                  }).then(async () => {
                    let res = await push({
                      patientFilesId: this.form.id,
                      patientFilesItemId: this.patientFilesItemId,
                    })
                    if (res.code === 0) {
                      this.$message.success('推送成功')
                    }
                  })
                }


                
              } else {
                this.$message.error(res.message);
                this.loading = false;
              }
            })
            .catch(e => {
              this.typeFlag = true;
              this.loading = false;
            });
        } else {
          this.$message.error("请填写必填项");

          // 校验不通过自动定位到不通过的表单项
          this.moveToErr()
          return false
        }
      });
    },

    // 自动定位到表单报错项
    moveToErr() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName('is-error')
        console.log(isError)
        console.log(isError.length)
        if (isError.length) {
          isError[0].scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          })
        // // 这个当滑动到报错项之后自动获取输入框的焦点，方便用户直接进行输入，延迟 800ms 是因为需要都能到定位成功后在进行获取焦点体验更好一些
        //         setTimeout(() => {
        //           if (isError[0].previousElementSibling.querySelector('input')) {
        //             isError[0].previousElementSibling.querySelector('input').focus()
        //           }
        //         }, 800)
        }
      })
    }
  }
};
</script>
<style scoped lang="less">
// /deep/.el-form-item {
//   margin-bottom: 0;
// }
// .inspection-table,.standard-table {
//   /deep/.el-form-item {
//     margin-bottom: 0;
//   }
// }
/deep/.el-table td {
  padding-bottom: 4px;
  padding-top: 4px;
}
/deep/.el-table .el-form-item {
  margin-bottom: 0 !important;
}
/deep/.el-form-item__error {
  padding-top: 0;
  position: unset;
  text-align: left;
}
.select-inspect-item {
  .inspect-item-type {
    width: 30px;
    height: 16px;
    background: #1A7BFC;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 16px;
    display: inline-block;
    text-align:center;
    margin-right:6px;
  }
  .inspect-item-name {
    font-size: 14px;
    color: #000000;
  }
}
.del-file-btn {
  padding: 7px;
  background: #ffffff;
  border-radius: 50%;
  color: #000000;
  display: inline-block;
  margin-right: 10px;
}
.standard-table {
  /deep/.el-table__expanded-cell {
    padding-right: 10px;
  }
}
.table-cell-style {
  display: flex;
  justify-content: center;
}
.disease-record-row {
  display: flex;
  align-items: center;
  /deep/.el-form-item {
    margin-bottom: 0;
  }
}
.disease-record-card {
  width: 100%;
  border: 2px solid #1A7BFC;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .record-time {
    font-size: 16px;
    font-weight: 600;
  }
  .depart-hos {
    // display: flex;
    margin:0 40px;
  }
}
.record-type-radio {
  margin-top:30px;
  /deep/.el-form-item__label {
    line-height: unset;
  }
  /deep/.el-form-item__content {
    line-height: unset;
    padding-top: 3px;
  }
  /deep/.el-radio {
    margin-bottom:15px;
  }
}
.drug-entry-wrapper {
  /deep/.el-select {
    width: 100%;
  }
}
.inputValue-overdot {
  display: inline-block;
  width: 180px;
	overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
// .overdot-hospital {
//   display: inline-block;
//   width: 96px;
// 	overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }
// .overdot-depart {
//   display: inline-block;
//   width: 80px;
// 	overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
//   margin-left:10px;
// }
// .overdot-disease {
//   width: 100%;
// 	overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;
// }
.fold-btn {
  // margin-top:30px;
  font-size: 12px;
  font-weight: 500;
  color: #1A7BFC;
  cursor: pointer;
}
.drug-title-wrapper {
  display: flex;
  justify-content: space-between;
}
.drug-table {
  /deep/.el-table {
    /deep/.el-form-item {
      margin-bottom: 0;
    }
  }
}
.important-tag {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: rgba(26,123,252,0.1);
  border-radius: 10px;
  border: 1px solid rgba(26,123,252,0.2);
  color: #1A7BFC;
  line-height: 18px;
}
.no-important-tag {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: rgba(255,90,37,0.1);
  border-radius: 10px;
  border: 1px solid rgba(255,90,37,0.2);
  color: #FF5A25;
  line-height: 18px;
}
.update-add-imgName {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  span {
    display: inline-block;
    width: 120px;
    text-align: right;
    margin-right: 20px;
  }
  span::before {
    content: "*";
    display: inline-block;
    // width: 4px;
    // height: 15px;
    color: red;
    // margin-right: 15px;
    // margin-top: 2.5px;
  }
  .el-button {
    margin-left: 20px;
  }
}
.dialog-carousel-content {
  /deep/.el-carousel__container {
    height: 500px;
  }
}
// .event-list-scrollbar {
//   /deep/.el-scrollbar__wrap {
//     overflow-x: scroll !important;
//     background: #f8f8f8;
//   }
//   // .el-scrollbar__bar.is-horizontal {
//   //   height: 6px !important;
//   // }
// }
// .course-disease-time {
//   margin-bottom: 20px;
//   /deep/.el-date-editor .el-range-separator {
//     width: 30px;
//   }
// }
.add-item {
  width: 100%;
  background-color: #fcfcfc;
  border: 1px dashed #d9d9d9;
  color: #333333;
  margin-top: 20px;
}
// .event-list-wrapper {
//   display: flex;
//   padding: 20px;
//   background: #f8f8f8;
//   .select-event {
//     // width: 208px;
//     // height: 78px;
//     background: #FFFFFF;
//     border-radius: 8px;
//     border: 1px solid #1A7BFC;
//   }
//   .event-list {
//     padding: 78px 0;
//     position: relative;
//     .event-detail-top {
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 208px;
//       padding: 10px;
//       z-index: 2;
//     }
//     .event-detail-bottom {
//       position: absolute;
//       bottom: 0;
//       left: 0;
//       width: 208px;
//       padding: 10px;
//       z-index: 1;
//     }
//     .single-line-wrapper {
//       display: flex;
//       align-items: center;
//       .single-dot {
//         display: inline-block;
//         width: 10px;
//         height: 10px;
//         background: #1a7bfc;
//         // border: 4px solid #F8F8F8;
//         border-radius: 50%;
//         margin: 0 4px;
//       }
//       .single-line {
//         display: inline-block;
//         width: 90px;
//         height: 1px;
//         background: #d8d8d8;
//         border: 1px solid #999999;
//       }
//     }
//   }
// }
// .publicDialog {
/deep/.el-dialog__wrapper {
  // position:relative;
  overflow: hidden;
}
.kins-folk-info {
  position: absolute;
  top: 45px;
  left: 0px;
  z-index: 3;
  /deep/.el-form-item {
    margin-bottom: 20px !important;
  }
}
.invalid-btn,
.recover-btn {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  box-sizing: border-box;

  font-size: 12px;
  font-weight: 600;
  margin-left: 20px;
  cursor: pointer;
  img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
.invalid-btn {
  width: 92px;
  height: 30px;
  background: #ffffff;
  border-radius: 15px;
  color: #000000;
}
.recover-btn {
  width: 92px;
  height: 30px;
  background: #197afb;
  border-radius: 15px;
  color: #ffffff;
}
.content {
  // height: calc(80vh - 30px);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .left-content {
    width: 54%;
    // flex:1;
    height: 100%;
    padding-bottom: 20px;
  }
  .right-content {
    width: 44%;
    // flex:1;
    height: 100%;
    background: rgba(#333, 0.5);
    padding: 30px 0px;
    position: relative;
    .pdfFiled {
      width: 95%;
      height: 100%;
      margin: 0 auto;
      .pdfContent {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .imgFiled {
        // width: 95%;
        // height: 100%;
        // margin:0 auto;
        // position: relative;
        height: calc(100% - 130px);
      }
      .preview-img {
        width: 500px;
        height: 500px;
        position: fixed;
        top: 20vh;
        right: 10%;
        z-index: 33;
      }
    }
  }
}
.pic-option-row {
  margin-top: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.edit-pic-btn {
  font-size: 26px;
  color: #fff;
  margin-right: 40px;
  cursor: pointer;
}
.folder-wrapper {
  width: 100%;
  height: 50px;
  background: #d9d9d9;

  font-size: 12px;
  color: #333333;
  // text-align: right;
  padding: 0 5px;
  line-height: 50px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.ocr-text-wrapper {
  position: absolute; /*定位*/
  top: 220px;
  left: 76%;
  z-index: 66;
  // height: calc(100% - 400px);
  // max-height: 500px;
  width: 23%;
  margin-left: 4px;

  // padding: 15px;
  // border: transparent 10px solid;
  box-sizing: border-box;
}
.ocr-text {
  // flex:1;
  // height:500px;
  background-color: #fafafa;
  // max-height: 500px;
  // padding: 16px 20px;
  color: #333333;
  font-size: 12px;
  height: 480px;
}
// }
/deep/.el-dialog__header {
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    width: 4px;
    height: 15px;
    background: #1a7bfc;
    margin-right: 12px;
  }
  h1,.disease-record {
    font-size: 14px;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }
}
/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}
/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}
/deep/.el-table th {
  background: #fafafa;
}
.addDrug {
  // margin-top: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  text-align: center;
  line-height: 32px;
  border: 1px dashed #d9d9d9;
  &:hover {
    border: 1px dashed #1a7bfc;
    color: #1a7bfc;
  }
}
.updataBtn {
  text-align: center;
  padding-top: 20px;
}
.exact-recognize {
  .title {
    display: block;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
  }
  padding: 10px 15px;
  // border: 1px solid #D9D9D9;
}
/deep/.el-carousel {
  height: 100%;
}
/deep/.el-carousel__container {
  // height: 60vh;
  height: 100%;
}
.move-position {
  position: relative; /*定位*/
  top: 20px;
  left: 0px;
  z-index: 66;
}
h3 {
  font-size: 13px;
  font-weight: 600;
  color: #1a7bfc;
  margin-bottom: 20px;
  padding-left: 16px;
}
.swap-ocr {
  display: flex;
  align-items: center;
  width: 88px;
  cursor: pointer;
  // height: 28px;
  padding: 6px;
  background: #ffffff;
  // padding-top:6px;
  // line-height: 28px;
  text-align: center;
  border-radius: 18px 0px 0px 18px;
  position: absolute;
  right: 0;
  bottom: 30%;
  z-index: 64;
  font-size: 12px;
}
/deep/.el-dialog {
  height: unset !important;
}
.entry-time-tips {
  text-align: center;
  font-size: 16px;
  color: #383838;
  line-height: 22px;
}
/deep/.el-dialog__footer {
  text-align: center;
}
// .public-content-Dialog {
//   /deep/.el-autocomplete {
//     width: 48%;
//   }
// }
</style>
<style lang="less">
.public-content-Dialog {
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__item {
    font-size: 14px;
    // color: #333333;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}
// .kins-pop {
//   padding: 20px;
//   .el-popover__title {
//     text-align: center;
//   }
// }
// .inputValue-tool-tip {
//   max-width: 600px;
// }
</style>